/* eslint-disable */
/* tslint:disable */

/**
 * 이 파일은 toolkit/generate-api 에 의해 자동으로 생성됩니다.
 *
 * - ACLOSET_ENV : qa
 * - 생성일 : 2025. 7. 25. 오후 2:56:21
 */

// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export interface DomainABTestModel {
  /** json tag name은 amplitude에 저장되는 값이라 convention과 맞지 않음 */
  name?: DomainSearchPolicyName;
  updatedAt?: string;
}

export interface DomainAcceptRefundSellerRequest {
  orderItemIDs: number[];
}

export interface DomainAcceptReturnProSellerRequest {
  orderItemIDs: number[];
}

export interface DomainAclosetReviewRating {
  /** 등급 */
  grade?: string;
  /** 리뷰 평균 점수 (5점 만점에 소수점 있음) */
  rating?: number;
  /** 상위 5%의 점수 */
  top5Rating?: number;
}

export interface DomainAddressInfoProSeller {
  /** 상세주소 */
  additionalAddress: string;
  /** 주소 */
  address: string;
  name: string;
  /** 우편번호 */
  zoneCode: string;
}

export interface DomainAdminItem {
  adminID?: number;
  memo?: string;
  permissions?: DomainAdminItemPermission[];
  roles?: string[];
  username?: string;
}

export interface DomainAdminItemPermission {
  description?: string;
  id?: number;
  name?: string;
}

export interface DomainAmplitudeAnalyticResponse {
  /**
   * 이벤트 이름
   * @example "앱내알림_옷 등록 알림 tap"
   */
  name: DomainSearchPolicyName;
  /** 이벤트 파라미터 */
  params?: Record<string, string>;
}

export interface DomainApplyUserStoreCouponRequest {
  /** 다운받은 매장 쿠폰 ID */
  userStoreCouponID: number;
}

export interface DomainBackofficeAcceptDisputeOrderRequest {
  /** @example [1] */
  orderItemIDs: number[];
  /** @example "BUYER" */
  reasonType: DomainOrderDisputeReasonType;
}

export interface DomainBackofficeAdminSetPermission {
  permissionIDs?: number[];
}

export interface DomainBackofficeApproveMarketItemReviewsRequest {
  reviewIDs: number[];
}

export interface DomainBackofficeCommunityPostReportResponse {
  /**
   * 신고 일시
   * @example "2024-04-05T04:24:25.966Z"
   */
  createdAt?: string;
  /**
   * 신고 사유
   * @example "내용이 별로임"
   */
  reason?: string;
  /**
   * 신고 ID
   * @example 99
   */
  reportID?: number;
  /** 신고한 사용자 정보 */
  user?: DomainCommunityUserResponse;
}

export interface DomainBackofficeCommunityPostResponse {
  /**
   * 게시판 종류
   * @example "VINTAGE_SHOP_RECOMMENDATION"
   */
  board?: DomainCommunityBoard;
  /**
   * 게시글 작성일시
   * @example "2024-04-05T04:24:25.966Z"
   */
  createdAt?: string;
  /**
   * 게시글 ID
   * @example 100
   */
  postID?: number;
  /**
   * 신고 수
   * @example 3
   */
  reportCount?: number;
  /**
   * 게시글 제목
   * @example "Test Title"
   */
  title?: string;
  /** 게시글을 작성한 사용자 정보 */
  user?: DomainCommunityUserResponse;
}

export interface DomainBackofficeCountMarketItemReviewsResponse {
  approvedReviewCount: number;
  pendingReviewCount: number;
  rejectedReviewCount: number;
}

export interface DomainBackofficeCreateAdminRequest {
  memo: string;
  password: string;
  permissionIDs: number[];
  username: string;
}

export interface DomainBackofficeCreatePresignedUrlRequest {
  /** 상위 prefix입니다. d1으로 시작할 경우 하루 뒤에 만료됩니다. */
  category?: string;
  /** 파일의 mime type입니다. */
  contentType?: string;
}

export type DomainBackofficeDeleteAdminRequest = object;

export interface DomainBackofficeDeleteMarketItemRequest {
  userID?: number;
}

export interface DomainBackofficeDisputeOrderRequest {
  /** @example [1] */
  orderItemIDs: number[];
}

export interface DomainBackofficeDownloadSettlementsXlsxRequest {
  settlementIDs?: number[];
}

export interface DomainBackofficeGetMarketItemEditableResponse {
  editable: boolean;
  message?: string;
}

export interface DomainBackofficeGetMarketItemResponse {
  /**
   * 해당 중고 물품에 북마크 한 수
   * @example 1
   */
  bookmarkCount: number;
  bottomTotalLength?: number;
  bottomWaist?: number;
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /** @example 1 */
  brandTagID: number;
  /**
   * 중고 아이템 구매자 유저 ID
   * @example 22612346
   */
  buyerID?: number;
  categoryID?: number;
  /** @example 2626123 */
  clothesID?: number;
  /**
   * 중고 아이템 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 중고 아이템 생성일
   * @example 1668080178342
   */
  createDate: number;
  /**
   * TODO: 아래필드는 삭제 예정 (4.4.0) <-- 진짜 삭제하는지 확인
   * @example "KRW"
   */
  currency: string;
  cursor?: string;
  /**
   * 중고 아이템 설명
   * @example "사실 2년 입었어유"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  /** @example "MARKET-ITEM_FABRIC_COTTON" */
  fabric: string;
  fabrics: string[];
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  genderWear?: string;
  images?: string[];
  /** @example false */
  isBookmarked: boolean;
  /**
   * 중고 아이템 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /**
   * 프로셀러 여부
   * @example true
   */
  isProSeller: boolean;
  /** 비슷한 상품 여부 */
  isSimilar?: boolean;
  /**
   * 지점명 노출 여부
   * @example true
   */
  isVisible: boolean;
  /**
   * Looko AI 상품 코드
   * @example "1234567890"
   */
  itemCode: string;
  /**
   * 중고 아이템 검색 키워드
   * @example ["흰색","티셔츠","남성"]
   */
  keywords: string[];
  logixID: number;
  /**
   * 공급사명(지점명)
   * @example "공급사 없음"
   */
  logixName: string;
  logixPolicy: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 조회수
   * @example 1
   */
  marketItemView?: number;
  /**
   * 중고 아이템 수정일
   * @example 1668080178342
   */
  modifyDate: number;
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  /**
   * 중고 아이템의 상태 (깨끗함, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  score: number;
  shoeSize?: number;
  /**
   * 중고 옷 사이즈
   * @example "FREE"
   */
  size: string;
  sizeForDisplay?: DomainSizeForDisplay;
  /** 중고 아이템 판매 상태 */
  status: DomainMarketItemStatus;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
  /**
   * 중고 아이템 제목
   * @example "새것 같은 노스페이스 패딩 팔아유"
   */
  title: string;
  topChest?: number;
  topShoulder?: number;
  topSleeveLength?: number;
  topTotalLength?: number;
  userEmail?: string;
  /**
   * 중고 아이템 판매자 유저 ID
   * @example 22612346
   */
  userID: number;
  userNickname?: string;
  userPhone?: string;
  /** Deprecated: 6.7.0 이후 삭제 와우 할인가 */
  wowDiscountAmount?: number;
}

export interface DomainBackofficeGetUserResponse {
  clothesCount?: number;
  dailylookCount?: number;
  deleteDate?: number;
  ideaCount?: number;
  marketItemCount?: number;
  recent3MAccessCount?: number;
  recent9MAccessCount?: number;
  recentAccessDate?: number;
  signUpDate?: number;
  user?: DomainUserItem;
}

export interface DomainBackofficeListAdminsResponse {
  adminItems?: DomainAdminItem[];
  hasNext?: boolean;
}

export interface DomainBackofficeListCommunityPostReportsResponse {
  reports?: DomainBackofficeCommunityPostReportResponse[];
}

export interface DomainBackofficeListCommunityPostsResponse {
  pagination?: DomainPaginationResponse;
  posts?: DomainBackofficeCommunityPostResponse[];
}

export interface DomainBackofficeListContactsResponse {
  contacts?: DomainContactItem[];
  hasNext?: boolean;
}

export interface DomainBackofficeListMarketItemReviewsResponse {
  pagination?: DomainPaginationResponse;
  reviews?: DomainBackofficeMarketItemReviewResponse[];
}

export interface DomainBackofficeListMarketItemsResponse {
  hasNext?: boolean;
  marketItems?: DomainBackofficeMarketItem[];
}

export interface DomainBackofficeListOrdersResponse {
  /** @example true */
  hasNext: boolean;
  orders?: DomainOrderItemForBackofficeDTO[];
}

export interface DomainBackofficeListPromotionInfosResponse {
  nextCursor: number;
  promotionInfos: DomainPromotionInfoDTO[];
}

export interface DomainBackofficeListReportsResponse {
  hasNext?: boolean;
  reports?: DomainReportItem[];
}

export interface DomainBackofficeListSettlementsResponse {
  hasNext?: boolean;
  settlementItems?: DomainSettlementResponse[];
}

export interface DomainBackofficeListSettlementsXlsxTotalRequest {
  createDateEnd?: number;
  createDateStart?: number;
  /** @example true */
  isProSeller?: boolean;
  searchTimestamp?: number;
}

export interface DomainBackofficeListTxsResponse {
  /** @example true */
  hasNext: boolean;
  txs?: DomainOrderItemListDto[];
}

export interface DomainBackofficeListUsersResponse {
  hasNext?: boolean;
  userItems?: DomainUserItem[];
}

export interface DomainBackofficeMarketItem {
  /**
   * 해당 중고 물품에 북마크 한 수
   * @example 1
   */
  bookmarkCount: number;
  bottomTotalLength?: number;
  bottomWaist?: number;
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /** @example 1 */
  brandTagID: number;
  /**
   * 중고 아이템 구매자 유저 ID
   * @example 22612346
   */
  buyerID?: number;
  categoryID?: number;
  /** @example 2626123 */
  clothesID?: number;
  /**
   * 중고 아이템 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 중고 아이템 생성일
   * @example 1668080178342
   */
  createDate: number;
  /**
   * TODO: 아래필드는 삭제 예정 (4.4.0) <-- 진짜 삭제하는지 확인
   * @example "KRW"
   */
  currency: string;
  cursor?: string;
  /**
   * 중고 아이템 설명
   * @example "사실 2년 입었어유"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  /** @example "MARKET-ITEM_FABRIC_COTTON" */
  fabric: string;
  fabrics: string[];
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  genderWear?: string;
  images?: string[];
  /** @example false */
  isBookmarked: boolean;
  /**
   * 중고 아이템 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /**
   * 프로셀러 여부
   * @example true
   */
  isProSeller: boolean;
  /** 비슷한 상품 여부 */
  isSimilar?: boolean;
  /**
   * 지점명 노출 여부
   * @example true
   */
  isVisible: boolean;
  /**
   * Looko AI 상품 코드
   * @example "1234567890"
   */
  itemCode: string;
  /**
   * 중고 아이템 검색 키워드
   * @example ["흰색","티셔츠","남성"]
   */
  keywords: string[];
  logixID: number;
  /**
   * 공급사명(지점명)
   * @example "공급사 없음"
   */
  logixName: string;
  logixPolicy: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 조회수
   * @example 1
   */
  marketItemView?: number;
  /**
   * 중고 아이템 수정일
   * @example 1668080178342
   */
  modifyDate: number;
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  /**
   * 중고 아이템의 상태 (깨끗함, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  score: number;
  shoeSize?: number;
  /**
   * 중고 옷 사이즈
   * @example "FREE"
   */
  size: string;
  sizeForDisplay?: DomainSizeForDisplay;
  /** 중고 아이템 판매 상태 */
  status: DomainMarketItemStatus;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
  /**
   * 중고 아이템 제목
   * @example "새것 같은 노스페이스 패딩 팔아유"
   */
  title: string;
  topChest?: number;
  topShoulder?: number;
  topSleeveLength?: number;
  topTotalLength?: number;
  userEmail?: string;
  /**
   * 중고 아이템 판매자 유저 ID
   * @example 22612346
   */
  userID: number;
  userNickname?: string;
  userPhone?: string;
  /** Deprecated: 6.7.0 이후 삭제 와우 할인가 */
  wowDiscountAmount?: number;
}

export interface DomainBackofficeMarketItemReviewResponse {
  /**
   * 리뷰 내용
   * @example "1시간 늦게 나왔네요"
   */
  comment: string;
  /**
   * 리뷰 생성일시
   * @example 1668080178342
   */
  createDate: number;
  /** 리뷰 이미지 */
  images: DomainMarketItemReviewImageResponse[];
  /** 상품 썸네일 snapshot */
  marketItemThumbnail: string;
  /** 상품 이름 snapshot */
  marketItemTitle: string;
  /** @example "ONLINE" */
  paymentType: 'ONLINE' | 'STORE';
  /**
   * 리뷰 평점
   * @example 0.5
   */
  rating: number;
  reviewID: number;
  /** 컨디션 태그 */
  reviewTags: DomainMarketItemReviewTag[];
  /**
   * 리뷰의 타입 (BUYING: 구매자가 작성한 리뷰, SELLING: 판매자가 작성한 리뷰)
   * @example "MARKET-ITEM_REVIEW-TYPE_SELLING"
   */
  reviewType: 'MARKET-ITEM_REVIEW-TYPE_SELLING' | 'MARKET-ITEM_REVIEW-TYPE_BUYING';
  reviewerNickname: string;
  sizeTags: DomainMarketItemReviewSizeTag[];
  /**
   * 리뷰 상태
   * @example "MARKET-ITEM-REVIEW_INSPECTION_REJECTED"
   */
  status:
    | 'MARKET-ITEM-REVIEW_INSPECTION_PENDING'
    | 'MARKET-ITEM-REVIEW_INSPECTION_APPROVED'
    | 'MARKET-ITEM-REVIEW_INSPECTION_REJECTED';
  /** 컬러 태그 */
  treasureTags: DomainMarketItemReviewTreasureTag[];
}

export interface DomainBackofficeOrderSummaryResponse {
  /** 쿠폰 할인 */
  couponDisCountPrice?: number;
  /** 가격 제안 여부 */
  isPriceOffered?: boolean;
  /** 배송비 */
  logixPrice?: number;
  /** 포인트 할인 */
  pointDisCountPrice?: number;
  /** 해당 상품주문이 속한 주문의 모든 상품금액의 합 표기 */
  totalMarketItemPrice?: number;
  /** 총 상품 판매가 */
  totalMarketItemSalePrice?: number;
  /** 총 가격 제안 금액 */
  totalOfferPrice?: number;
  /** 총 주문금액 = 주문에 속한 모든 상품금액의 총합 + 배송비 = 결제금액 + 쿠폰금액 */
  totalPrice?: number;
}

export interface DomainBackofficePatchContactRequest {
  answerStatus?:
    | 'CONTACT_ANSWER_RESPONSE-COMPLETE'
    | 'CONTACT_ANSWER_RESPONSE-DENIED'
    | 'CONTACT_ANSWER_AWAITING-RESPONSE';
}

export interface DomainBackofficePatchPortoneCIRequest {
  productUploadBlocked?: boolean;
}

export interface DomainBackofficePatchSettlementsRequest {
  /** 정산일 수정 */
  endDate?: string;
  /** 정산 아이디 목록 */
  settlementIDs?: number[];
  /** 정산 상태 수정 */
  status?:
    | 'SETTLEMENT_STATUS_UNAUDITED'
    | 'SETTLEMENT_STATUS_SCHEDULED'
    | 'SETTLEMENT_STATUS_COMPLETED'
    | 'SETTLEMENT_STATUS_HOLD';
}

export interface DomainBackofficeProsellerResponse {
  /**
   * 배경 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  backgroundImageURL?: string;
  /** 상점 소개 */
  bio?: string;
  /** 상품수가 많은 브랜드 3개 */
  brandTop3?: string[];
  /** 상점 이미지 */
  images?: string[];
  /** 조회한 유저 기준 팔로우 여부 */
  isFollowing?: boolean;
  /** 상점 노출 여부 */
  isVisibleProSeller?: boolean;
  /** 가장 최근 할인 날짜 */
  lastDiscountPriceModifyDate?: string;
  /** 해당 프로셀러의 상품 수 */
  marketItemCount?: number;
  /** 샵의 대표 아이템 */
  marketItems?: DomainProSellerMarketItemResponse[];
  /** 최대 할인율 */
  maximumDiscountRate?: number;
  nickname?: string;
  /** 프로셀러로 등록된 날짜 */
  officiallyEnteredDate?: string;
  /** 임시 서비스, 프로셀러가 최대 200명 내외 */
  proSellerInterviewImages?: string[];
  /** Deprecated: 프로필 이미지 */
  profileImage?: string;
  /** 프로필 이미지 URL */
  profileImageURL?: string;
  /** 상점 키워드 */
  prosellerKeywords?: string[];
  /** 판매중인 아이템 수 (DiscountPriceModifyDateStart, End 에 따라 값이 달라짐. 안 넣으면 전체) */
  remainingMarketItemCount?: number;
  /** 셀러 알림 여부 */
  sellerNotificationAgreed?: boolean;
  /** 아이템 총 갯수 (DiscountPriceModifyDateStart, End 에 따라 값이 달라짐. 안 넣으면 전체) */
  totalMarketItemCount?: number;
  userID?: number;
}

export type DomainBackofficeRefreshTokenRequest = object;

export interface DomainBackofficeRejectDisputeOrderRequest {
  /** @example [1] */
  orderItemIDs: number[];
}

export interface DomainBackofficeRejectMarketItemReviewsRequest {
  reviewIDs: number[];
}

export interface DomainBackofficeSearchProsellerResponse {
  hasNext?: boolean;
  proSellerUserItems?: DomainBackofficeProsellerResponse[];
}

export interface DomainBackofficeSignInRequest {
  password: string;
  username: string;
}

export interface DomainBackofficeSignInResponse {
  access_token?: string;
}

export interface DomainBanUserRequest {
  bannedUserID: number;
}

export interface DomainBankAccountVerificationRequest {
  /** 판매자 예금주명 */
  accountHolder: string;
  /** 판매자 계좌번호 */
  accountNumber: string;
  bankCode: string;
  bankName: string;
}

export interface DomainBottomCategory {
  id?: number;
  name?: string;
}

export interface DomainBrandAuthenticityTipResponse {
  /** 체크리스트 설명 */
  description?: string;
  /** 가품 캡션 (비어있으면 없는 것임) */
  fakeCaption?: string;
  /** 가품 이미지 */
  fakeImage?: string;
  /** 정품 캡션 (비어있으면 없는 것임) */
  genuineCaption?: string;
  /** 정품 이미지 */
  genuineImage?: string;
  /** 체크리스트 이름 */
  title?: string;
}

export type DomainBrandDivision = 'GLOBAL' | 'CUSTOM' | 'TOTAL';

export interface DomainBrandDto {
  /** @example 1 */
  brandID: number;
  /** @example "THE NORTH FACE" */
  brandName: string;
  /** @example "더 노스 페이스" */
  brandNameKr: string;
  logoUrl?: string;
}

export interface DomainBrandFilter {
  filterBrandItems: DomainFilterBrandItem[];
}

export interface DomainBrandTagDto {
  brandCategoryImage: string;
  brandSectionTitle: string;
  brandTagID: number;
  isBrandCategoryVisible: boolean;
  isOnboardingVisible: boolean;
  name: string;
  officialBrandCount: number;
  officialBrands: DomainOfficialBrandDto[];
  onboardingImage: string;
  resources: DomainBrandTagResource[];
}

export type DomainBrandTagResource =
  | 'BRAND-TAG_RESOURCE_BRAND-CATEGORY'
  | 'BRAND-TAG_RESOURCE_ONBOARDING'
  | 'BRAND-TAG_RESOURCE_SELLER-BRAND-ITEMS';

export interface DomainCancelDetail {
  orderItemID?: number;
  reason?: DomainCancelOrderReason;
  reasonDetail?: string;
  /** 주문 취소 후 변경할 상품 상태. 판매중, 판매중지만 가능함 */
  targetMarketItemStatus?: DomainMarketItemStatus;
  /** Deprecated: 하위 호환성을 위해 남겨둠 */
  withoutMarketItemStatus?: boolean;
}

export interface DomainCancelDispatchOrderBySellerForLookoAIRequest {
  orderItemIDs: number[];
}

export interface DomainCancelOrderByBuyerRequest {
  orderItems: DomainCancelOrderItem[];
}

export interface DomainCancelOrderBySellerRequest {
  orderItems: DomainCancelDetail[];
}

export interface DomainCancelOrderInfoByBuyerResponse {
  /** 취소 금액 */
  cancelAmount?: number;
  /** 환불 수단 */
  payMethod?: DomainPayMethod;
  /** 환불 차감 쿠폰 금액 */
  refundDeductionCouponAmount?: number;
  /** 환불 차감 배송비 */
  refundDeductionLogixAmount?: number;
  /** 환불 차감 반품 배송비 */
  refundDeductionLogixReturnAmount?: number;
  /** 환불 차감 포인트 금액 */
  refundDeductionPointAmount?: number;
  /** 환불 차감 금액 */
  refundDeductionTotalAmount?: number;
  /** 환불 금액 */
  returnAmount?: number;
  /** 반품 가능 여부 */
  returnable?: boolean;
}

export interface DomainCancelOrderItem {
  orderItemID: number;
  reason: DomainCancelOrderReason;
  reasonDetail?: string;
}

export interface DomainCancelOrderRate {
  /** 등급 (A, B, C, D, E) */
  grade?: string;
  /** 주문취소 비율 (0-100 범위) */
  rating?: number;
  /** 상위 5%의 점수 */
  top5Rating?: number;
}

export type DomainCancelOrderReason =
  | 'deleteItem'
  | 'failPayment'
  | 'sellerNoAnswer'
  | 'cancelSellerReason1'
  | 'adminRefundApproval'
  | 'cancelReasonRefund'
  | 'cancelReasonAlreadyProcessed'
  | 'externalRequest'
  | 'cancelManagerReason'
  | 'cancelExtraReason'
  | 'cancelSellerReason2'
  | 'paymentTimeout'
  | 'lowPriceOffer'
  | 'alreadyItemSold'
  | 'scheduler';

export interface DomainCancelPendingOrderBySellerRequest {
  reason?: DomainCancelOrderReason;
  reasonDetail?: string;
  /** 주문 취소 후 변경할 상품 상태. 판매중, 판매중지만 가능함 */
  targetMarketItemStatus?: DomainMarketItemStatus;
  withoutMarketItemStatus?: boolean;
}

export interface DomainCancelablePurchaseOrderItemsResponse {
  orderItems?: DomainOrderItemDetailDto[];
}

export interface DomainCategoryFilter {
  filterTopCategories: DomainFilterTopCategory[];
}

export interface DomainCategoryGroup {
  group: string;
  ids: number[];
}

export interface DomainCategoryHierarchyWithGenderWear {
  genderWear: DomainGenderWearType;
  topCategory?: DomainTopCategory[];
}

export interface DomainCategoryMarketItemCount {
  bottomCategoryIDs?: number[];
  id: string;
  marketItemCount: number;
  name: string;
}

export type DomainChatContentType = 'CHAT_CONTENT-TYPE_TEXT' | 'CHAT_CONTENT-TYPE_IMAGE' | 'CHAT_CONTENT-TYPE_FILE';

export interface DomainChatResponse {
  /**
   * 채팅 ID
   * @example 1
   */
  chatID: number;
  /**
   * 채팅 내용
   * @example "안녕"
   */
  content: string;
  /**
   * 채팅 내용 타입
   * @example "CHAT_CONTENT_TYPE_TEXT"
   */
  contentType: DomainChatContentType;
  /**
   * 생성 시간
   * @example "2023-07-11T12:00:00Z"
   */
  createdAt: string;
  /**
   * 읽음 표시됨
   * @example true
   */
  isSeen: boolean;
  /**
   * 메타데이터 (JSON 문자열)
   * @example "{"type":"text"}"
   */
  metadata: string;
  /**
   * 채팅방 ID
   * @example 1
   */
  roomID: number;
  /**
   * 작성자 ID
   * @example 123
   */
  userID: number;
  /**
   * 작성자 이름
   * @example "홍길동"
   */
  userName: string;
}

export interface DomainChatRoomResponse {
  /**
   * 채팅방 키
   * @example "ITEM-12345"
   */
  chatRoomKey: string;
  /**
   * 채팅방 타입
   * @example "CHAT_ROOM_TYPE_ITEM"
   */
  chatRoomType: DomainChatRoomType;
  /**
   * 생성 시간
   * @example "2023-07-11T10:00:00Z"
   */
  createdAt: string;
  /**
   * 마지막 메시지 타입
   * @example "CHAT_CONTENT_TYPE_TEXT"
   */
  lastChatContentType?: DomainChatContentType;
  /**
   * 마지막 메시지 내용
   * @example "[{"content":"안녕하세요?"}]"
   */
  lastChatContents?: string;
  /**
   * 마지막 메시지 시간
   * @example "2023-07-11T12:00:00Z"
   */
  lastChattedAt?: string;
  /**
   * 채팅방 ID
   * @example 1
   */
  roomID: number;
  /**
   * 채팅방 상태
   * @example "CHAT_ROOM-USER-STATUS_ACTIVE"
   */
  status: DomainUserChatRoomStatus;
  /**
   * 채팅방 제목
   * @example "새로운 채팅방"
   */
  title: string;
  /**
   * 안읽은 메시지 수
   * @example 3
   */
  unreadChatCount: number;
  /**
   * 참여한 사용자 ID 목록
   * @example [123,456]
   */
  userIDs: number[];
}

export type DomainChatRoomType = 'CHAT_ROOM-TYPE_NORMAL-SELLER-MARKET-ITEM' | 'CHAT_ROOM-TYPE_PROSELLER';

export interface DomainCheckBankAccountVerificationResponse {
  isVerified?: boolean;
}

export interface DomainCheckDuplicateEmailResponse {
  /** 유저 가입 구분 */
  division?: string;
  /** 이미 존재하는 유저 정보 */
  existUserInfo?: DomainExistUser;
}

export interface DomainCheckFirstOrderReturnToProSellerResponse {
  isFirstOrderReturn?: boolean;
}

export interface DomainCheckFirstOrderToProSellerResponse {
  isFirstOrder?: boolean;
}

export interface DomainClaimPurchaseRequest {
  /**
   * 구매를 거절할 중고 아이템과 연결된 중고 아이템 ID
   * @example 162581
   */
  marketItemID: number;
}

export interface DomainCloseMarketItemRequest {
  /**
   * 판매 종료 시 판매자가 구매자를 선택하는 경우 구매자 ID
   * @example 25123561
   */
  buyerID?: number;
  /**
   * 판매 종료할 중고 아이템 ID
   * @example 123415
   */
  marketItemID: number;
}

export interface DomainClothesDetectionResult {
  /** 세컨솔드 카테고리 ID */
  category?: number;
  /** 신뢰도 */
  score?: number;
  /** Crop할 옷의 꼭지점 좌표 (일반적으로 4개, 정사각형) */
  vertices?: DomainVertex[];
}

export type DomainClothesFeatures =
  | 'SHOP_ITEM-CLOTHES-FEATURE_RAGLAN'
  | 'SHOP_ITEM-CLOTHES-FEATURE_TOP-RAGLAN'
  | 'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-RAGLAN'
  | 'SHOP_ITEM-CLOTHES-FEATURE_SHOULDER-PAD'
  | 'SHOP_ITEM-CLOTHES-FEATURE_TOP-SHOULDER-PAD'
  | 'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-SHOULDER-PAD'
  | 'SHOP_ITEM-CLOTHES-FEATURE_WAIST-BANDING'
  | 'SHOP_ITEM-CLOTHES-FEATURE_CHEST-PAD'
  | 'SHOP_ITEM-CLOTHES-FEATURE_TOP-CHEST-PAD'
  | 'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-CHEST-PAD'
  | 'SHOP_ITEM-CLOTHES-FEATURE_LINER'
  | 'SHOP_ITEM-CLOTHES-FEATURE_TOP-LINER'
  | 'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-LINER'
  | 'SHOP_ITEM-CLOTHES-FEATURE_SKIRT-LINER'
  | 'SHOP_ITEM-CLOTHES-FEATURE_PANTS-LINER';

export type DomainClothesSizeType =
  | 'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-OUTER'
  | 'SHOP_ITEM-CLOTHES-SIZE-TYPE_DRESS'
  | 'SHOP_ITEM-CLOTHES-SIZE-TYPE_JUMPSUITS'
  | 'SHOP_ITEM-CLOTHES-SIZE-TYPE_PANTS'
  | 'SHOP_ITEM-CLOTHES-SIZE-TYPE_SKIRT'
  | 'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-PANTS'
  | 'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-SKIRT'
  | 'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-ONEPIECE'
  | 'SHOP_ITEM-CLOTHES-SIZE-TYPE_HEADWEAR'
  | 'SHOP_ITEM-CLOTHES-SIZE-TYPE_SHOES'
  | 'SHOP_ITEM-CLOTHES-SIZE-TYPE_OTHER-ITEMS';

export interface DomainColorFilter {
  filterColorItems: DomainFilterColorItem[];
}

export type DomainCommunityBoard = 'VINTAGE_SHOP_RECOMMENDATION' | 'GOOD_DEAL' | 'FREE_TALK';

export interface DomainCommunityPostCommentResponse {
  /**
   * 댓글 ID
   * @example 5
   */
  commentID?: number;
  /**
   * 댓글 내용
   * @example "Test Comment ☺️"
   */
  content?: string;
  /**
   * 댓글 작성일시
   * @example "2024-04-05T04:24:25.966Z"
   */
  createdAt?: string;
  /** 댓글을 작성한 사용자 정보 */
  user?: DomainCommunityUserResponse;
}

export interface DomainCommunityPostMarketItemResponse {
  /**
   * 중고마켓 아이템 브랜드
   * @example "Nike"
   */
  brand?: string;
  /**
   * 중고마켓 아이템 ID
   * @example 98
   */
  marketItemID?: number;
  /**
   * 중고마켓 아이템 썸네일 URL
   * @example "https://test.com/thumbnail.jpg"
   */
  thumbnailURL?: string;
  /**
   * 중고마켓 아이템 제목
   * @example "기가막힌 바지"
   */
  title?: string;
}

export interface DomainCommunityPostResponse {
  /**
   * 게시판 종류
   * @example "VINTAGE_SHOP_RECOMMENDATION"
   */
  board?: DomainCommunityBoard;
  /**
   * 댓글 수
   * @example 2
   */
  commentCount?: number;
  /**
   * 게시글 내용
   * @example "Test Content 👍"
   */
  content?: string;
  /**
   * 게시글 작성일시
   * @example "2024-04-05T04:24:25.966Z"
   */
  createdAt?: string;
  /**
   * 게시글 이미지 URL 목록
   * @example ["https://test.com/test1.jpg","https://test.com/test2.jpg"]
   */
  imageURLs?: string[];
  /**
   * 현재 사용자가 해당 게시글에 좋아요를 눌렀는지 여부
   * @example true
   */
  isLiked?: boolean;
  /**
   * 좋아요 수
   * @example 10
   */
  likeCount?: number;
  /** 게시글에 등록된 중고마켓 아이템 목록 */
  marketItems?: DomainCommunityPostMarketItemResponse[];
  /**
   * 게시글 ID
   * @example 100
   */
  postID?: number;
  /**
   * 게시글 제목
   * @example "Test Title"
   */
  title?: string;
  /** 게시글을 작성한 사용자 정보 */
  user?: DomainCommunityUserResponse;
}

export interface DomainCommunityUserResponse {
  /**
   * 사용자 닉네임
   * @example "kevin"
   */
  nickname?: string;
  /**
   * 사용자 프로필 이미지 URL
   * @example "https://test.com/profile.jpg"
   */
  profileImageURL?: string;
  /**
   * 사용자 ID
   * @example 7
   */
  userID?: number;
}

export interface DomainConfirmOrderBySellerRequest {
  orderItemIDs: number[];
}

export interface DomainConfirmPurchaseByBuyerRequest {
  orderItemIDs: number[];
}

export interface DomainConfirmablePurchaseOrderItemsResponse {
  orderItems?: DomainOrderItemDetailDto[];
}

export interface DomainContactItem {
  answerStatus?:
    | 'CONTACT_ANSWER_AWAITING-RESPONSE'
    | 'CONTACT_ANSWER_RESPONSE-COMPLETE'
    | 'CONTACT_ANSWER_RESPONSE-DENIED';
  content?: string;
  createDt?: number;
  deviceInfo?: DomainContactItemDeviceInfo;
  hasOrders?: boolean;
  id?: number;
  lastAppVersion?: string;
  locale?: DomainContactItemLocale;
  nickname?: string;
  permission?: DomainContactItemPermission;
  title?: string;
  type?: DomainContactType;
  userEmail?: string;
  userID?: number;
}

export interface DomainContactItemDeviceInfo {
  appVersion?: string;
  device?: string;
  freeStorage?: string;
  osVersion?: string;
  timeozne?: string;
}

export interface DomainContactItemLocale {
  countryCode?: string;
  /** nolint:tagliatelle */
  isRTL?: boolean;
  languageCode?: string;
  languageTag?: string;
}

export interface DomainContactItemPermission {
  camera?: string;
  location?: string;
  photo?: string;
}

export type DomainContactType = 'CONTACT_TYPE_NORMAL' | 'CONTACT_TYPE_SHOP-RECOMMENDATION';

export interface DomainCountCartsResponse {
  count: number;
}

export interface DomainCountMarketItemBrandsResponse {
  marketItemBrandCount?: number;
}

export interface DomainCountMarketItemReviewsForLookoAIResponse {
  count?: number;
}

export interface DomainCountNotificationsResponse {
  /**
   * 알림 개수
   * @example 1
   */
  notificationCount: number;
}

export interface DomainCountOfficialBrandsResponse {
  officialBrandCount?: number;
}

export interface DomainCountSendbirdUnreadMessageResponse {
  /**
   * 안읽은 메세지 개수
   * @example 7
   */
  count: number;
}

export interface DomainCountUnreadChatsInRoomResponse {
  /**
   * 안읽은 메시지 수
   * @example 3
   */
  count?: number;
  /**
   * 채팅방 ID
   * @example 1
   */
  roomID?: number;
}

export interface DomainCountUnreadChatsResponse {
  /**
   * 읽지 않은 채팅 수
   * @example 5
   */
  count?: number;
}

export interface DomainCountUserBookmarkMarketItemResponse {
  /**
   * 유저가 북마크한 중고 아이템 수
   * @example 0
   */
  bookmarkCount: number;
}

export interface DomainCountUserMarketItemResponse {
  /**
   * 유저가 구매자로 참여한 중고 아이템 수
   * @example 0
   */
  buyMarketItemCount: number;
  /**
   * 유저가 판매자로 참여한 중고 아이템 수
   * @example 0
   */
  sellMarketItemCount: number;
}

export interface DomainCountUserMarketItemReviewResponse {
  /**
   * 유저가 받은 구매 리뷰 수
   * @example 0
   */
  buyReviewCount: number;
  /**
   * 유저가 받은 판매 리뷰 수
   * @example 0
   */
  sellReviewCount: number;
}

export interface DomainCountWeeklyMarketItemResponse {
  count?: number;
  month?: number;
  week?: number;
}

export type DomainCouponCalcType = 'COUPON_CALC_TYPE_RATE' | 'COUPON_CALC_TYPE_AMOUNT';

export interface DomainCouponConditionDTO {
  conditionType?: DomainCouponConditionType;
  conditionValue?: number;
  proSellerID?: number;
  userCreateDateEnd?: string;
  userCreateDateStart?: string;
}

export type DomainCouponConditionType =
  | 'ALL_USER'
  | 'USER_CREATE_DATE'
  | 'NO_PRO_SELLER_PURCHASE_HISTORY'
  | 'PRO_SELLER_PURCHASE_COUNT'
  | 'PRO_SELLER_PURCHASE_AMOUNT'
  | 'PRO_SELLER_ID';

export type DomainCouponIssuer = 'COUPON_ISSUER_ACLOSET' | 'COUPON_ISSUER_PRO_SELLER';

export interface DomainCouponItem {
  allowDuplicateUsage: boolean;
  allowReissue: boolean;
  /** 정률, 정액 */
  couponCalcType: DomainCouponCalcType;
  couponCode: string;
  couponConditions: DomainCouponConditionDTO[];
  couponContentImages: string[];
  couponDescription: string;
  couponID: number;
  couponImage: string;
  couponIssueButtonImage: string;
  couponIssuer: DomainCouponIssuer;
  /** 쿠폰 이름 */
  couponName: string;
  couponStatus: DomainCouponStatus;
  couponUsageMax: number;
  discountAmount: number;
  /** 정률인 경우 */
  discountAmountMax: number;
  eventEndDate: string;
  eventStartDate: string;
  /** 유효 기간 (24시간) */
  expirationDuration: number;
  isActivate: boolean;
  isIssued: boolean;
  issuedCouponCount: number;
  /** 정률인 경우 */
  txAmountMin: number;
  usedCouponCount: number;
}

export interface DomainCouponItemForLookoAI {
  /** 재발급 가능 여부 */
  allowReissue: boolean;
  /** 발급 타입 */
  conditionType: DomainCouponConditionType;
  /** 발급 조건 (구매 횟수, 구매 금액) */
  conditionValue?: number;
  /** 정률, 정액 */
  couponCalcType: DomainCouponCalcType;
  couponID: number;
  /** 쿠폰 이름 */
  couponName: string;
  /** 진행 상태 */
  couponStatus: DomainCouponStatus;
  /** 발급 한도 */
  couponUsageMax: number;
  /** 할인 금액(혹은 할인율) */
  discountAmount: number;
  /** 정률인 경우 - 최대 할인 금액 */
  discountAmountMax: number;
  /** 발급 가능 기간 종료일 */
  eventEndDate: string;
  /** 발급 가능 기간 시작일 */
  eventStartDate: string;
  /** 발급 후 사용 기간 */
  expirationDuration: number;
  /** 쿠폰 발급 한도 제한 여부 */
  hasIssueLimit: boolean;
  /** 발급 수량 */
  issuedCouponCount: number;
  /** 최소 결제 금액 */
  txAmountMin: number;
  /** 사용 수 */
  usedCouponCount: number;
}

export type DomainCouponStatus = 'COUPON_STATUS_IDLE' | 'COUPON_STATUS_IN_PROGRESS' | 'COUPON_STATUS_END';

export interface DomainCreateAmplitudeMarketItemSearchLogRequest {
  item_list_id?: string;
  search_keyword?: string;
  viewer_id?: number;
}

export interface DomainCreateAmplitudeMarketItemViewLogRequest {
  item_list_id?: string;
  market_item_id?: number;
  screen_name?: string;
  search_keyword?: string;
  section?: string;
  sort?: string;
  view_index?: number;
  viewer_id?: number;
}

export interface DomainCreateCartRequest {
  marketItemID?: number;
}

export interface DomainCreateChatRequest {
  /** 채팅 내용 타입 (예: 텍스트, 이미지 등) */
  contentType: DomainChatContentType;
  /**
   * 채팅 내용
   * @example "안녕하세요!"
   */
  contents: string;
  /**
   * 메타데이터 (선택사항). 유효한 JSON 형식이어야 합니다.
   * @example "{"type":"text"}"
   */
  metadata?: string;
}

export interface DomainCreateChatResponse {
  /**
   * 생성된 채팅 ID
   * @example 1
   */
  chatID: number;
}

export interface DomainCreateChatRoomRequest {
  /** 채팅방 키. 상품번호 등을 전달받아 채팅방의 유일성을 판단합니다. 전달할게 없을 경우에는 빈 문자열로라도 보냅니다. */
  chatRoomKey?: string;
  /** 채팅방 타입 */
  chatRoomType: DomainChatRoomType;
  /**
   * 채팅방 제목
   * @example "새로운 채팅방"
   */
  title: string;
  /** 참여할 사용자 ID 목록 */
  userIDs: number[];
}

export interface DomainCreateChatRoomResponse {
  /**
   * 생성된 채팅방 ID
   * @example 1
   */
  roomID: number;
}

export interface DomainCreateCommunityPostCommentReportRequest {
  /**
   * 200 글자 이내
   * @example "욕설"
   */
  reason: string;
}

export interface DomainCreateCommunityPostCommentRequest {
  /**
   * 댓글 내용. 200자 이내
   * @example "완전 대박!"
   */
  content: string;
}

export interface DomainCreateCommunityPostReportRequest {
  /**
   * 200 글자 이내
   * @example "욕설"
   */
  reason: string;
}

export interface DomainCreateCommunityPostRequest {
  /**
   * 게시판 종류
   * @example "VINTAGE_SHOP_RECOMMENDATION"
   */
  board: DomainCommunityBoard;
  /**
   * 게시글 내용. 5000자 이내
   * @example "Test Content"
   */
  content: string;
  /**
   * 게시글에 등록할 이미지 URL 목록
   * @example ["https://test.com/test1.jpg","https://test.com/test2.jpg"]
   */
  imageUrls?: string[];
  /**
   * 게시글에 등록할 중고마켓 아이템 ID 목록
   * @example [13,2434,123143]
   */
  marketItemIDs?: number[];
  /**
   * 게시글 제목. 50자 이내
   * @example "Test Title"
   */
  title: string;
}

export interface DomainCreateContactRequest {
  content: string;
  email: string;
  title: string;
  /** @example "CONTACT_TYPE_NORMAL" */
  type: DomainContactType;
}

export interface DomainCreateCouponForLookoAIRequest {
  /** 재발급 가능 여부 */
  allowReIssue: boolean;
  /** 발급 타입 */
  conditionType: DomainCouponConditionType;
  /** 발급 조건 (구매 횟수, 구매 금액) */
  conditionValue?: number;
  /** 쿠폰 타입 (정률, 정액) */
  couponCalcType: DomainCouponCalcType;
  /** 쿠폰 이름 */
  couponName: string;
  /** 쿠폰 발급 한도 */
  couponUsageMax: number;
  /** 할인 금액 혹은 할인율 */
  discountAmount: number;
  /** 최대 할인 가능 금액 */
  discountAmountMax: number;
  /** 쿠폰 발급 가능 기간 (종료) */
  eventEndDate: string;
  /** 쿠폰 발급 가능 기간 (시작) */
  eventStartDate: string;
  /** 발급 후 사용 기간 (만료기간) */
  expirationDuration: number;
  /** 쿠폰 발급 한도 제한 여부 */
  hasIssueLimit: boolean;
  /** 최소 결제 금액 */
  txAmountMin: number;
}

export interface DomainCreateCouponRequest {
  allowDuplicateUsage: boolean;
  /** 정률, 정액 */
  couponCalcType: DomainCouponCalcType;
  couponDescription: string;
  couponImage: string;
  couponName: string;
  discountAmount: number;
  /** 정률인 경우 */
  discountAmountMax: number;
  /** 유효 기간 (24시간) */
  expirationDuration: number;
  /** 정률인 경우 */
  txAmountMin: number;
}

export interface DomainCreateErrorReportRequest {
  /** 앱 버전 */
  appVersion: string;
  /** 내용 */
  description?: string;
  /** 디바이스 */
  device: string;
  /** 에러 타입 */
  errorReportType: DomainErrorReportType;
  /** OS 버전 */
  osVersion: string;
  /** Sentry ID */
  sentryID?: string;
}

export type DomainCreateLoginTokenRequest = object;

export interface DomainCreateLoginTokenResponse {
  /** 로그인 토큰 */
  token?: string;
}

export interface DomainCreateMarketItemChatroomRequest {
  /**
   * 타겟유저 ID
   * @example 12383
   */
  targetUserID: number;
}

export interface DomainCreateMarketItemChatroomResponse {
  /**
   * 채팅방 ID (Sendbird Group Channel URL)
   * @example "sendbird_group_channel_175316761_dc76b0be7092ccc16cc4435a639697aaaa1e2b0f"
   */
  chatroomID: string;
  /**
   * 마켓 아이템 채팅방 ID (서버 관리 값)
   * @example 1823838
   */
  marketItemChatroomID: number;
}

export interface DomainCreateMarketItemImageRequest {
  /**
   * BASE64로 인코딩 된 이미지 바이너리
   * @example "BASE64"
   */
  base64: string;
  /**
   * 이미지 높이
   * @example 100
   */
  height: number;
  /**
   * 대표이미지 여부
   * @example true
   */
  isMain: boolean;
  /**
   * 이미지 순서
   * @example 1
   */
  order: number;
  /**
   * 이미지 폭
   * @example 100
   */
  width: number;
}

export interface DomainCreateMarketItemRequest {
  /**
   * 중고 아이템 브랜드 이름
   * @example "zara"
   */
  brandName?: string;
  /**
   * 중고 아이템 카테고리 ID
   * @example 56
   */
  categoryID: number;
  /**
   * 중고 아이템 색상 ID 리스트
   * @example [2,6,7]
   */
  colorIDs?: number[];
  /**
   * 중고 아이템 내용
   * @example "직거래는 워싱턴에서 희망해요"
   */
  description: string;
  /**
   * 중고 아이템 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear:
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_GIRL';
  /** 중고 아이템 첨부 이미지 리스트 */
  images: DomainCreateMarketItemImageRequest[];
  logixPrice: DomainLogixPrice;
  logixType: 'MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE' | 'MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY';
  /**
   * 중고 아이템 가격
   * @example 1000
   */
  price: number;
  /**
   * 중고 아이템 깨끗함 상태(깨끗, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality?:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  /**
   * 중고 아이템 사이즈
   * @example "XXL"
   */
  size?: string;
  /**
   * 중고 아이템 사이즈 ID
   * @example 1
   */
  sizeID?: number;
  /**
   * 중고 아이템 사이즈 지역
   * @example "kr"
   */
  sizeRegion?: string;
  /**
   * 중고 아이템 제목
   * @example "신품급 버버리 코트 팔아유"
   */
  title: string;
}

export interface DomainCreateMarketItemReviewRequest {
  /**
   * 리뷰 내용
   * @example "매너도 좋고 친절하세요 가방을 샀는데 패딩을 덤으로 주시네요 ㅜㅜ"
   */
  comment: string;
  /** 리뷰 사진 */
  images: DomainMarketItemReviewImageRequest[];
  /**
   * 평점 5점 만점
   * @example 5
   */
  rating: number;
  /** 리뷰 태그 */
  reviewTags?: DomainMarketItemReviewTag[];
  /**
   * 리뷰를 받는 유저 ID
   * @example 626723
   */
  revieweeID: number;
  /** 사이즈 태그 */
  sizeTags?: DomainMarketItemReviewSizeTag[];
  /** 보물 태그 */
  treasureTags?: DomainMarketItemReviewTreasureTag[];
}

export interface DomainCreateMarketItemReviewResponse {
  /**
   * 리뷰 추가로 가능한 지 여부
   * @example true
   */
  hasReviewableMarketItem: boolean;
  /**
   * 정상 생성된 리뷰의 ID (PK)
   * @example 1
   */
  reviewID: number;
  /**
   * 지급 포인트
   * @example 1
   */
  rewardPoint: number;
}

export interface DomainCreateMarketItemV2Request {
  bottomTotalLength?: number;
  bottomWaist?: number;
  /**
   * 중고 아이템 브랜드 이름
   * @example "zara"
   */
  brandName?: string;
  /**
   * 중고 아이템 카테고리 ID
   * @example 56
   */
  categoryID: number;
  /**
   * 중고 아이템 색상 ID 리스트
   * @example [2,6,7]
   */
  colorIDs?: number[];
  /**
   * 중고 아이템 내용
   * @example "직거래는 워싱턴에서 희망해요"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 1000
   */
  discountPrice?: number;
  fabrics?: string[];
  frontImageURL?: string;
  /**
   * 중고 아이템 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear:
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX';
  /** 중고 아이템 첨부 이미지 리스트 */
  images: DomainMarketItemImageRequest[];
  isFrontImageBackgroundRemoved?: boolean;
  isLoadedFromBunjang?: boolean;
  /**
   * Looko AI 상품 코드
   * @example "1234567890"
   */
  itemCode: string;
  itemOrigin?: string;
  keywords?: string[];
  logixID?: number;
  logixPrice: DomainLogixPrice;
  logixType: 'MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE' | 'MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY';
  /** LookoAI 데이터와의 추적을 위한 로깅용 필드 (아이템 아이디) */
  lookoAIID?: string;
  /** @example 1 */
  materialID?: number;
  neck: string;
  /** @example 1 */
  patternID?: number;
  /**
   * 중고 아이템 가격
   * @example 1000
   */
  price: number;
  /**
   * 중고 아이템 깨끗함 상태(깨끗, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality?:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  raglan?: DomainMarketItemRaglanType[];
  shoulderPad?: DomainMarketItemShoulderPadType[];
  /**
   * 중고 아이템 사이즈
   * @example "XXL"
   */
  size?: string;
  sizeForDisplay?: DomainSizeForDisplay;
  /**
   * 중고 아이템 사이즈 ID
   * @example 1
   */
  sizeID?: number;
  /**
   * 중고 아이템 사이즈 지역
   * @example "kr"
   */
  sizeRegion?: string;
  sleeveLength: string;
  /**
   * 중고 아이템 상태
   * @example "MARKET-ITEM_STATUS_FOR-SALE"
   */
  status?: DomainMarketItemStatus;
  /**
   * 중고 아이템 제목
   * @example "신품급 버버리 코트 팔아유"
   */
  title: string;
  topChest?: number;
  topShoulder?: number;
  topSleeveLength?: number;
  topTotalLength?: number;
  waistBanding?: DomainMarketItemWaistBandingType[];
}

export interface DomainCreateOrderRequest {
  couponID?: number;
  isCartPayment?: boolean;
  /** 재결제를 위한 파라미터 */
  isRepayment?: boolean;
  logix?: DomainOrderBuyerLogix;
  marketItemIDs: number[];
  /** 가격 제안 */
  marketItemPriceOffers?: DomainMarketItemPriceOffer[];
  orderID?: number;
  payMethod?: DomainPayMethod;
  point?: number;
}

export interface DomainCreateOrderResponse {
  amount: number;
  buyerID: number;
  couponAmount?: number;
  couponDiscountAmount: number;
  couponID?: number;
  couponType?: string;
  details: DomainOrderItemDetailDto[];
  isFirstOrder: boolean;
  isPriceOffered: boolean;
  logixPrice: number;
  marketItemPrices: number;
  marketItemTitle: string;
  merchantUID: string;
  point?: number;
  sellerID: number;
}

export interface DomainCreatePresignedUrlRequest {
  /** 상위 prefix입니다. d1으로 시작할 경우 하루 뒤에 만료됩니다. */
  category?: string;
  /** 파일의 mime type입니다. */
  contentType?: string;
}

export interface DomainCreatePresignedUrlResponse {
  getUrl?: string;
  path?: string;
  putUrl?: string;
}

export interface DomainCreateProSellerLogixForLookoAIRequest {
  /** CS 담당 연락처 */
  afterServicePhoneNumber: string;
  /** 택배사 */
  courierCompany: string;
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeOnAmount: number;
  /** 공급사명(지점명) 노출 여부 */
  isVisible: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea: boolean;
  /** 공급사명(지점명) */
  logixName: string;
  /** 배송 정책 */
  logixPolicy: string;
  /** 배송비 */
  logixPrice: DomainLogixPrice;
  /** 배송 타입 */
  logixType: DomainLogixType;
  /** 최대 구매 수량 */
  purchaseQuantity: number;
  /** 수거 방법 */
  refundLogixType: DomainRefundLogixType;
  /** 반품 주소 */
  returnAddress: string;
  /** 반품 상세 주소 */
  returnAddressDetail: string;
  /** 반품 배송비 */
  returnFee: number;
  /** 반품 이름 */
  returnName: string;
  /** 반품 정책 */
  returnPolicy: string;
  /** 반품 우편 번호 */
  returnZipCode: string;
}

export interface DomainCreateProSellerLogixForLookoAIResponse {
  /** 공급사 아이디 */
  logixID: number;
}

export interface DomainCreateReportRequest {
  /**
   * 신고 상세 사유
   * @example "이거 이거 완전 사기꾼이에요"
   */
  detail?: string;
  /**
   * 신고 사유 코드
   * @example "REPORT_REASON_SPAM"
   */
  reasonCode: 'REPORT_REASON_SPAM' | 'REPORT_REASON_NUDITY' | 'REPORT_REASON_HATE-SPEECH';
  /**
   * 신고 타입 코드
   * @example "REPORT_TYPE_USER"
   */
  reportType: 'REPORT_TYPE_USER' | 'REPORT_TYPE_COMMENT' | 'REPORT_TYPE_CLOTHES' | 'REPORT_TYPE_OUTFIT';
  /** 신고 당한 object 아이디 */
  reportedID: number;
  /** 신고 당한 유저 아이디 */
  reportedUserID: number;
}

export interface DomainCreateSearchABTestRequest {
  policies?: DomainSearchPolicyName[];
  testName?: DomainMarketItemOrderField;
}

export interface DomainCreateStoreCouponForLookoAIRequest {
  /** 쿠폰 이름 */
  couponName: string;
  /** 할인 금액 */
  discountAmount: number;
  /** 파트너 샵 ID */
  partnerShopInfoID: number;
  /** 최소 결제 금액 */
  txAmountMin: number;
}

export interface DomainCreateUserBankAccountRequest {
  /** 예금주명 */
  accountHolder: string;
  /** 계좌번호 */
  accountNumber: string;
  /** 은행 코드 */
  bankCode: string;
  /** 은행명 */
  bankName: string;
  /** 환불 계좌 여부 */
  isRefundAccount: boolean;
  /** 정산 계좌 여부 */
  isSettlementAccount: boolean;
}

export interface DomainCreateUserCouponRequest {
  couponCode?: string;
  couponID?: number;
}

export interface DomainCreateUserSearchKeywordRequest {
  searchKeyword: string;
}

export interface DomainCreateUserStoreCouponRequest {
  /** 매장 쿠폰 ID */
  storeCouponID: number;
}

export interface DomainCreateUserSurveyHistoryRequest {
  /** 객관식 답변 리스트 */
  multipleChoiceAnswers?: string[];
  /** 주문 아이디 */
  orderID?: number;
  /** 주문상품 아이디 */
  orderItemID?: number;
  /** 주관식 답변 */
  subjectiveAnswer?: string;
  /** 설문 답변 타입 (주관식, 객관식) */
  surveyAnswerType: string;
  /** 설문 조사가 속한 그룹 */
  surveyGroupType: string;
  /** 설문 조사 버전 (회차) */
  surveyGroupVersion: string;
  /** 프론트 분들께서 추가해주실 설문에 대한 부가적인 json 데이터 */
  surveyMetadata?: string;
  /** 설문 제목 */
  surveyTitle: string;
}

export interface DomainCreateWishlistRequest {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 필터에 대한 설명
   * @example "1000~50000, ZARA, 남자, 옷파는야옹이, 파란색"
   */
  description?: string;
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example 40000
   */
  discountPriceMax?: number;
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example 1000
   */
  discountPriceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example ["MARKET-ITEM_GENDERWEAR_MEN","MARKET-ITEM_GENDERWEAR_WOMEN"]
   */
  genderWears?: DomainGenderWearType[];
  /** @example true */
  isNotification: boolean;
  /**
   * 빈 문자열은 안됨. 글자수 제한 없음
   * @example "스포츠 관심상품"
   */
  name: string;
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /**
   * Deprecated: 1,000원 단위 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example 40000
   */
  priceMax?: number;
  /**
   * Deprecated: 1,000원 단위 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example 1000
   */
  priceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  sellerIDs?: number[];
  /** @example 1 */
  shoeSizeMax?: number;
  /** @example 1 */
  shoeSizeMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 문자열이 아닌 null 로 받음
   * @example "나이키 집업"
   */
  textSearch?: string;
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
}

export interface DomainCreateWishlistResponse {
  /** @example 1 */
  wishlistID: number;
}

export interface DomainCursorPaginationResponse {
  hasNext: boolean;
  nextCursor: string;
}

export interface DomainCustomerReviewRate {
  /** 리뷰 태그별 개수 */
  count?: number;
  /** 리뷰 태그 (MarketItemReviewTreasureTag, MarketItemReviewSizeTags, MarketItemReviewTag 포함) */
  reviewTag?: string;
}

export interface DomainDeleteCartRequest {
  marketItemIDs?: number[];
}

export interface DomainDeleteMarketItemBookmarksRequest {
  /**
   * 북마크를 삭제할 중고 아이템 ID 리스트
   * @example [1,2,3]
   */
  marketItemIDs: number[];
  /** @example true */
  removeNotForSale: boolean;
}

export interface DomainDeleteMarketItemBookmarksResponse {
  /**
   * 삭제된 북마크 중고 아이템 ID 리스트
   * @example [1,2,3]
   */
  marketItemIDs: number[];
}

export interface DomainDeleteMarketItemChatroomsRequest {
  /**
   * 삭제하고자 하는 채팅방 ID 리스트
   * @example ["[sendbird-1238asd"," sendbird-fj934fj1]"]
   */
  chatroomIDs?: string[];
  /**
   * 중고 ID와 연관된 채팅방 모두 삭제
   * @example 96923
   */
  marketItemID?: number;
}

export interface DomainDeleteMarketItemImageRequest {
  /**
   * 중고 아이템 수정 시 삭제할 이미지 ID
   * @example 125161
   */
  imageID: number;
}

export interface DomainDiscountNotification {
  /**
   * 할인된 금액
   * @example 1000
   */
  discountAmount: number;
  /**
   * 마지막 할인 일자
   * @example "1"
   */
  discountDate: string;
  /**
   * 할인 알림 노출 여부
   * @example true
   */
  showNotification: boolean;
}

export interface DomainDiscountPriceFilter {
  discountPriceMax: number;
  discountPriceMin: number;
}

export interface DomainDiscountProSeller {
  /** 최대 할인율 */
  maximumDiscountRate?: number;
  nickname?: string;
  /** 프로필 이미지 */
  profileImage?: string;
  /** 특가 세일 배너 게시중 */
  promotionInProgress?: boolean;
  promotionInfoID?: number;
  userID?: number;
}

export interface DomainDiscountProSellerUserItem {
  /** 상점 노출 여부 */
  isVisibleProSeller?: boolean;
  /** 가장 최근 할인 날짜 */
  lastDiscountPriceModifyDate?: string;
  /** 샵의 대표 아이템 */
  marketItems?: DomainProSellerMarketItemResponse[];
  /** 최대 할인율 */
  maximumDiscountRate?: number;
  nickname?: string;
  /** 프로필 이미지 */
  profileImage?: string;
  /** 할인 판매중인 아이템 수 */
  remainingMarketItemCount?: number;
  /** 할인중인 아이템 총 갯수 */
  totalMarketItemCount?: number;
  userID: number;
}

export interface DomainDispatchOrderBySellerRequest {
  orderItemLogixs: DomainOrderItemLogix[];
}

export interface DomainDisplay {
  /** @example {" 2":" '아웃도어'}","{1":" '스포츠'"} */
  brandTagTitleMap: Record<string, string>;
  clientCustomConfig: string;
  /** '2column' | '3column' | 'horizontal' */
  layoutType: '2column' | '3column' | 'horizontal';
  /** @example "닉네임" */
  nickname?: string;
  /** @example "섹션 제목" */
  sectionTitle: string;
  /**
   * 유저 섹션 그리기 위한 유저 ID
   * @example 1
   */
  userID?: number;
}

export interface DomainDisplayRequest {
  /** @example {" 2":" '아웃도어'}","{1":" '스포츠'"} */
  brandTagTitleMap: Record<string, string>;
  /** @example "" */
  clientCustomConfig?: string;
  /** '2column' | '3column' | 'horizontal' */
  layoutType: '2column' | '3column' | 'horizontal';
  /** @example "섹션 제목" */
  sectionTitle: string;
}

export interface DomainDuplicateCheckWishlistRequest {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example ["MARKET-ITEM_GENDERWEAR_MEN","MARKET-ITEM_GENDERWEAR_WOMEN"]
   */
  genderWears?: DomainGenderWearType[];
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example 40000
   */
  priceMax?: number;
  /** @example 1000 */
  priceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  sellerIDs?: number[];
  /** @example 1 */
  shoeSizeMax?: number;
  /** @example 1 */
  shoeSizeMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 문자열이 아닌 null 로 받음
   * @example "나이키 집업"
   */
  textSearch?: string;
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
}

export interface DomainDuplicateCheckWishlistResponse {
  /** @example true */
  isDuplicate: boolean;
}

export type DomainErrorReportType = 'LOGIN' | 'REGISTER' | 'PHONE_AUTH' | 'PAYMENT_FAILED' | 'ETC';

export interface DomainExistUser {
  division?: string;
  email?: string;
  nickname?: string;
  profilePhotoUrl?: string;
  userID?: number;
}

export interface DomainExistsMarketItemResponse {
  /**
   * 해당 중고 물품에 북마크 한 수
   * @example 1
   */
  bookmarkCount: number;
  bottomTotalLength?: number;
  bottomWaist?: number;
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /** @example 1 */
  brandTagID: number;
  /**
   * 중고 아이템 구매자 유저 ID
   * @example 22612346
   */
  buyerID?: number;
  /** @example 2626123 */
  clothesID?: number;
  /**
   * 중고 아이템 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 중고 아이템 생성일
   * @example 1668080178342
   */
  createDate: number;
  /**
   * TODO: 아래필드는 삭제 예정 (4.4.0) <-- 진짜 삭제하는지 확인
   * @example "KRW"
   */
  currency: string;
  cursor?: string;
  /**
   * 중고 아이템 설명
   * @example "사실 2년 입었어유"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  existsCompletedOrder?: boolean;
  existsOrder?: boolean;
  /** @example "MARKET-ITEM_FABRIC_COTTON" */
  fabric: string;
  fabrics: string[];
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  /** @example false */
  isBookmarked: boolean;
  /**
   * 중고 아이템 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /**
   * 프로셀러 여부
   * @example true
   */
  isProSeller: boolean;
  /** 비슷한 상품 여부 */
  isSimilar?: boolean;
  /**
   * 지점명 노출 여부
   * @example true
   */
  isVisible: boolean;
  /**
   * Looko AI 상품 코드
   * @example "1234567890"
   */
  itemCode: string;
  /**
   * 중고 아이템 검색 키워드
   * @example ["흰색","티셔츠","남성"]
   */
  keywords: string[];
  logixID: number;
  /**
   * 공급사명(지점명)
   * @example "공급사 없음"
   */
  logixName: string;
  logixPolicy: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 조회수
   * @example 1
   */
  marketItemView?: number;
  /**
   * 중고 아이템 수정일
   * @example 1668080178342
   */
  modifyDate: number;
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  /**
   * 중고 아이템의 상태 (깨끗함, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  score: number;
  shoeSize?: number;
  /**
   * 중고 옷 사이즈
   * @example "FREE"
   */
  size: string;
  sizeForDisplay?: DomainSizeForDisplay;
  /** 중고 아이템 판매 상태 */
  status: DomainMarketItemStatus;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
  /**
   * 중고 아이템 제목
   * @example "새것 같은 노스페이스 패딩 팔아유"
   */
  title: string;
  topChest?: number;
  topShoulder?: number;
  topSleeveLength?: number;
  topTotalLength?: number;
  /**
   * 중고 아이템 판매자 유저 ID
   * @example 22612346
   */
  userID: number;
  /** Deprecated: 6.7.0 이후 삭제 와우 할인가 */
  wowDiscountAmount?: number;
}

export interface DomainExistsUserForLookoAIRequest {
  /** 중복 확인 이메일 */
  email?: string;
  /** 중복 확인 닉네임 */
  nickName?: string;
}

export interface DomainExistsUserForLookoAIResponse {
  /** 해당 이메일이 존재하는지를 나타내는 값 */
  emailExists: boolean;
  /** 해당 계정이 존재하는지를 나타내는 값 (이메일+닉네임 중복 확인. 하나만 중복되어도 true로 반환됩니다.) */
  exists: boolean;
  /** 해당 계정이 존재할 경우, 해당 계정이 프로셀러인지 아닌지를 나타내는 값 */
  isProSeller: boolean;
  /** 해당 닉네임이 존재하는지를 나타내는 값 */
  nicknameExists: boolean;
}

export type DomainExitChatRoomResponse = object;

export interface DomainExtendConfirmPurchaseByBuyerRequest {
  orderItemIDs: number[];
}

export interface DomainFabricFilter {
  filterFabricItems: DomainFilterFabricItem[];
}

export interface DomainFilterBottomCategory {
  count: number;
  id: number;
  name: string;
}

export interface DomainFilterBrandItem {
  count: number;
  logoUrl: string;
  nameEn: string;
  nameKr: string;
  officialBrandID: number;
}

export interface DomainFilterColorItem {
  count: number;
  hexCode: string;
  id: number;
  name: string;
}

export interface DomainFilterFabricItem {
  count: number;
  name: string;
  sid: string;
}

export interface DomainFilterGenderWearItem {
  count: number;
  name: string;
  sid: string;
}

export interface DomainFilterMiddleCategory {
  count: number;
  filterBottomCategories: DomainFilterBottomCategory[];
  name: string;
  sid: string;
}

export interface DomainFilterPatternItem {
  count: number;
  id: number;
  imageURL: string;
  name: string;
}

export interface DomainFilterSizeLengthItem {
  count: number;
  max: number;
  min: number;
  sid: string;
}

export interface DomainFilterTopCategory {
  count: number;
  filterMiddleCategories: DomainFilterMiddleCategory[];
  id: number;
  name: string;
}

export interface DomainFindMaxDiscountCouponResponse {
  discountAmount?: number;
}

export interface DomainFindOrdersForReviewResponse {
  /** @example true */
  hasNext: boolean;
  orderItems?: DomainOrderItemReviewDto[];
}

export interface DomainGenderWearFilter {
  filterGenderWearItems: DomainFilterGenderWearItem[];
}

export type DomainGenderWearType =
  | 'MARKET-ITEM_GENDERWEAR_WOMEN'
  | 'MARKET-ITEM_GENDERWEAR_MEN'
  | 'MARKET-ITEM_GENDERWEAR_GIRL'
  | 'MARKET-ITEM_GENDERWEAR_BOY'
  | 'MARKET-ITEM_GENDERWEAR_UNISEX'
  | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX';

export interface DomainGetBankAccountInfoResponse {
  /** 판매자 예금주명 */
  accountHolder: string;
  /** 판매자 계좌번호 */
  accountNumber: string;
  bankName: string;
}

export interface DomainGetBrandAuthenticityTipsResponse {
  /** 체크리스트 목록 */
  checkLists?: DomainBrandAuthenticityTipResponse[];
}

export interface DomainGetBrandTagResponse {
  brandTag?: DomainBrandTagDto;
}

export interface DomainGetCommunityPostResponse {
  /**
   * 게시판 종류
   * @example "VINTAGE_SHOP_RECOMMENDATION"
   */
  board?: DomainCommunityBoard;
  /**
   * 댓글 수
   * @example 2
   */
  commentCount?: number;
  /**
   * 게시글 내용
   * @example "Test Content 👍"
   */
  content?: string;
  /**
   * 게시글 작성일시
   * @example "2024-04-05T04:24:25.966Z"
   */
  createdAt?: string;
  /**
   * 게시글 이미지 URL 목록
   * @example ["https://test.com/test1.jpg","https://test.com/test2.jpg"]
   */
  imageURLs?: string[];
  /**
   * 현재 사용자가 해당 게시글에 좋아요를 눌렀는지 여부
   * @example true
   */
  isLiked?: boolean;
  /**
   * 좋아요 수
   * @example 10
   */
  likeCount?: number;
  /** 게시글에 등록된 중고마켓 아이템 목록 */
  marketItems?: DomainCommunityPostMarketItemResponse[];
  /**
   * 게시글 ID
   * @example 100
   */
  postID?: number;
  /**
   * 게시글 제목
   * @example "Test Title"
   */
  title?: string;
  /** 게시글을 작성한 사용자 정보 */
  user?: DomainCommunityUserResponse;
}

export interface DomainGetCouponResponse {
  coupon: DomainCouponItem;
}

export interface DomainGetMarketItemEditableResponse {
  editable: boolean;
  message?: string;
}

export interface DomainGetMarketItemResponse {
  /**
   * 평균 주문확정부터 배송시작까지 걸리는 일수
   * @example 2
   */
  avgDaysFromOrderConfirmToShipStart?: number;
  /**
   * 해당 중고 물품에 북마크 한 수
   * @example 1
   */
  bookmarkCount: number;
  bottomTotalLength?: number;
  bottomWaist?: number;
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /** @example 1 */
  brandTagID: number;
  /**
   * 중고 아이템 구매자 유저 ID
   * @example 22612346
   */
  buyerID?: number;
  /** @example 52 */
  categoryID: number;
  /** @example 2626123 */
  clothesID?: number;
  /**
   * 중고 아이템의 색상 ID 리스트
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 중고 아이템 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 중고 아이템 생성일
   * @example 1668080178342
   */
  createDate: number;
  /**
   * TODO: 아래필드는 삭제 예정 (4.4.0) <-- 진짜 삭제하는지 확인
   * @example "KRW"
   */
  currency: string;
  cursor?: string;
  /**
   * 중고 아이템 설명
   * @example "사실 2년 입었어유"
   */
  description: string;
  /** 할인정보 추가 */
  discountNotification?: DomainDiscountNotification;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  /** @example "MARKET-ITEM_FABRIC_COTTON" */
  fabric: string;
  fabrics: string[];
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  /**
   * 중고 아이템 성별
   * @example "MARKET-ITEM_GENDERWEAR_MAN"
   */
  genderWear:
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_GIRL';
  /** 중고 아이템 이미지 리스트 */
  images: DomainMarketItemImageResponse[];
  /** @example false */
  isBookmarked: boolean;
  /**
   * 중고 아이템 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /** 마켓아이템 상세에서 해당 마켓아이템이 장바구니에 담겼는지 확인 */
  isOnCart: boolean;
  /**
   * 프로셀러 여부
   * @example true
   */
  isProSeller: boolean;
  /** 비슷한 상품 여부 */
  isSimilar?: boolean;
  /**
   * 지점명 노출 여부
   * @example true
   */
  isVisible: boolean;
  /**
   * Looko AI 상품 코드
   * @example "1234567890"
   */
  itemCode: string;
  /**
   * 중고 아이템 검색 키워드
   * @example ["흰색","티셔츠","남성"]
   */
  keywords: string[];
  logixID: number;
  /**
   * 공급사명(지점명)
   * @example "공급사 없음"
   */
  logixName: string;
  /** 배송정책 */
  logixPolicy: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  /**
   * 셀러의 판매중인 상품 수
   * @example 1
   */
  marketItemCount?: number;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 조회수
   * @example 1
   */
  marketItemView?: number;
  /**
   * 프로셀러인 경우만 노출되며, 일반 셀러인 경우 0으로 내려감
   * @example 1000
   */
  minOrderAmountForOffer: number;
  /**
   * 중고 아이템 수정일
   * @example 1668080178342
   */
  modifyDate: number;
  /**
   * 로그인 한 유저가 작성한 리뷰가 있을 경우 해당 ReviewID
   * @example 1
   */
  myReviewID?: number;
  /**
   * 판매자 닉네임
   * @example "nickname"
   */
  nickname?: string;
  /**
   * 공식 브랜드 ID
   * @example [1]
   */
  officialBrandIDs: number[];
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  priceModificationHistories?: DomainMarketItemPriceHistoryResponse[];
  /**
   * 판매자 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  profileImageURL?: string;
  /**
   * 중고 아이템의 상태 (깨끗함, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  score: number;
  /**
   * 마켓아이템이 속한 카테고리
   * @example [1,2,3]
   */
  setupCategoryIDs: number[];
  shoeSize?: number;
  /**
   * 중고 옷 사이즈
   * @example "FREE"
   */
  size: string;
  sizeForDisplay?: DomainSizeForDisplay;
  /** @example 1 */
  sizeID?: number;
  /** @example "kr" */
  sizeRegion?: 'it' | ' kr' | 'us' | ' uk' | ' eu';
  /** 중고 아이템 판매 상태 */
  status: DomainMarketItemStatus;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
  /**
   * 중고 아이템 제목
   * @example "새것 같은 노스페이스 패딩 팔아유"
   */
  title: string;
  topChest?: number;
  topShoulder?: number;
  topSleeveLength?: number;
  topTotalLength?: number;
  /**
   * 거래 희망 지역 // TODO 4.4.0 삭제 예정
   * @example "MARKET-ITEM_TRADE-REGION_LOCAL,MARKET-ITEM_TRADE-REGION_GLOBAL"
   */
  tradeRegion: string;
  /**
   * 중고 아이템 판매자 유저 ID
   * @example 22612346
   */
  userID: number;
  /** Deprecated: 6.7.0 이후 삭제 와우 할인가 */
  wowDiscountAmount?: number;
}

export interface DomainGetMarketItemReviewResponse {
  /**
   * 리뷰 내용
   * @example "1시간 늦게 나왔네요"
   */
  comment: string;
  /**
   * 리뷰 답글
   * @example "1시간 늦게 나왔네요"
   */
  commentReply: string;
  /**
   * 리뷰 답글 작성일시
   * @example "2021-08-10T00:00:00Z"
   */
  commentReplyDate?: string;
  /**
   * 리뷰 생성일시 timestamp
   * @example 1668080178342
   */
  createDate: number;
  /** 리뷰 이미지 */
  images: DomainMarketItemReviewImageResponse[];
  /**
   * 리뷰 수정 여부
   * @example true
   */
  isModified: boolean;
  /**
   * 리뷰를 하는 사람의 회원 탈퇴 여부
   * @example true
   */
  isReviewerDeleted: boolean;
  /**
   * 리뷰와 연결된 중고 ID
   * @example 125156
   */
  marketItemID: number;
  /**
   * 해당 리뷰에 로그인 한 유저가 답 리뷰를 남겼을 경우 해당 리뷰 ID (없는 경우 null)
   * @example 125125
   */
  myReviewID?: number;
  /**
   * 결제 타입
   * @example "ONLINE"
   */
  paymentType: DomainPaymentType;
  /**
   * 리뷰 평점
   * @example 0.5
   */
  rating: number;
  /**
   * 리뷰 ID (PK)
   * @example 24521
   */
  reviewID: number;
  /** 컨디션 태그 */
  reviewTags: DomainMarketItemReviewTag[];
  /**
   * 리뷰 종류 (구매/판매)
   * @example "MARKET-ITEM_REVIEW-TYPE_SELLING"
   */
  reviewType: 'MARKET-ITEM_REVIEW-TYPE_SELLING' | 'MARKET-ITEM_REVIEW-TYPE_BUYING';
  /** 리뷰를 받는 사람 */
  reviewee: DomainReviewUserResponse;
  /** 리뷰를 하는 사람 */
  reviewer: DomainReviewUserResponse;
  /** 배달 태그 */
  sizeTags: DomainMarketItemReviewSizeTag[];
  /**
   * 리뷰 상태
   * @example "MARKET-ITEM-REVIEW_INSPECTION_REJECTED"
   */
  status:
    | 'MARKET-ITEM-REVIEW_INSPECTION_PENDING'
    | 'MARKET-ITEM-REVIEW_INSPECTION_APPROVED'
    | 'MARKET-ITEM-REVIEW_INSPECTION_REJECTED';
  /** 컬러 태그 */
  treasureTags: DomainMarketItemReviewTreasureTag[];
}

export interface DomainGetMarketItemStatisticsResponse {
  /**
   * 프로셀러 수
   * @example 10
   */
  prosellerCount: number;
  /**
   * 총 마켓 아이템 수
   * @example 100
   */
  totalMarketItemCount: number;
  /** 주간 마켓 아이템 수 */
  weeklyMarketItemCount: DomainCountWeeklyMarketItemResponse;
}

export interface DomainGetMyInformationPortoneCIResponse {
  /** 첫 구매 혜택 만료일 */
  firstPurchaseBenefitExpireDate: string;
  /** 첫 구매 혜택 수령 여부 */
  firstPurchaseBenefitReceived: boolean;
  /** Portone CI 보유 여부 */
  hasPortoneCI: boolean;
  /** 상품 업로드 차단 여부 */
  productUploadBlocked: boolean;
}

export interface DomainGetMyInformationResponse {
  accountHolder?: string;
  accountNumber?: string;
  /**
   * 배경 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  backgroundImageURL?: string;
  bankName?: string;
  /**
   * 자기 소개
   * @example "Hello!"
   */
  bio?: string;
  /**
   * 생년월일
   * @example "2023-01-01"
   */
  birth: string;
  /**
   * 클라이언트 설정
   * @example "{isFirst:false}"
   */
  clientConfig?: string;
  /**
   * 댓글 알림 수신 여부
   * @example true
   */
  commentNotificationAgreed: boolean;
  /**
   * 라운지 알림: 내 게시글에 새로운 댓글이 달렸을 때
   * @example true
   */
  communityCommentNotifAgreed?: boolean;
  /**
   * 라운지 알림: 댓글을 단 글에 새로운 댓글이 달렸을 때
   * @example true
   */
  communityCommentOnNotifAgreed?: boolean;
  /**
   * 라운지 알림: 내 게시글에 좋아요가 눌렸을 때
   * @example true
   */
  communityLikeNotifAgreed?: boolean;
  /**
   * 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 쿠폰 만료 알림
   * @example true
   */
  couponExpiredNotificationAgreed?: boolean;
  /**
   * 코디 추천 독려 알림 수신 여부
   * @example true
   */
  createClothesEncouragementNotificationAgreed: boolean;
  /**
   * 통화
   * @example "KRW"
   */
  currency: string;
  /**
   * 국가 전화번호
   * @example "+82"
   */
  dialingCode?: string;
  /**
   * 접속 정보(GOOGLE, KAKAO ...)
   * @example "GOOGLE"
   */
  division?: string;
  /**
   * 이메일
   * @example "example@gmail.com"
   */
  email?: string;
  /**
   * 환율
   * @example 1
   */
  exchangeRate: number;
  /**
   * 팔로우 알림 수신 여부
   * @example true
   */
  followNotificationAgreed: boolean;
  /**
   * 성별
   * @example "MALE"
   */
  gender: string;
  /**
   * 키
   * @example 180.1
   */
  height?: number;
  /**
   * 계정 밴 여부
   * @example false
   */
  isBanned: boolean;
  /**
   * 게스트 여부
   * @example false
   */
  isGuest: boolean;
  /**
   * 포토네 인증 여부
   * @example false
   */
  isPortoneVerified: boolean;
  /**
   * 해당 유저가 파워셀러인지 여부
   * @example false
   */
  isProSeller: boolean;
  /**
   * 인증 여부 Deprecated 4.1.0
   * @example false
   */
  isVerified: boolean;
  /**
   * 언어 코드
   * @example "ko"
   */
  language: string;
  /**
   * 알림 관련 필드
   * @example true
   */
  likeNotificationAgreed: boolean;
  /**
   * 링크
   * @example "https://www.link.com/chicken/"
   */
  link?: string;
  /**
   * 마켓 아이템 북마크 알림 수신 여부
   * @example true
   */
  marketItemBookmarkNotificationAgreed: boolean;
  /** @example true */
  marketItemChattingPushNotificationAgreed: boolean;
  /** @example true */
  marketItemDiscountPushNotificationAgreed: boolean;
  /**
   * 가격 제안 알림 수신 여부
   * @example true
   */
  marketItemPriceOfferNotificationAgreed: boolean;
  /**
   * 마켓 아이템 리뷰 알림 수신 여부
   * @example true
   */
  marketItemReviewNotificationAgreed: boolean;
  /**
   * 휴대폰 번호
   * @example "01012345678"
   */
  mobile?: string;
  /**
   * 유저 이름
   * @example "홍길동"
   */
  name?: string;
  /**
   * 북마크한 유저의 새로운 중고 아이템 알림 수신 여부
   * @example true
   */
  newMarketItemFromBookmarkedSellerNotificationAgreed: boolean;
  /**
   * 닉네임
   * @example "hkja1"
   */
  nickname: string;
  /**
   * 계정 비공개 여부
   * @example false
   */
  outfitPrivacy: boolean;
  /** Deprecated: 선호 옷장 */
  prefClosets: DomainPrefClosets;
  proSellerInfo?: DomainProSellerInfo;
  /**
   * 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  profileImageURL?: string;
  /**
   * '배송 중' 도달 120 시간 이후 리뷰 작성 독려 푸시 알림 허용(수정 안할 시 null)
   * @example true
   */
  reviewPushNotificationAgreed: boolean;
  /**
   * 코디 추천 온도감(-2: 더 따뜻하게 입을래요, -1: 조금 따뜻하게 입을래요, 0: 적당해요, 1: 조금 시원하게 입을래요, 2: 더 시원하게 입을래요)
   * @example 0
   */
  tempSenseLevel: number;
  /** @example true */
  transactionPushNotificationAgreed: boolean;
  /**
   * 업데이트 알림 수신 여부
   * @example true
   */
  updateNotificationAgreed: boolean;
  /**
   * 에이클로젯 업데이트 알림 동의 날짜
   * @example 100030
   */
  updateNotificationAgreedDate?: number;
  /** 사용자 AB */
  userABTest: DomainUserABTest;
  /**
   * 유저 아이디
   * @example 620687
   */
  userID: number;
  /**
   * 회원가입 시 division 에 따라 배정되는 유니크한 유저 이름
   * @example "safasdf"
   */
  username: string;
  /**
   * 몸무게
   * @example 70.1
   */
  weight?: number;
}

export interface DomainGetOfficialBrandResponse {
  officialBrand?: DomainOfficialBrandDto;
}

export interface DomainGetOfficialBrandStatisticsResponse {
  officialBrandsSortedByBookmarkedCount: DomainOfficialBrandsSortedByBookmarkedCountResponse[];
}

export interface DomainGetOrderByImpUIDResponse {
  isCartPayment?: boolean;
  success?: boolean;
  txID?: number;
}

export interface DomainGetOrderItemTooltipResponse {
  shouldDisplayTooltip?: boolean;
}

export interface DomainGetOrderPolicyResponse {
  pgFeeRate: number;
}

export interface DomainGetOrderResponse {
  /** 수수료 */
  agentFee: number;
  /** 수수료 할인 금액 */
  agentFeeDiscount: number;
  /** 수수료 할인 타입 */
  agentFeeDiscountType: string;
  /** 상품 금액 */
  amount: number;
  /** 구매자 ID */
  buyerID: number;
  /** 구매자 닉네임, snapshot */
  buyerNickname: string;
  /** 최종 환불금액 내역 */
  cancelAmount?: number;
  /** 쿠폰 할인 금액 */
  couponDiscountAmount: number;
  /** 쿠폰 */
  couponItem?: DomainCouponItem;
  /** 거래생성일 */
  createDate: string;
  /** 거래생성 unix timestamp */
  createdAt: number;
  /** 주문 */
  details: DomainOrderItemDetailDto[];
  /** 정산 예정 금액 */
  expectedSettlementAmount: number;
  /** 주문 ID */
  id: number;
  /** 구매자 탈퇴 여부 */
  isDeleteBuyer: boolean;
  /** 판매자 탈퇴 여부 */
  isDeleteSeller: boolean;
  /** 첫 구매 혜택 적용 여부 */
  isFirstOrder: boolean;
  /** 가격 제안 여부 */
  isPriceOffered: boolean;
  /** 프로셀러 여부 */
  isProSeller: boolean;
  /** 시간 조정 여부 */
  isTimeAdjusted: boolean;
  /** 상세주소 */
  logixAdditionalAddress: string;
  /** 주소 */
  logixAddress: string;
  /** 배송 메모 */
  logixMemo: string;
  /** 수령인 이름 */
  logixName: string;
  /** 수령인 전화번호 */
  logixPhone: string;
  /** 배송비 (실제) */
  logixPrice: number;
  /** 지역별 배송비 타입 일반, 제주, 도서산간 */
  logixPriceType: DomainLogixPriceType;
  /** 배송비 유형 */
  logixType: DomainLogixType;
  /** 우편번호 */
  logixZoneCode: string;
  /** 총 제안 가격 */
  offerAmount: number;
  /** 결제 금액 */
  paidAmount: number;
  /** 결제 정보 */
  paidAt: number;
  paidDueDate: string;
  /** 결제 요청 수단 */
  payMethod: DomainPayMethod;
  /** 매장 결제 여부 */
  paymentType?: DomainPaymentType;
  /** PG수수료 */
  pgCommissionFee: number;
  /** 포인트 할인 금액 */
  pointDiscountAmount: number;
  /** 환불 차감 쿠폰 금액 */
  refundDeductionCouponAmount?: number;
  /** 환불 차감 배송비 */
  refundDeductionLogixAmount?: number;
  /** 환불 차감 반품 배송비 */
  refundDeductionLogixReturnAmount?: number;
  /** 환불 차감 포인트 금액 */
  refundDeductionPointAmount?: number;
  /** 환불 차감 금액 */
  refundDeductionTotalAmount?: number;
  /** 환불 수단 */
  refundPayMethod?: DomainPayMethod;
  refundPending?: boolean;
  /** 환불 정책 */
  refundPolicy: string;
  /** 환불 금액 */
  returnAmount?: number;
  /** 반품 택배사 */
  returnCourierName: string;
  /** 반품 방법 */
  returnLogixType: DomainRefundLogixType;
  /** 반품 가능 여부 */
  returnable?: boolean;
  /** 판매자가 구매자 주소 확인 할 수 있는 여부 */
  sellerAddrIsShow: boolean;
  /** 판매자 ID */
  sellerID: number;
  /** 판매자 닉네임, snapshot */
  sellerNickname: string;
  /** 판매자 연락처 */
  sellerNumber: string;
  /** 주문 제목 (5.10.0 기준 가격 제안일 경우에만 사용) */
  title: string;
  /** 계좌번호 */
  virtualAccountNumber?: string;
  /** 은행 코드 */
  virtualBankCode?: string;
  /** 은행명 */
  virtualBankName?: string;
}

export interface DomainGetOrderReturnItemResponse {
  /** 메모 */
  address?: string;
  /** 상세주소 */
  addressDetails?: string;
  /** 첫 주문 여부 */
  isFirstOrder?: boolean;
  /** 첫 주문 반품 여부 */
  isFirstOrderReturn?: boolean;
  /** 반품 재신청 여부 */
  isReturnReRequested?: boolean;
  /** 반품 배송비 */
  logixReturnPrice?: number;
  marketItemID?: number;
  marketItemPrice?: number;
  marketItemThumbnail?: string;
  marketItemTitle?: string;
  /** 수거해주세요, 직접 보낼게요 */
  method?: DomainRefundLogixType;
  /** 수거 정보의 사람 이름 */
  name?: string;
  /** 연락처 */
  phone?: string;
  /** 포토? */
  photos?: string[];
  /** 메모 */
  proSellerAddress?: string;
  /** 상세주소 */
  proSellerAddressDetails?: string;
  /** 수거 정보의 사람 이름 */
  proSellerName?: string;
  /** 연락처 */
  proSellerPhone?: string;
  /** 우편번호 */
  proSellerZipCode?: string;
  reasonDetail?: string;
  reasonTags?: DomainReturnReasonTagType[];
  reasonType?: DomainRefundReason;
  /** 반품 거부 사유 */
  rejectReason?: DomainOrderReturnRejectReason;
  /** 반품 거부 상세 사유 */
  rejectReasonDetails?: string;
  /** 반품 요청일 */
  returnDate?: number;
  status?: DomainOrderStatus;
  /** 우편번호 */
  zipCode?: string;
}

export interface DomainGetPaymentInfoRequest {
  couponID?: number;
  /**
   * 주문할 상품 목록입니다. 일반적인 주문일 경우에는 필수로 보내야 합니다.
   * @example [1,2,3,4]
   */
  marketItemIDs?: number[];
  /** 가격 제안 시 사용 */
  marketItemPriceOffers?: DomainMarketItemPriceOffer[];
  /**
   * Deprecated
   * @example 10000
   */
  payAmount?: number;
  /** Deprecated */
  sellerID?: number;
  zonecode?: string;
}

export interface DomainGetPaymentInfoResponse {
  agentFee: number;
  agentFeeDiscount: number;
  agentFeeDiscountType: string;
  amount: number;
  availableRewardPoint: number;
  couponDiscountAmount: number;
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  isFirstOrder: boolean;
  logixInfo: DomainLogixPrice;
  logixPrice: number;
  logixPriceType: DomainLogixPriceType;
  logixType: DomainLogixType;
  marketItemCount: number;
  marketItemPrice: number;
  marketItemRegularPrice: number;
  marketItemSalePrice: number;
  offerPrice: number;
  proSellerLogixPrice: number;
  proSellerLogixType: DomainLogixType;
  proSellerLogixTypeFreeOnAmount: number;
  /** @example true */
  shouldDisplayToolTip: boolean;
  totalRewardPoint: number;
}

export interface DomainGetProSellerAdditionalInformationResponse {
  /** 해당 유저의 파워셀러 정보 */
  proSellerInfo?: DomainProSellerInfo;
  proSellerLogixes?: DomainProSellerLogixDTO[];
  /** 주력 브랜드 */
  topBrands: DomainOfficialBrandDto[];
  /**
   * 유저 아이디
   * @example 620687
   */
  userID: number;
}

export interface DomainGetProSellerLogixInfoForLookoAIResponse {
  /** CS 담당 연락처 */
  afterServicePhoneNumber: string;
  /** 택배사 */
  courierCompany: string;
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeOnAmount: number;
  /** 기본 배송지 여부 */
  isDefault: boolean;
  /** 공급사명 노출 여부 */
  isVisible: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea: boolean;
  /** 배송정보 ID */
  logixID: number;
  /** 공급사명(지점명) */
  logixName: string;
  /** 배송 정책 */
  logixPolicy: string;
  /** 배송비 */
  logixPrice: DomainLogixPrice;
  /** 배송 타입 */
  logixType: DomainLogixType;
  /** 프로 셀러 ID */
  proSellerID: number;
  /** 최대 구매 수량 */
  purchaseQuantity: number;
  /** 수거 방법 */
  refundLogixType: DomainRefundLogixType;
  /** 반품 주소 */
  returnAddress: string;
  /** 반품 상세 주소 */
  returnAddressDetail: string;
  /** 반품 배송비 */
  returnFee: number;
  /** 반품 이름 */
  returnName?: string;
  /** 반품 정책 */
  returnPolicy: string;
  /** 반품 우편 번호 */
  returnZipCode: string;
}

export interface DomainGetProSellerServiceScoreForLookoAIResponse {
  /** 리뷰 점수 */
  aclosetReviewRating?: DomainAclosetReviewRating;
  /** 주문취소 점수 */
  cancelOrderRate?: DomainCancelOrderRate;
  /** 고객 리뷰 목록 */
  customerReviewRates?: DomainCustomerReviewRate[];
  /** 반품처리 점수 */
  returnProcessingDay?: DomainReturnProcessingDay;
  /** 반품사유 목록 */
  returnReasonRates?: DomainReturnReasonRate[];
  /** 배송시작 점수 */
  shipStartOrderRate?: DomainShipStartOrderRate;
}

export interface DomainGetProSellerServiceScoreResponse {
  /** 리뷰 점수 */
  aclosetReviewRating?: DomainAclosetReviewRating;
  /** 주문취소 점수 */
  cancelOrderRate?: DomainCancelOrderRate;
  /** 고객 리뷰 목록 */
  customerReviewRates?: DomainCustomerReviewRate[];
  /** 반품처리 점수 */
  returnProcessingDay?: DomainReturnProcessingDay;
  /** 반품사유 목록 */
  returnReasonRates?: DomainReturnReasonRate[];
  /** 배송시작 점수 */
  shipStartOrderRate?: DomainShipStartOrderRate;
}

export interface DomainGetRecentShippingAddressResponse {
  additionalAddress: string;
  address: string;
  memo?: string;
  name: string;
  phone: string;
  zoneCode: string;
}

export interface DomainGetRewardPointPolicyResponse {
  /** 사진 리뷰시 적립금 */
  addPhoto?: number;
  /** 텍스트 리뷰시 적립금 */
  addText?: number;
  /** 기본 적립금 */
  basic?: number;
  /** 최대로 받을 수 있는 적립금 정책 */
  maximumRewardPointPolicy?: DomainMaximumRewardPointPolicyDto;
  /** 총 적립금 */
  total?: number;
}

export interface DomainGetRewardPointSummaryResponse {
  /** @example 1000 */
  maximumExpectedRewardPoint: number;
  /**
   * 최근 구매한 상품 개수
   * @example 5
   */
  recentMarketItemCount: number;
  /** 최근 구매한 상품 이미지 */
  recentMarketItemImages: string[];
  /** @example 0 */
  saveAwaitedRewardPoint: number;
  /** @example true */
  shouldDisplayToolTip: boolean;
  /** @example 3000 */
  totalSavedPoint: number;
}

export interface DomainGetSendbirdTokenResponse {
  /**
   * Sendbird 유저토큰 (만료기한 X)
   * @example "b057f665-c2b7-4a19-9fe4-cebf5fbb5159"
   */
  accessToken: string;
  /**
   * 유저 ID
   * @example 183831
   */
  userID: number;
}

export interface DomainGetSettlementAmountResponse {
  /** 정산예정 대상금액 (구매확정금액) */
  amount: number;
  /** 정산완료 금액 */
  completedAmount: number;
  /** 정산보류 금액 */
  holdAmount: number;
  /** PG 수수료 */
  pgFee: number;
  /** 정산예정 금액 */
  scheduledAmount: number;
  /** 최종 정산 금액 (수수료 제외) */
  sellerAmount: number;
  /** 미정산 금액 */
  unauditedAmount: number;
}

export interface DomainGetSurveyRequiredReturnOrderItemResponse {
  buyerNickname?: string;
  createDate?: string;
  marketItemThumbnail?: string;
  marketItemTitle?: string;
  orderID?: number;
  processedDate?: string;
  reason?: DomainRefundReason;
  reasonDetails?: string;
  reasonTags?: string[];
  reasonType?: DomainOrderReturnReasonType;
  sellerName?: string;
}

export interface DomainGetUserMarketItemReviewScoreResponse {
  averageReviewRate?: number;
  customerReviewRates?: DomainCustomerReviewRate[];
  totalReviewCount?: number;
  treasureReviewCount?: number;
}

export interface DomainGetUserPreferenceResponse {
  birth: string;
  bottomWaistSizes?: string[];
  brandTagIDs?: number[];
  genderWear: DomainUserPreferenceGenderWearType;
  height?: number;
  shoeSizes?: number[];
  shoppingTypes?: DomainShoppingType[];
  topChestMax?: number;
  topChestMin?: number;
  /** 5.13.0 Deprecated. 구 버전 호환성 */
  topClothesSizes?: string[];
  userID: number;
  weight?: number;
}

export interface DomainGetUserPreferenceSizesResponse {
  bottomSizes?: DomainUserPreferenceBottomSize[];
  shoeSizes?: DomainUserPreferenceShoeSize[];
  topSizes?: DomainUserPreferenceTopSize[];
}

export interface DomainGetUserProfileResponse {
  /**
   * 배경 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  backgroundImageURL?: string;
  /**
   * 자기 소개
   * @example "Hello!"
   */
  bio?: string;
  /**
   * 국가
   * @example "KR"
   */
  countryCode: string;
  /**
   * 쿠폰 만료 알림
   * @example true
   */
  couponExpiredNotificationAgreed?: boolean;
  /**
   * 팔로워 수
   * @example 1
   */
  followerCount: number;
  /**
   * 팔로잉 수
   * @example 1
   */
  followingCount: number;
  /**
   * 로그인 한 유저가 해당 유저를 차단했는지 여부
   * @example false
   */
  isBanned: boolean;
  /**
   * 조회한 유저 기준 팔로우 여부
   * @example true
   */
  isFollowing: boolean;
  /**
   * 해당 유저가 판매/구매한 물품이 있었는지 여부
   * @example false
   */
  isMarketUser: boolean;
  /**
   * 해당 유저가 파워셀러인지 여부
   * @example false
   */
  isProSeller: boolean;
  /** 가장 최근 할인 날짜 */
  lastDiscountPriceModifyDate?: string;
  /**
   * Deprecated: 좋아요 수
   * @example 1
   */
  likeCount: number;
  /**
   * 링크
   * @example "https://www.link.com/chicken/"
   */
  link?: string;
  /**
   * 판매/구매한 물품 수
   * @example 1
   */
  marketItemCount: number;
  /**
   * 닉네임
   * @example "hkja1"
   */
  nickname: string;
  /**
   * 코디 나만 보기 모드
   * @example false
   */
  outfitPrivacy: boolean;
  /** 해당 유저의 파워셀러 정보 */
  proSellerInfo?: DomainProSellerInfo;
  proSellerLogixes?: DomainProSellerLogixDTO[];
  /**
   * 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  profileImageURL?: string;
  /** 프로셀러 키워드 */
  prosellerKeywords?: string[];
  /** 판매중인 아이템 수 (DiscountPriceModifyDateStart, DiscountPriceModifyDateEnd 가 있으면 할인하는 아이템 노출) */
  remainingMarketItemCount: number;
  /**
   * 받은 리뷰 수
   * @example 1
   */
  reviewCount: number;
  /**
   * 받은 리뷰 평점
   * @example 4.5
   */
  reviewScore: number;
  /** @example true */
  sellerNotificationAgreed: boolean;
  /** 아이템 총 갯수 (DiscountPriceModifyDateStart, DiscountPriceModifyDateEnd 가 있으면 할인하는 아이템 노출) */
  totalMarketItemCount: number;
  /**
   * 유저 아이디
   * @example 620687
   */
  userID: number;
}

export interface DomainGetWishlistResponse {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 필터에 대한 설명
   * @example "1000~50000, ZARA, 남자, 옷파는야옹이, 파란색"
   */
  description?: string;
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 null 로 반환함.
   * @example 40000
   */
  discountPriceMax?: number;
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 null 로 반환함.
   * @example 1000
   */
  discountPriceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example ["MARKET-ITEM_GENDERWEAR_MEN","MARKET-ITEM_GENDERWEAR_WOMEN"]
   */
  genderWears?: DomainGenderWearType[];
  /**
   * 알람 여부
   * @example true
   */
  isNotification: boolean;
  /**
   * 새로 생성된 아이템을 확인했는지 여부 (true: 확인함, false: 확인하지 않음)
   * @example true
   */
  isSeen: boolean;
  /**
   * 빈 문자열은 안됨. 글자수 제한 없음
   * @example "스포츠 관심상품"
   */
  name: string;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /**
   * Deprecated: 1,000원 단위 필터를 사용하지 않는 경우 null 로 반환함.
   * @example 40000
   */
  priceMax?: number;
  /**
   * Deprecated: 1,000원 단위 필터를 사용하지 않는 경우 null 로 반환함.
   * @example 1000
   */
  priceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  sellerIDs?: number[];
  /** @example 1 */
  shoeSizeMax?: number;
  /** @example 1 */
  shoeSizeMin?: number;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example "나이키 집업"
   */
  textSearch?: string;
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
  /** @example 1 */
  userID: number;
  /** @example 1 */
  wishlistID: number;
}

export type DomainInitialPriceType = 'initial' | 'edited';

export type DomainKeywordsType =
  | 'PROSELLER-INFO_KEYWORDS-TYPE_VINTAGE'
  | 'PROSELLER-INFO_KEYWORDS-TYPE_BASIC'
  | 'PROSELLER-INFO_KEYWORDS-TYPE_CLASSIC'
  | 'PROSELLER-INFO_KEYWORDS-TYPE_FUNKY'
  | 'PROSELLER-INFO_KEYWORDS-TYPE_CASUAL'
  | 'PROSELLER-INFO_KEYWORDS-TYPE_STREET'
  | 'PROSELLER-INFO_KEYWORDS-TYPE_FEMININE'
  | 'PROSELLER-INFO_KEYWORDS-TYPE_SPORTY'
  | 'PROSELLER-INFO_KEYWORDS-TYPE_MILITARY';

export interface DomainListApplicableCouponsResponse {
  coupons: DomainCouponItem[];
}

export interface DomainListAppliedCouponsResponse {
  coupons: DomainCouponItem[];
}

export interface DomainListAvailableCouponsResponse {
  coupons: DomainCouponItem[];
  maxDiscountAmount?: number;
  storeCoupons: DomainStoreCouponItem[];
}

export interface DomainListBookmarkMarketItemsSellerResponse {
  sellers: DomainProSellerUserItem[];
}

export interface DomainListBrandsResponse {
  brands?: DomainBrandDto[];
  hasNext?: boolean;
}

export interface DomainListCartsResponse {
  sellers: DomainListCartsSellerDto[];
}

export interface DomainListCartsSellerDto {
  /** 찜한 상품 */
  bookmarkedMarketItems?: DomainMarketItemResponse[];
  isOfficiallyEntered: boolean;
  isProSeller: boolean;
  isVisible: boolean;
  logixID: number;
  logixName: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  logixTypeFreeOnAmount: number;
  logixTypePayOnQuantity: number;
  marketItems?: DomainListCartsSellerMarketItemDto[];
  minOrderAmountForOffer: number;
  nickname: string;
  /** 찜하지 않은 상품 */
  notBookmarkedMarketItems?: DomainMarketItemResponse[];
  purchaseQuantityLimit: number;
  thumbnailURL: string;
  userID: number;
}

export interface DomainListCartsSellerMarketItemDto {
  brand: string;
  cartCount: number;
  discountPrice: number;
  isDelete: boolean;
  mainMarketItems: DomainMarketItemResponse[];
  marketItemID: number;
  otherMarketItems: DomainMarketItemResponse[];
  /** Deprecated 구클라 대응 - 5.17.0 부터 사용하지 않음 */
  price: number;
  regularPrice: number;
  status: DomainMarketItemStatus;
  thumbnailURL: string;
  title: string;
}

export interface DomainListCategoryPropertiesResponse {
  categories?: DomainCategoryHierarchyWithGenderWear[];
}

export interface DomainListChatRoomsResponse {
  /** 페이지네이션 정보 */
  pagination?: DomainCursorPaginationResponse;
  /** 채팅방 목록 */
  rooms?: DomainChatRoomResponse[];
}

export interface DomainListChatsResponse {
  /** 채팅 목록 */
  chats?: DomainChatResponse[];
  /** 페이지네이션 정보 */
  pagination: DomainCursorPaginationResponse;
}

export interface DomainListClothesDetectionsResponse {
  /** 분석 결과 */
  results?: DomainClothesDetectionResult[];
}

export interface DomainListClothesSizesResponse {
  categoryGroups: DomainCategoryGroup[];
  sizes: DomainSize[];
  /** 사이즈 번역 (For Girls on Boys) */
  translations: DomainTranslation[];
}

export interface DomainListCommunityPostCommentsResponse {
  /** 댓글 목록 */
  comments?: DomainCommunityPostCommentResponse[];
  /** 다음 페이지 존재 여부 */
  hasNext?: boolean;
  /** 다음 페이지 조회를 위한 커서 값 */
  nextCursor?: string;
}

export interface DomainListCommunityPostsResponse {
  /** 다음 페이지 존재 여부 */
  hasNext?: boolean;
  /** 다음 페이지 조회를 위한 커서 값 */
  nextCursor?: string;
  /** 게시글 목록 */
  posts?: DomainCommunityPostResponse[];
}

export interface DomainListCouponsForLookoAIResponse {
  coupons: DomainCouponItemForLookoAI[];
  /** 페이징 정보 */
  pagination?: DomainPaginationResponse;
}

export interface DomainListDiscountProSellerUsersResponse {
  hasNext?: boolean;
  proSellerUserItems?: DomainDiscountProSellerUserItem[];
}

export interface DomainListFilterMarketItemCountsResponse {
  brandFilter: DomainBrandFilter;
  categoryFilter: DomainCategoryFilter;
  colorFilter: DomainColorFilter;
  discountPriceFilter: DomainDiscountPriceFilter;
  fabricFilter: DomainFabricFilter;
  genderWearFilter: DomainGenderWearFilter;
  patternFilter: DomainPatternFilter;
  sizeLengthFilter: DomainSizeLengthFilter;
  totalItemCount: number;
}

export interface DomainListFollowingsMarketItemsResponse {
  /**
   * 다음 페이지가 있는지 여부
   * @example true
   */
  hasNext: boolean;
  marketItems?: DomainMarketItemResponse[];
  sellerIDs?: number[];
}

export interface DomainListFollowingsMarketItemsV2Response {
  marketItems?: DomainMarketItemV2Response[];
  sellerIDs?: number[];
}

export interface DomainListMarketItemBrandsResponse {
  hasNext?: boolean;
  marketItemBrandItems?: DomainMarketItemBrandItem[];
}

export interface DomainListMarketItemChatroomsResponse {
  chatrooms?: DomainMarketItemChatroomResponse[];
}

export interface DomainListMarketItemCoordinatesResponse {
  coordinates: DomainMarketItemCoordinateResponse[];
  /** @example 1 */
  nextCursor: number;
}

export interface DomainListMarketItemCountPerCategoryResponse {
  /** 중분류 카테고리 목록 - TopCategoryID 필드가 있을 경우 반환 */
  middleCategories?: DomainCategoryMarketItemCount[];
  /** 대분류 카테고리 목록 - TopCategoryID 필드가 없을 경우 반환 */
  topCategories?: DomainCategoryMarketItemCount[];
}

export interface DomainListMarketItemDetailsResponse {
  marketItems?: DomainMarketItemDetailResponse[];
}

export interface DomainListMarketItemRealtimeReviewsResponse {
  reviews?: DomainMarketItemRealtimeReviewResponse[];
}

export interface DomainListMarketItemsForCompareSizesResponse {
  marketItems?: DomainMarketItemForCompare[];
}

export interface DomainListMarketItemsMissingLinkResponse {
  marketItems?: DomainMarketItemMissingLink[];
}

export interface DomainListMarketItemsResponse {
  /**
   * 다음 페이지가 있는지 여부
   * @example true
   */
  hasNext: boolean;
  marketItems?: DomainMarketItemResponse[];
}

export interface DomainListMarketItemsV2Response {
  analytics: DomainAmplitudeAnalyticResponse;
  marketItems?: DomainMarketItemV2Response[];
}

export interface DomainListMetadataResponse {
  count: number;
  domains: string[];
  items: DomainMetadataResponse[];
  subDomains: string[];
}

export interface DomainListNewMarketItemWishlistDTO {
  /**
   * 새로 생성된 아이템을 확인했는지 여부 (true: 확인함, false: 확인하지 않음)
   * @example true
   */
  isSeen: boolean;
  /**
   * 새로 생성된 아이템의 ID
   * @example 1
   */
  marketItemID?: number;
  /**
   * 새로 생성된 아이템의 썸네일 URL
   * @example "https://acloset-static.s3.ap-northeast-2.amazonaws.com/..."
   */
  marketItemThumbnailURL: string;
  /**
   * 빈 문자열은 안됨. 글자수 제한 없음
   * @example "스포츠 관심상품"
   */
  name: string;
  /** @example 1 */
  wishlistID: number;
}

export interface DomainListNewMarketItemWishlistsResponse {
  /** @example true */
  hasNext: boolean;
  wishlists?: DomainListNewMarketItemWishlistDTO[];
}

export interface DomainListNotificationsResponse {
  nextCursor?: number;
  notifications?: DomainNotificationResponse[];
}

export interface DomainListOfficialBrandFollowsResponse {
  brandFollows?: DomainOfficialBrandDto[];
}

export interface DomainListOfficialBrandTagsResponse {
  brandTags?: DomainBrandTagDto[];
}

export interface DomainListOfficialBrandsResponse {
  hasNext?: boolean;
  officialBrands?: DomainOfficialBrandDto[];
}

export interface DomainListOnboardingBrandTagsResponse {
  brandTags?: DomainOnboardingBrandTagDto[];
}

export interface DomainListOrdersForLookoAIResponse {
  orders?: DomainOrderDTO[];
}

export interface DomainListOrdersResponse {
  /** @example true */
  hasNext: boolean;
  txs?: DomainOrderItemListDto[];
}

export interface DomainListPendingRefundOrdersResponse {
  orders?: DomainPendingRefundOrder[];
}

export interface DomainListPermissionsItem {
  description?: string;
  name?: string;
  readID?: number;
  updateID?: number;
}

export interface DomainListPermissionsResponse {
  permissions?: DomainListPermissionsItem[];
}

export interface DomainListPopularKeywordsResponse {
  popularKeywords: DomainPopularKeywordDto[];
}

export interface DomainListPopularUsersResponse {
  hasNext?: boolean;
  users?: DomainPopularUserResponse[];
}

export interface DomainListProSellerLogixInfoForLookoAIResponse {
  logixInfos?: DomainProSellerLogixDTO[];
}

export interface DomainListProSellerPartnerShopRegionsResponse {
  regions?: string[];
}

export interface DomainListProSellerPartnerShopsForLookoAIResponse {
  hasNext?: boolean;
  proSellerPartnerShopInfos?: DomainProSellerPartnerShopResponse[];
}

export interface DomainListProSellerPartnerShopsResponse {
  hasNext?: boolean;
  proSellerPartnerShopInfos?: DomainProSellerPartnerShopResponse[];
}

export interface DomainListProSellerPartnerShopsWEBResponse {
  hasNext?: boolean;
  proSellerPartnerShopInfos?: DomainProSellerPartnerShopResponse[];
}

export interface DomainListProSellerUsersResponse {
  hasNext?: boolean;
  proSellerUserItems?: DomainProSellerUserItem[];
}

export interface DomainListProSellerUsersV2Response {
  filteredProSellerCount?: number;
  hasNext?: boolean;
  proSellerUserItems?: DomainProSellerUserItemV2[];
  totalProSellerCount?: number;
}

export interface DomainListProSellersWithSpecialSaleResponse {
  prosellers?: DomainDiscountProSeller[];
}

export interface DomainListPromotionInfosResponse {
  promotionInfos: DomainPromotionInfoDTO[];
}

export interface DomainListPropertiesWithMiddleCategoryResponse {
  topCategories?: DomainTopCategory[];
}

export interface DomainListRecentlyViewedMarketItemsResponse {
  marketItems?: DomainMarketItemResponse[];
}

export interface DomainListRecommInfoHistoriesResponse {
  nextCursor: number;
  recommSectionInfoHistories: DomainRecommSectionInfoHistory[];
}

export interface DomainListRecommInfosResponse {
  sectionInfos: DomainSectionInfo[];
}

export interface DomainListRelatedKeywordsResponse {
  /** @example ["나이키","나이키 운동화","나이키 후드티"] */
  keywords: string[];
}

export interface DomainListRewardPointsResponse {
  /** @example true */
  hasNext: boolean;
  rewardPoints: DomainRewardPointResponse[];
}

export interface DomainListSearchABTestsResponse {
  searchABTests?: DomainSearchABTestDto[];
}

export interface DomainListSettlementsResponse {
  hasNext?: boolean;
  settlementItems?: DomainSettlementResponse[];
}

export interface DomainListStoreCouponsForLookoAIResponse {
  coupons: DomainStoreCouponResponse[];
}

export interface DomainListStoreCouponsResponse {
  coupons: DomainStoreCouponResponse[];
}

export interface DomainListUniversalSizesResponse {
  universalSizes: string[];
}

export interface DomainListUserBankAccountsResponse {
  bankAccounts?: DomainUserBankAccountDto[];
}

export interface DomainListUserBookmarkMarketItemsResponse {
  /** @example true */
  hasNext: boolean;
  marketItems?: DomainMarketItemResponse[];
}

export interface DomainListUserCouponsRequest {
  /** MarketItemID 결제 창에서 가지고 있는 쿠폰을 조회할 때, 해당 상품 ID를 넣어준다. */
  marketItemIDs?: number[];
  marketItemPrice?: number;
  sellerID?: number;
}

export interface DomainListUserCouponsResponse {
  userCoupons: DomainUserCouponItem[];
}

export interface DomainListUserDownloadableCouponsResponse {
  coupons: DomainCouponItem[];
}

export interface DomainListUserMarketItemReviewsResponse {
  reviews?: DomainMarketItemReviewResponse[];
}

export interface DomainListUserMarketItemsResponse {
  /**
   * 다음 페이지가 있는지 여부
   * @example true
   */
  hasNext: boolean;
  marketItems?: DomainUserMarketItemResponse[];
}

export interface DomainListUserSellerFollowsResponse {
  hasNext: boolean;
  proSellerUserItems: DomainProSellerUserItem[];
}

export interface DomainListUserStoreCouponsResponse {
  userStoreCoupons: DomainUserStoreCouponResponse[];
}

export interface DomainListUserSurveyHistoriesResponse {
  /** 페이징 정보 */
  pagination?: DomainPaginationResponse;
  /** 전체 설문에 답한 유저 수 */
  totalUserCount: number;
  /** 설문 그룹 리스트 */
  userSurvey: DomainUserSurveyResponse[];
}

export interface DomainListUserWishlistsResponse {
  /** @example true */
  hasNext: boolean;
  wishlists?: DomainWishlistDTO[];
}

export interface DomainLogixPrice {
  /** @example 50 */
  jeju: number;
  /** @example 30 */
  normal: number;
  /** @example 50 */
  outlyingArea: number;
}

export type DomainLogixPriceType =
  | 'MARKET-ITEM_LOGIX-PRICE-TYPE_NORMAL'
  | 'MARKET-ITEM_LOGIX-PRICE-TYPE_OUTLYING-AREA'
  | 'MARKET-ITEM_LOGIX-PRICE-TYPE_JEJU';

export type DomainLogixType =
  | 'MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE'
  | 'MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY'
  | 'MARKET-ITEM_LOGIX-TYPE_FREE'
  | 'MARKET-ITEM_LOGIX-TYPE_PAY'
  | 'MARKET-ITEM_LOGIX-TYPE_FREE-ON-AMOUNT';

export type DomainMarketItemBookmarkOrderField =
  | 'marketItemID'
  | 'discountPrice'
  | 'discountRate'
  | 'bookmarkID'
  | 'createDate';

export interface DomainMarketItemBrandItem {
  /** 해당 브랜드로 등록된 마켓아이템 수 */
  count?: number;
  /** 로고 이미지 주소 */
  logoUrl?: string;
  /** 브랜드 명 */
  name?: string;
}

export interface DomainMarketItemChatroomResponse {
  /**
   * 구매자 닉네임
   * @example "penguin"
   */
  BuyerNickname: string;
  /**
   * 채팅방과 연결된 중고 아이템 ID
   * @example false
   */
  IsMarketItemDeleted: boolean;
  /**
   * 구매자 유저 ID
   * @example 677235
   */
  buyerID: number;
  /**
   * 구매자 유저 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  buyerProfileImageURL?: string;
  /**
   * Sendbird ID (샌드버드 사용할 때 한정사용)
   * @example "sendbird_group_channel_25108471_a1bc35f5f0d237207bc1rd343562c878fc2fd426"
   */
  chatroomID: string;
  /**
   * 구매자의 회원 탈퇴 여부
   * @example false
   */
  isBuyerDeleted: boolean;
  /**
   * 판매자의 회원 탈퇴 여부
   * @example false
   */
  isSellerDeleted: boolean;
  /**
   * 채팅방 내역 ID (PK)
   * @example 12541
   */
  marketItemChatroomID: number;
  /**
   * 채팅방과 연결된 중고 아이템 ID
   * @example 16523667
   */
  marketItemID: number;
  /**
   * 채팅방과 연결된 중고 아이템 썸네일 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  marketItemImageURL: string;
  /** 중고 아이템 상태 */
  marketItemStatus: 'MARKET-ITEM_STATUS_SOLD' | 'MARKET-ITEM_STATUS_PROCESSING' | 'MARKET-ITEM_STATUS_FOR-SALE';
  /**
   * 판매자 유저 ID
   * @example 1251235
   */
  sellerID: number;
  /**
   * 판매자 닉네임
   * @example "penguin"
   */
  sellerNickname: string;
  /**
   * 판매자 유저 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  sellerProfileImageURL?: string;
}

export interface DomainMarketItemCoordinateResponse {
  /**
   * 코디 ID
   * @example 1
   */
  id: number;
  /**
   * 코디 이미지
   * @example "https://image.com"
   */
  imageURL: string;
  /**
   * 코디에 사용된 마켓 아이템 IDs
   * @example [1,2,3,4,5]
   */
  marketItemIDs: number[];
  /**
   * 섹션 Key
   * @example 1234567890234246
   */
  sectionKey?: number;
  /**
   * 코디 제목
   * @example "빈티지 코디"
   */
  title: string;
}

export interface DomainMarketItemDetailResponse {
  /**
   * 해당 중고 물품에 북마크 한 수
   * @example 1
   */
  bookmarkCount: number;
  /**
   * 해당 중고 물품이 속한 장바구니 개수
   * @example 10
   */
  cartCount?: number;
  /** @example false */
  isBookmarked: boolean;
  /**
   * 프로셀러 여부
   * @example true
   */
  isProSeller: boolean;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 조회수
   * @example 1
   */
  marketItemView?: number;
}

export type DomainMarketItemFabric =
  | 'MARKET-ITEM_FABRIC_COTTON'
  | 'MARKET-ITEM_FABRIC_COTTON100'
  | 'MARKET-ITEM_FABRIC_WOOL'
  | 'MARKET-ITEM_FABRIC_WOOL100'
  | 'MARKET-ITEM_FABRIC_NYLON'
  | 'MARKET-ITEM_FABRIC_RAYON'
  | 'MARKET-ITEM_FABRIC_ACRYLIC'
  | 'MARKET-ITEM_FABRIC_ACRYLIC100'
  | 'MARKET-ITEM_FABRIC_POLYESTER'
  | 'MARKET-ITEM_FABRIC_POLYESTER100'
  | 'MARKET-ITEM_FABRIC_ANGORA'
  | 'MARKET-ITEM_FABRIC_ANGORA100'
  | 'MARKET-ITEM_FABRIC_SILK'
  | 'MARKET-ITEM_FABRIC_SILK100'
  | 'MARKET-ITEM_FABRIC_CASHMERE'
  | 'MARKET-ITEM_FABRIC_CASHMERE100'
  | 'MARKET-ITEM_FABRIC_LINEN'
  | 'MARKET-ITEM_FABRIC_MOHAIR'
  | 'MARKET-ITEM_FABRIC_ALPACA'
  | 'MARKET-ITEM_FABRIC_ALPACA100'
  | 'MARKET-ITEM_FABRIC_POLYURETHANE'
  | 'MARKET-ITEM_FABRIC_TRIACETATE'
  | 'MARKET-ITEM_FABRIC_ACETATE'
  | 'MARKET-ITEM_FABRIC_DENIM'
  | 'MARKET-ITEM_FABRIC_CORDUROY'
  | 'MARKET-ITEM_FABRIC_LEATHER'
  | 'MARKET-ITEM_FABRIC_SUEDE'
  | 'MARKET-ITEM_FABRIC_VISCOSE'
  | 'MARKET-ITEM_FABRIC_LYOCELL'
  | 'MARKET-ITEM_FABRIC_CUPRO'
  | 'MARKET-ITEM_FABRIC_RABBITFUR'
  | 'MARKET-ITEM_FABRIC_DOWN'
  | 'MARKET-ITEM_FABRIC_DUCKDOWN'
  | 'MARKET-ITEM_FABRIC_GOOSEDOWN'
  | 'MARKET-ITEM_FABRIC_COWLEATHER'
  | 'MARKET-ITEM_FABRIC_LAMBLEATHER'
  | 'MARKET-ITEM_FABRIC_PIGLEATHER'
  | 'MARKET-ITEM_FABRIC_GENUINELEATHER'
  | 'MARKET-ITEM_FABRIC_SYNTHETICLEATHER'
  | 'MARKET-ITEM_FABRIC_METAL'
  | 'MARKET-ITEM_FABRIC_VELVET'
  | 'MARKET-ITEM_FABRIC_UNKNOWN';

export interface DomainMarketItemForCompare {
  /**
   * 중고 아이템 ID
   * @example 6252
   */
  marketItemID: number;
  /**
   * 주문 결제 일시
   * @example "2022-03-10T00:00:00Z"
   */
  orderPaidDate: string;
  sizeForDisplay?: DomainSizeForDisplay;
  /**
   * 중고 아이템 썸네일 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
}

export interface DomainMarketItemImageRequest {
  aimsImageID: string;
  /**
   * 이미지 높이
   * @example 100
   */
  height: number;
  imageTypes?: string[];
  /**
   * 대표이미지 여부
   * @example true
   */
  isMain: boolean;
  /**
   * 이미지 순서
   * @example 1
   */
  order: number;
  /**
   * image url
   * @example "url"
   */
  url: string;
  /**
   * 이미지 폭
   * @example 100
   */
  width: number;
}

export interface DomainMarketItemImageResponse {
  /** @example 1 */
  height: number;
  /**
   * 중고 아이템과 연결된 이미지 ID
   * @example 1621
   */
  imageID: number;
  /** @example 1 */
  imageOrder: number;
  /**
   * 이미지 타입
   * @example ["SHOP_IMAGE-TYPE_FRONT"]
   */
  imageTypes: string[];
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  imageURL: string;
  /** @example true */
  isMain: boolean;
  /** @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp" */
  thumbnailURL: string;
  /** @example 1 */
  width: number;
}

export interface DomainMarketItemMissingLink {
  isDelete?: boolean;
  marketItemID?: number;
  status?: DomainMarketItemStatus;
}

export type DomainMarketItemOrderField =
  | 'marketItemID'
  | 'discountPrice'
  | 'discountRate'
  | 'createDate'
  | 'modifyDate'
  | '_score'
  | 'aclosetScore'
  | 'popularity'
  | 'sellingDiscountRate'
  | 'discountPriceModifyDate'
  | 'similarUserPreferredItems'
  | 'recommendAfterSurvey'
  | 'bookmark';

export interface DomainMarketItemPriceHistoryResponse {
  /** @example 1000 */
  discountPrice: number;
  /** @example 1420 */
  marketItemID: number;
  /** @example 1 */
  marketItemPriceHistoryID: number;
  /** @example "2024-04-05T04:24:25.966Z" */
  modifyDate: string;
}

export interface DomainMarketItemPriceOffer {
  marketItemID: number;
  marketItemPriceOffer: number;
}

export type DomainMarketItemQuality =
  | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
  | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
  | 'MARKET-ITEM_QUALITY_GOOD'
  | 'MARKET-ITEM_QUALITY_LITTLE-USE'
  | 'MARKET-ITEM_QUALITY_MANY-USE'
  | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';

export type DomainMarketItemRaglanType =
  | 'MARKET-ITEM_RAGLAN-TYPE_NORMAL'
  | 'MARKET-ITEM_RAGLAN-TYPE_TOP'
  | 'MARKET-ITEM_RAGLAN-TYPE_ONEPIECE';

export interface DomainMarketItemRealtimeReviewResponse {
  /**
   * 리뷰 내용
   * @example "1시간 늦게 나왔네요"
   */
  comment: string;
  /**
   * 리뷰 생성일시
   * @example 1668080178342
   */
  createDate: number;
  /** 리뷰 이미지 */
  images: DomainMarketItemReviewImageResponse[];
  /**
   * 리뷰와 연결된 중고 ID
   * @example 125156
   */
  marketItemID: number;
  /**
   * 리뷰 평점
   * @example 0.5
   */
  rating: number;
  /**
   * 리뷰 ID (PK)
   * @example 24521
   */
  reviewID: number;
  /** 리뷰를 하는 사람 */
  reviewer: DomainReviewUserResponse;
}

export interface DomainMarketItemResponse {
  /**
   * 해당 중고 물품에 북마크 한 수
   * @example 1
   */
  bookmarkCount: number;
  bottomTotalLength?: number;
  bottomWaist?: number;
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /** @example 1 */
  brandTagID: number;
  /**
   * 중고 아이템 구매자 유저 ID
   * @example 22612346
   */
  buyerID?: number;
  /** @example 2626123 */
  clothesID?: number;
  /**
   * 중고 아이템 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 중고 아이템 생성일
   * @example 1668080178342
   */
  createDate: number;
  /**
   * TODO: 아래필드는 삭제 예정 (4.4.0) <-- 진짜 삭제하는지 확인
   * @example "KRW"
   */
  currency: string;
  cursor?: string;
  /**
   * 중고 아이템 설명
   * @example "사실 2년 입었어유"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  /** @example "MARKET-ITEM_FABRIC_COTTON" */
  fabric: string;
  fabrics: string[];
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  /** @example false */
  isBookmarked: boolean;
  /**
   * 중고 아이템 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /**
   * 프로셀러 여부
   * @example true
   */
  isProSeller: boolean;
  /** 비슷한 상품 여부 */
  isSimilar?: boolean;
  /**
   * 지점명 노출 여부
   * @example true
   */
  isVisible: boolean;
  /**
   * Looko AI 상품 코드
   * @example "1234567890"
   */
  itemCode: string;
  /**
   * 중고 아이템 검색 키워드
   * @example ["흰색","티셔츠","남성"]
   */
  keywords: string[];
  logixID: number;
  /**
   * 공급사명(지점명)
   * @example "공급사 없음"
   */
  logixName: string;
  logixPolicy: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 조회수
   * @example 1
   */
  marketItemView?: number;
  /**
   * 중고 아이템 수정일
   * @example 1668080178342
   */
  modifyDate: number;
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  /**
   * 중고 아이템의 상태 (깨끗함, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  score: number;
  shoeSize?: number;
  /**
   * 중고 옷 사이즈
   * @example "FREE"
   */
  size: string;
  sizeForDisplay?: DomainSizeForDisplay;
  /** 중고 아이템 판매 상태 */
  status: DomainMarketItemStatus;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
  /**
   * 중고 아이템 제목
   * @example "새것 같은 노스페이스 패딩 팔아유"
   */
  title: string;
  topChest?: number;
  topShoulder?: number;
  topSleeveLength?: number;
  topTotalLength?: number;
  /**
   * 중고 아이템 판매자 유저 ID
   * @example 22612346
   */
  userID: number;
  /** Deprecated: 6.7.0 이후 삭제 와우 할인가 */
  wowDiscountAmount?: number;
}

export interface DomainMarketItemReviewImageRequest {
  /**
   * 이미지 높이
   * @example 100
   */
  height: number;
  /**
   * 대표이미지 여부
   * @example true
   */
  isMain: boolean;
  /**
   * 이미지 순서
   * @example 1
   */
  order: number;
  /**
   * image url
   * @example "url"
   */
  url: string;
  /**
   * 이미지 폭
   * @example 100
   */
  width: number;
}

export interface DomainMarketItemReviewImageResponse {
  /**
   * 이미지 높이
   * @example 100
   */
  height: number;
  /** @example true */
  isMain: boolean;
  /** @example 1 */
  order: number;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  url: string;
  /**
   * 이미지 폭
   * @example 100
   */
  width: number;
}

export type DomainMarketItemReviewInspection =
  | 'MARKET-ITEM-REVIEW_INSPECTION_PENDING'
  | 'MARKET-ITEM-REVIEW_INSPECTION_APPROVED'
  | 'MARKET-ITEM-REVIEW_INSPECTION_REJECTED';

export interface DomainMarketItemReviewResponse {
  /**
   * 리뷰 내용
   * @example "1시간 늦게 나왔네요"
   */
  comment: string;
  /**
   * 리뷰 답글
   * @example "힝"
   */
  commentReply: string;
  /**
   * 리뷰 답글 일자
   * @example "2024-12-31T00:00:00Z"
   */
  commentReplyDate?: string;
  /**
   * 리뷰 생성일시
   * @example 1668080178342
   */
  createDate: number;
  /** 리뷰 이미지 */
  images: DomainMarketItemReviewImageResponse[];
  /**
   * 리뷰 수정 여부
   * @example false
   */
  isModified: boolean;
  /**
   * 리뷰를 하는 사람의 회원탈퇴 여부
   * @example false
   */
  isReviewerDeleted: boolean;
  /**
   * 리뷰와 연결된 중고 ID
   * @example 125156
   */
  marketItemID: number;
  /**
   * 리뷰와 연결된 중고 상품 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  marketItemImageURL: string;
  /**
   * 리뷰와 연결된 중고 상품 썸네일 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  marketItemThumbnailURL: string;
  /**
   * 로그인 한 유저가 답글 리뷰를 작성한 경우 해당 리뷰 ID (작성하지 않은 경우 null)
   * @example 12512563
   */
  myReviewID?: number;
  /**
   * 주문 ID
   * @example 1
   */
  orderID: number;
  /**
   * 주문 상품 ID
   * @example 1
   */
  orderItemID: number;
  /** Deprecated */
  paymentType: DomainPaymentType;
  /**
   * 리뷰 평점
   * @example 0.5
   */
  rating: number;
  /**
   * 리뷰 ID (PK)
   * @example 24521
   */
  reviewID: number;
  /** 컨디션 태그 */
  reviewTags: DomainMarketItemReviewTag[];
  /**
   * 리뷰의 타입 (BUYING: 구매자가 작성한 리뷰, SELLING: 판매자가 작성한 리뷰)
   * @example "MARKET-ITEM_REVIEW-TYPE_SELLING"
   */
  reviewType: 'MARKET-ITEM_REVIEW-TYPE_SELLING' | 'MARKET-ITEM_REVIEW-TYPE_BUYING';
  /** 리뷰를 받는 사람 */
  reviewee: DomainReviewUserResponse;
  /** 리뷰를 하는 사람 */
  reviewer: DomainReviewUserResponse;
  sizeTags: DomainMarketItemReviewSizeTag[];
  /**
   * 리뷰 상태
   * @example "MARKET-ITEM-REVIEW_INSPECTION_REJECTED"
   */
  status:
    | 'MARKET-ITEM-REVIEW_INSPECTION_PENDING'
    | 'MARKET-ITEM-REVIEW_INSPECTION_APPROVED'
    | 'MARKET-ITEM-REVIEW_INSPECTION_REJECTED';
  /** 컬러 태그 */
  treasureTags: DomainMarketItemReviewTreasureTag[];
}

export type DomainMarketItemReviewSizeTag = 'SMALLER_THAN_EXPECTED' | 'FITS_WELL' | 'LARGER_THAN_EXPECTED';

export type DomainMarketItemReviewTag =
  | 'REASONABLE_PRICE'
  | 'ACCURATE_PRODUCT_DESCRIPTION'
  | 'CLEAN_PRODUCT_CONDITION'
  | 'DETAILED_PRODUCT_DESCRIPTION'
  | 'MATCHING_COLOR_IN_PHOTOS'
  | 'FRIENDLY_RESPONSE'
  | 'SATISFACTORY_DESIGN'
  | 'SIZE_FITS_WELL'
  | 'ATTRACTIVE_STORE_ATMOSPHERE'
  | 'UNIQUE_ITEM_PARADISE'
  | 'FRIENDLY_RESPONSE_IN_STORE';

export type DomainMarketItemReviewTreasureTag = 'FOUND_TREASURE' | 'NOT_BAD';

export type DomainMarketItemReviewType = 'MARKET-ITEM_REVIEW-TYPE_BUYING' | 'MARKET-ITEM_REVIEW-TYPE_SELLING';

export interface DomainMarketItemSearchTestBedRequest {
  /** @example 1000 */
  createMarketItemCount: number;
  /** @example 100 */
  createUserCount: number;
  /** @example false */
  isCreatedUser: boolean;
  /** @example 20 */
  marketItemBookmark10Rate: number;
  /** @example 20 */
  marketItemBookmark2Rate: number;
  /** @example 20 */
  marketItemBookmark5Rate: number;
  /** @example 20 */
  marketItemView15Rate: number;
  /** @example 20 */
  marketItemView50Rate: number;
}

export interface DomainMarketItemSearchTestBedResponse {
  excelDownloadURL: string;
}

export type DomainMarketItemShoulderPadType =
  | 'MARKET-ITEM_SHOULDER-PAD-TYPE_NORMAL'
  | 'MARKET-ITEM_SHOULDER-PAD-TYPE_TOP'
  | 'MARKET-ITEM_SHOULDER-PAD-TYPE_ONEPIECE';

export type DomainMarketItemStatus =
  | 'MARKET-ITEM_STATUS_SOLD'
  | 'MARKET-ITEM_STATUS_PROCESSING'
  | 'MARKET-ITEM_STATUS_FOR-SALE'
  | 'MARKET-ITEM_STATUS_STOP-SALE'
  | 'MARKET-ITEM_STATUS_NO-SALE';

export interface DomainMarketItemV2Response {
  bottomTotalLength?: number;
  bottomWaist?: number;
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /** @example 1 */
  brandTagID: number;
  /**
   * 중고 아이템 구매자 유저 ID
   * @example 22612346
   */
  buyerID?: number;
  /** @example 2626123 */
  clothesID?: number;
  /**
   * 중고 아이템 생성일
   * @example 1668080178342
   */
  createDate: number;
  cursor: string;
  /**
   * 중고 아이템 설명
   * @example "사실 2년 입었어유"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  /**
   * 대표 소재
   * @example "MARKET-ITEM_FABRIC_COTTON"
   */
  fabric: string;
  /**
   * 포함된 전체 소재
   * @example ["COTTON"]
   */
  fabrics?: string[];
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  /**
   * 이미지 최대 높이
   * @example 300
   */
  imageMaxHeight: number;
  /**
   * 이미지 최대 너비
   * @example 300
   */
  imageMaxWidth: number;
  /**
   * 중고 아이템 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /** 비슷한 상품 여부 */
  isSimilar?: boolean;
  /**
   * 지점명 노출 여부
   * @example true
   */
  isVisible: boolean;
  /**
   * 중고 아이템 검색 키워드
   * @example ["흰색","티셔츠","남성"]
   */
  keywords: string[];
  /**
   * 공급사명(지점명)
   * @example "공급사 없음"
   */
  logixName: string;
  logixPolicy: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 수정일
   * @example 1668080178342
   */
  modifyDate: number;
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  /**
   * 중고 아이템의 상태 (깨끗함, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  score: number;
  shoeSize?: number;
  /**
   * 사이즈
   * @example "L"
   */
  size?: string;
  sizeForDisplay?: DomainSizeForDisplay;
  /** 중고 아이템 판매 상태 */
  status: DomainMarketItemStatus;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
  /**
   * 중고 아이템 제목
   * @example "새것 같은 노스페이스 패딩 팔아유"
   */
  title: string;
  topChest?: number;
  topShoulder?: number;
  topSleeveLength?: number;
  topTotalLength?: number;
  /**
   * 중고 아이템 판매자 유저 ID
   * @example 22612346
   */
  userID: number;
  /** Deprecated: 6.7.0부터 제거 와우 할인가 */
  wowDiscountAmount?: number;
}

export type DomainMarketItemWaistBandingType =
  | 'MARKET-ITEM_WAIST-BANDING-TYPE_NORMAL'
  | 'MARKET-ITEM_WAIST-BANDING-TYPE_TOP'
  | 'MARKET-ITEM_WAIST-BANDING-TYPE_ONEPIECE';

export interface DomainMaximumRewardPointPolicyDto {
  /** 사진 리뷰시 적립금 */
  addPhoto?: number;
  /** 텍스트 리뷰시 적립금 */
  addText?: number;
  /** 기본 적립금 */
  basic?: number;
  /** 총 적립금 */
  total?: number;
}

export interface DomainMetadataDescriptionResponse {
  en?: string;
  es?: string;
  fr?: string;
  ko?: string;
  ru?: string;
}

export interface DomainMetadataResponse {
  code: string;
  description?: DomainMetadataDescriptionResponse;
  domain?: string;
  subDomain?: string;
}

export interface DomainMiddleCategory {
  bottomCategory?: DomainBottomCategory[];
  id?: string;
  name?: string;
}

export interface DomainNotificationContent {
  /** @example "kevin" */
  content: string;
  /** @example "https://acloset.style/kevin" */
  deeplink: string;
}

export interface DomainNotificationResponse {
  /** Amplitude 이벤트 */
  analytics: DomainAmplitudeAnalyticResponse[];
  /** 알림 컨텐츠 */
  contents: Record<string, DomainNotificationContent>;
  /**
   * 생성 날짜
   * @example 1668080178342
   */
  createDate: number;
  /**
   * 이미지 URL
   * @example "https://example.com/image.png"
   */
  imageURL?: string;
  /**
   * 알림 메시지 "읽음" 여부
   * @example false
   */
  isSeen: boolean;
  /**
   * 알림 딥링크
   * @example "https://secondsold.kr/user/3"
   */
  notificationDeeplink: string;
  /**
   * 알림 아이디
   * @example 1
   */
  notificationID: number;
  /**
   * 알림 텍스트
   * @example "{user}님이 내 코디를 좋아합니다"
   */
  notificationText: string;
  /**
   * 프로필 이미지 URL
   * @example "https://example.com/image.png"
   */
  profileImageURL?: string;
}

export type DomainNotificationViewType = 'NOTIFICATION_VIEW_TYPE_ACTIVITY' | 'NOTIFICATION_VIEW_TYPE_FAVORITE';

export interface DomainOfficialBrandDto {
  childBrands?: string[];
  isFollowing?: boolean;
  logoUrl: string;
  mainImage: string;
  marketItemCount?: number;
  marketItems?: DomainMarketItemResponse[];
  nameEn: string;
  nameKr: string;
  officialBrandID: number;
  /** 판매중인 아이템 수 */
  remainingMarketItemCount?: number;
  /** 총 아이템 수 */
  totalMarketItemCount?: number;
}

export interface DomainOfficialBrandsSortedByBookmarkedCountResponse {
  logoUrl: string;
  nameEn: string;
  nameKr: string;
  officialBrandID: number;
}

export interface DomainOnboardingBrandTagDto {
  brandCategoryImage: string;
  brandSectionTitle: string;
  brandTagID: number;
  isOnboardingVisible: boolean;
  name: string;
  onboardingImage: string;
}

export interface DomainOrderBuyerLogix {
  additionalAddress: string;
  address: string;
  memo?: string;
  name: string;
  phone: string;
  zoneCode: string;
}

export interface DomainOrderCancelDTO {
  /** 취소 금액 */
  amount?: number;
  /** 취소 ID */
  id?: number;
  /** 취소 상품 */
  orderCancelItems?: DomainOrderCancelItemDTO[];
}

export interface DomainOrderCancelItemDTO {
  /** 주문 상품 ID */
  id?: number;
  /** 마켓 아이템 ID */
  marketItemID?: number;
  /** 가격 스냅샷 */
  marketItemPrice?: number;
  /** 썸네일 스냅샷 */
  marketItemThumbnail?: string;
  /** 타이틀 스냅샷 */
  marketItemTitle?: string;
  /** 주문 취소 ID */
  orderCancelID?: number;
  /** 주문 ID */
  orderID?: number;
  /** 취소 할 주문 상품 ID */
  orderItemID?: number;
  /** 거래 취소 사유 */
  orderReason?: DomainCancelOrderReason;
  /** 취소 상세 사유 */
  reason?: string;
  /** 취소 귀책 사유 */
  reasonType?: DomainOrderCancelReasonType;
}

export type DomainOrderCancelReasonType = 'BUYER' | 'SELLER' | 'ADMIN';

export interface DomainOrderDTO {
  /** 총 상품 금액 */
  amount?: number;
  /** 구매자 누적 주문 금액 */
  buyerAccumulatedOrderAmount?: number;
  /** 구매자 누적 주문 금액 */
  buyerAccumulatedOrderCount?: number;
  /** 구매자 이메일 */
  buyerEmail?: string;
  /** 구매자 ID */
  buyerID?: number;
  /** 구매자 연락처 */
  buyerMobile?: string;
  /** 구매자 닉네임 */
  buyerNickname?: string;
  /** 취소 내역 */
  cancels?: DomainOrderCancelDTO[];
  /** 주문 생성일 */
  createDate?: string;
  /** 조건부 무료 조건 금액 */
  freeConditionalAmount?: number;
  /** 주문 ID */
  id?: number;
  /** 첫 주문 여부 */
  isFirstOrder?: boolean;
  /** 가격 제안 유무 */
  isPriceOffered?: boolean;
  /** 주문 상품 */
  items?: DomainOrderItemDTO[];
  /** 배송 상세 주소 */
  logixAdditionalAddress?: string;
  /** 배송 주소 */
  logixAddress?: string;
  /** 배송 메모 */
  logixMemo?: string;
  /** 배송 받는 사람 이름 */
  logixName?: string;
  /** 배송 받는 사람 연락처 */
  logixPhone?: string;
  /** 실제 지불 배송비 (3000 or 0) */
  logixPrice?: number;
  /** 배송비 타입 (제주, 도서산간) */
  logixPriceType?: DomainLogixPriceType;
  /** 설정 반품 배송비 (유저 설정 : 5000원) */
  logixReturnPrice?: number;
  /** 배송비 타입 (무료, 유료, 조건부 무료) */
  logixType?: DomainLogixType;
  /** 배송지 우편 번호 */
  logixZipCode?: string;
  /** 가격 제안 금액 */
  offerAmount?: number;
  /** 총 결제 금액 */
  paidAmount?: number;
  /** 지불 방법 */
  payMethod?: DomainPayMethod;
  /** 스토어 결제 여부 */
  paymentType?: DomainPaymentType;
  /** 반품 내역 */
  returns?: DomainOrderReturnDTO[];
  /** 판매 금액 (할인 판매가) */
  saleAmount?: number;
  /** 에이클로젯 쿠폰 할인 금액 */
  sellerCouponDiscountAmount?: number;
  /** 판매자 ID */
  sellerID?: number;
  /** 판매자 닉네임 */
  sellerNickname?: string;
  /** 결제 금액 + 배송비 */
  totalAmount?: number;
  /** 설정 배송비 (3000 or 0) */
  txLogixPrice?: number;
}

export type DomainOrderDisputeReasonType = 'BUYER' | 'SELLER';

export interface DomainOrderForLookoAIResponse {
  /** 총 상품 금액 */
  amount?: number;
  /** 구매자 누적 주문 금액 */
  buyerAccumulatedOrderAmount?: number;
  /** 구매자 누적 주문 금액 */
  buyerAccumulatedOrderCount?: number;
  /** 구매자 이메일 */
  buyerEmail?: string;
  /** 구매자 ID */
  buyerID?: number;
  /** 구매자 연락처 */
  buyerMobile?: string;
  /** 구매자 닉네임 */
  buyerNickname?: string;
  /** 취소상품 주문 금액 */
  cancelAmount?: number;
  /** 취소 내역 */
  cancels?: DomainOrderCancelDTO[];
  /** 주문 생성일 */
  createDate?: string;
  /** 조건부 무료 조건 금액 */
  freeConditionalAmount?: number;
  /** 주문 ID */
  id?: number;
  /** 첫 주문 여부 */
  isFirstOrder?: boolean;
  /** 가격 제안 유무 */
  isPriceOffered?: boolean;
  /** 주문 상품 */
  items?: DomainOrderItemDTO[];
  /** 배송 상세 주소 */
  logixAdditionalAddress?: string;
  /** 배송 주소 */
  logixAddress?: string;
  /** 배송 메모 */
  logixMemo?: string;
  /** 배송 받는 사람 이름 */
  logixName?: string;
  /** 배송 받는 사람 연락처 */
  logixPhone?: string;
  /** 실제 지불 배송비 (3000 or 0) */
  logixPrice?: number;
  /** 배송비 (에이클로젯 보상비) */
  logixPriceAclosetSupported?: number;
  /** 배송비 (차감) */
  logixPriceDeducted?: number;
  /** 배송비 차감 여부 */
  logixPriceDeduction?: boolean;
  /** 배송비(합산) */
  logixPricePaid?: number;
  /** 배송비 합산여부 */
  logixPricePaidSummation?: boolean;
  /** 배송비 타입 (제주, 도서산간) */
  logixPriceType?: DomainLogixPriceType;
  /** 반품 배송비 */
  logixReturnPrice?: number;
  /** 반품 배송비 (에이클로젯 보상비) */
  logixReturnPriceAclosetSupported?: number;
  /** 배송비 타입 (무료, 유료, 조건부 무료) */
  logixType?: DomainLogixType;
  /** 배송지 우편 번호 */
  logixZipCode?: string;
  /** 가격 제안 금액 */
  offerAmount?: number;
  /** 총 결제 금액 */
  paidAmount?: number;
  /** 지불 방법 */
  payMethod?: DomainPayMethod;
  /** 스토어 결제 여부 */
  paymentType?: DomainPaymentType;
  /** 환불 예정 금액 */
  refundAmount?: number;
  /** 최종 환불 */
  refundDeduction?: number;
  /** 취소 상품금액 */
  refundItemsPrice?: number;
  /** 환불 가능 여부 */
  refundable?: boolean;
  /** 반품 내역 */
  returns?: DomainOrderReturnDTO[];
  /** 판매 금액 (할인 판매가) */
  saleAmount?: number;
  /** 에이클로젯 셀러 쿠폰 차감금액 */
  sellerCouponDeducted?: number;
  /** 에이클로젯 쿠폰 할인 금액 */
  sellerCouponDiscountAmount?: number;
  /** 환불후 최종 정산 예정액 */
  sellerExpectedAmount?: number;
  /** 판매자 ID */
  sellerID?: number;
  /** 판매자 닉네임 */
  sellerNickname?: string;
  /** 결제 금액 + 배송비 */
  totalAmount?: number;
  /** 설정 배송비 (3000 or 0) */
  txLogixPrice?: number;
}

export interface DomainOrderItemDTO {
  createDate?: string;
  id?: number;
  logixCourierName?: string;
  logixTrackingNumber?: string;
  marketItemBrand?: string;
  marketItemID?: number;
  marketItemPrice?: number;
  /** 할인 판매가 */
  marketItemSalePrice?: number;
  marketItemThumbnail?: string;
  marketItemTitle?: string;
  /** 가격 제안 금액 */
  offerPrice?: number;
  /** 배송 완료일 */
  shippingEndDate?: string;
  status?: DomainOrderStatus;
}

export interface DomainOrderItemDetailDto {
  /** 취소 시간 */
  cancelDate?: number;
  cancellationActor?: DomainOrderCancelReasonType;
  cancellationReason?: DomainCancelOrderReason;
  cancellationReasonDetail?: string;
  /** sendbird chat url */
  chatUrl?: string;
  /** 구매확정일 */
  confirmDate?: string;
  /** 구매확정예정일 */
  confirmTxDueDate: string;
  /** 주문 생성 일시 */
  createDate: string;
  /** 자동 구매 확정 예정일 */
  expectedAutoConfirmDate?: string;
  /** 주문 상세 id */
  id: number;
  /** 옷 등록 여부 */
  isClothesRegistered: boolean;
  /** 구매확정 연장 여부 */
  isExtend?: boolean;
  /** 가격 제안 여부 */
  isPriceOffered: boolean;
  /** 반품 재신청 여부 */
  isReturnReRequested?: boolean;
  /** 택배사 이름 */
  logixCourierName: string;
  /** 운송장 번호 */
  logixTrackingNumber: string;
  /** 상품 브랜드 snapshot */
  marketItemBrand: string;
  /** 상품 ID */
  marketItemID: number;
  /** 상품 가격 snapshot - 실 구매가 */
  marketItemPrice: number;
  /** 정가 snapshot */
  marketItemRegularPrice: number;
  /** 판매가 snapshot */
  marketItemSalePrice: number;
  /** 상품 썸네일 snapshot */
  marketItemThumbnail: string;
  /** 상품 이름 snapshot */
  marketItemTitle: string;
  /** 주문 수정 일시 */
  modifyDate: string;
  /** reviewID */
  myReviewID?: number;
  /** 제안가 */
  offerPrice: number;
  /** 주문 번호 */
  orderNumber: string;
  /** 반품 요청 횟수 */
  refundCount: number;
  /** 반품 거부 사유 */
  rejectReason?: DomainOrderReturnRejectReason;
  /** 반품 거부 상세 사유 */
  rejectReasonDetails?: string;
  /** 반품 요청일 */
  returnDate?: number;
  /** 반품설문조사 완료 여부 */
  returnSurveyRequired?: boolean;
  /** 배송 완료일 */
  shippingEndDate?: string;
  /** 주문 상태 필요 여부에따라 남길지 지울지 정해짐 */
  status: DomainOrderStatus;
}

export interface DomainOrderItemForBackofficeDTO {
  /** 수수료 */
  agentFee?: number;
  /** 수수료 할인 금액 */
  agentFeeDiscount?: number;
  /** 수수료 할인 타입 */
  agentFeeDiscountType?: string;
  /** 구매자 이메일 */
  buyerEmail?: string;
  /** 구매자 ID */
  buyerID: number;
  /** 구매자 닉네임, snapshot */
  buyerNickname?: string;
  /** 구매자 연락처 */
  buyerNumber?: string;
  /** 구매 확정일 */
  confirmDate?: number;
  /** 구매 확정 예정일 */
  confirmDueDate?: number;
  /** 거래생성 unix timestamp */
  createdAt: number;
  /** 구매자 탈퇴 여부 */
  isDeleteBuyer: boolean;
  /** 판매자 탈퇴 여부 */
  isDeleteSeller: boolean;
  /** 첫 구매 혜택 적용 여부 */
  isFirstOrder: boolean;
  /** 가격 제안 여부 */
  isPriceOffered: boolean;
  /** 프로셀러 여부 */
  isProSeller: boolean;
  /** 택배사 이름 */
  logixCourierName?: string;
  /** 운송장 번호 */
  logixTrackingNumber?: string;
  marketItemBrand: string;
  /** 상품 ID */
  marketItemID: number;
  /** 상품 가격 snapshot */
  marketItemPrice: number;
  /** 정가 snapshot */
  marketItemRegularPrice: number;
  /** 판매가 snapshot */
  marketItemSalePrice: number;
  /** 상품 썸네일 snapshot */
  marketItemThumbnail: string;
  /** 상품 이름 snapshot */
  marketItemTitle: string;
  /** 거래 수정일 */
  modifyAt: number;
  /** 제안가 */
  offerPrice: number;
  /** 주문 ID */
  orderID: number;
  /** 상품주문 ID */
  orderItemID: number;
  /** 상품주문 번호 */
  orderNumber: string;
  /** 결제 금액 */
  paidAmount: number;
  /** 결제 일시 */
  paidAt: number;
  /** 결제 수단 */
  payMethod: DomainPayMethod;
  /** 판매자 이메일 */
  sellerEmail?: string;
  /** 판매자 ID */
  sellerID: number;
  /** 판매자 닉네임, snapshot */
  sellerNickname?: string;
  /** 판매자 연락처 */
  sellerNumber?: string;
  /** 주문 상태 */
  status: DomainOrderStatus;
}

export interface DomainOrderItemListDto {
  buyerID: number;
  buyerNickname: string;
  /** 주문 생성 일시 */
  createDate: string;
  /** 자동 구매 확정 예정일 */
  expectedAutoConfirmDate?: string;
  /** 옷 등록 여부 */
  isClothesRegistered: boolean;
  isDeleteBuyer: boolean;
  isDeleteSeller: boolean;
  /** 첫 구매 혜택 적용 여부 */
  isFirstOrder: boolean;
  /** 가격 제안 여부 */
  isPriceOffered: boolean;
  isProSeller: boolean;
  /** 반품 재신청 여부 */
  isReturnReRequested?: boolean;
  /** 시간 조정 여부 */
  isTimeAdjusted: boolean;
  /** 상품 썸네일 snapshot */
  marketItemBrand: string;
  /** 상품 ID */
  marketItemID: number;
  /** 상품 가격 snapshot */
  marketItemPrice: number;
  /** 상품 정가 snapshot */
  marketItemRegularPrice: number;
  /** 상품 판매가 snapshot */
  marketItemSalePrice: number;
  /** 상품 썸네일 snapshot */
  marketItemThumbnail: string;
  /** 상품 이름 snapshot */
  marketItemTitle: string;
  /** 주문 수정 일시 */
  modifyDate: string;
  myReviewID?: number;
  needRepayment?: boolean;
  /** 제안가 */
  offerPrice: number;
  /** 주문 번호 (213489-01) */
  orderNumber: string;
  /** 현징결제 관련 플래그 */
  paymentType?: DomainPaymentType;
  /** 반품 거부 사유 */
  rejectReason?: DomainOrderReturnRejectReason;
  /** 반품 거부 상세 사유 */
  rejectReasonDetails?: string;
  /** 반품 설문조사 여부 */
  returnSurveyRequired?: boolean;
  /** 사용자 정보 */
  sellerID: number;
  sellerNickname: string;
  /** 배송 완료일 */
  shippingEndDate?: string;
  /** 주문 상태 필요 여부에따라 남길지 지울지 정해짐 */
  status: DomainOrderStatus;
  /** 구매 생성 일 (1970.01.02) */
  txDate: string;
  /** 주문 상세 id */
  txDetailID: number;
  /** 거래 id */
  txID: number;
}

export interface DomainOrderItemLogix {
  courierName?: string;
  orderItemID?: number;
  trackingNumber?: string;
}

export interface DomainOrderItemReviewDto {
  ConfirmDueDate: string;
  OrderCreateDate: string;
  confirmDate?: string;
  createDate: string;
  isExtend?: boolean;
  /** 시간 조정 여부 */
  isTimeAdjusted: boolean;
  logixCourierName: string;
  logixTrackingNumber: string;
  marketItemBrand: string;
  marketItemID: number;
  marketItemPrice: number;
  marketItemThumbnail: string;
  marketItemTitle: string;
  modifyDate: string;
  orderID: number;
  orderItemID: number;
  /** 결제 타입 */
  paymentType: DomainPaymentType;
  sellerID: number;
  status: DomainOrderStatus;
}

export interface DomainOrderReturnDTO {
  /** 메모 */
  address?: string;
  /** 상세주소 */
  addressDetails?: string;
  /** 반품 생성일 */
  createdAt?: string;
  /** 반품 ID */
  id?: number;
  /** 반품 사진 */
  images?: string[];
  /** 첫 반품 여부 */
  isFirstReturn?: boolean;
  /** 반품 배송비 */
  logixReturnPrice?: number;
  /** 반품 방법 */
  method?: DomainRefundLogixType;
  /** 수거 정보의 사람 이름 */
  name?: string;
  /** 주문 ID */
  orderID?: number;
  /** 반품 상품 */
  orderReturnItems?: DomainOrderReturnItemDTO[];
  /** 연락처 */
  phone?: string;
  /** 귀책 사유 (판매자 또는 구매자) */
  reason?: DomainRefundReason;
  /** 귀책 상세 사유 */
  reasonDetails?: string;
  /** 귀책 사유 타입 (판매자 또는 구매자) */
  reasonType?: DomainOrderReturnReasonType;
  /** 반품 주소가 배송 주소와 다른지 여부 */
  returnAddressIsDifferentFromShipping?: boolean;
  /** 설정 반품 배송비 (유저 설정 : 5000원) */
  txLogixReturnPrice?: number;
  /** 우편번호 */
  zipCode?: string;
}

export interface DomainOrderReturnItemDTO {
  /** 반품 상품 ID */
  id?: number;
  /** 반품 재요청 여부 */
  isReturnReRequested?: boolean;
  /** 마켓 아이템 ID */
  marketItemID?: number;
  /** 가격 스냅샷 */
  marketItemPrice?: number;
  /** 썸네일 스냅샷 */
  marketItemThumbnail?: string;
  /** 타이틀 스냅샷 */
  marketItemTitle?: string;
  /** 주문 ID */
  orderID?: number;
  /** 취소 할 주문 상품 ID */
  orderItemID?: number;
  /** 주문 취소 ID */
  orderReturnID?: number;
  /** 귀책 사유 (단순 변심, 상품 오배송 등) */
  reason?: DomainRefundReason;
  /** 귀책 상세 사유 */
  reasonDetails?: string;
  /** 귀책 사유 타입 (판매자 또는 구매자) */
  reasonType?: DomainOrderReturnReasonType;
  /** 반품 상태 */
  status?: DomainOrderReturnStatus;
}

export type DomainOrderReturnReasonType = 'BUYER' | 'SELLER';

export type DomainOrderReturnRejectReason = 'DESTROYED' | 'WRONG_REASON_TYPE' | 'OTHER_REASON';

export type DomainOrderReturnStatus = 'REQUEST' | 'APPROVED' | 'DENIED' | 'DENIED_AND_CONFIRM';

export type DomainOrderStatus =
  | 'TX_STATUS_CANCELED'
  | 'TX_STATUS_PAYMENT-PENDING'
  | 'TX_STATUS_PAYMENT-COMPLETED'
  | 'TX_STATUS_SHIPPING-PREPARING'
  | 'TX_STATUS_SHIPPING-IN-TRANSIT'
  | 'TX_STATUS_SHIPPING-COMPLETED'
  | 'TX_STATUS_TRANSACTION-COMPLETED-SAFE'
  | 'TX_STATUS_REFUND-REVIEW'
  | 'TX_STATUS_REFUND-WAIT'
  | 'TX_STATUS_REFUND-DENIED'
  | 'TX_STATUS_REFUND-COMPLETED';

export type DomainOrderType = 'SELL' | 'BUY';

export type DomainOriginCountryType =
  | 'PROSELLER-INFO_ORIGIN-COUNTRY-TYPE_USA'
  | 'PROSELLER-INFO_ORIGIN-COUNTRY-TYPE_JAPAN'
  | 'PROSELLER-INFO_ORIGIN-COUNTRY-TYPE_EUROPE';

export interface DomainPaginationResponse {
  /** 현재 페이지 번호 */
  pageNumber?: number;
  /** 페이지 당 크기 */
  pageSize?: number;
  /** 총 아이템 수 */
  totalCount?: number;
  /** 총 페이지 수 */
  totalPageCount?: number;
}

export interface DomainPartnerShopInfoStoreLocations {
  /** 주소지 */
  address?: string;
  /** 상세 주소 */
  detailedAddress?: string;
  /** 지번 */
  lotNumberAddress?: string;
  /** 도, 특별시, 광역시 */
  region?: string;
  /** Region에 해당하는 지역범위 */
  subRegion?: string;
}

export interface DomainPartnerShopStoreCouponResponse {
  /** 매장 쿠폰 이름 */
  couponName?: string;
  /** 할인 금액 */
  discountAmount?: number;
  /** 최소 결제 금액 */
  txAmountMin?: number;
}

export interface DomainPasertUserPreferenceRequest {
  /**
   * 따로 입력받지 않는 경우 User.Birth 로 적용
   * @example "1990-01-01"
   */
  birth?: string;
  bottomWaistSizes?: DomainUserPreferenceBottomSize[];
  brandTagIDs?: number[];
  /** 처음 생성 시 필수값임 */
  genderWear?: DomainUserPreferenceGenderWearType;
  height?: number;
  shoeSizes?: DomainUserPreferenceShoeSize[];
  shoppingTypes?: DomainShoppingType[];
  topChestMax?: number;
  topChestMin?: number;
  topClothesSizes?: DomainUserPreferenceTopSize[];
  weight?: number;
}

export interface DomainPatchCouponRequest {
  allowDuplicateUsage?: boolean;
  couponCalcType?: DomainCouponCalcType;
  couponCode?: string;
  couponConditions?: DomainCouponConditionDTO[];
  couponContentImages?: string[];
  couponDescription?: string;
  couponID: number;
  couponImage?: string;
  couponIssueButtonImage?: string;
  couponName?: string;
  couponUsageMax?: number;
  discountAmount?: number;
  discountAmountMax?: number;
  eventEndDate?: string;
  eventStartDate?: string;
  expirationDuration?: number;
  isActivate?: boolean;
  txAmountMin?: number;
}

export interface DomainPatchLogixPrice {
  /** @example 50 */
  jeju: number;
  /** @example 30 */
  normal: number;
  /** @example 50 */
  outlyingArea: number;
}

export type DomainPatchMarketItemAsSellingRequest = object;

export interface DomainPatchMarketItemBulkRequest {
  patchMarketItemDtos: DomainPatchMarketItemDto[];
}

export interface DomainPatchMarketItemDto {
  /**
   * 중고 아이템 브랜드 이름
   * @example "ZARA"
   */
  brandName?: string;
  /**
   * 중고 아이템 카테고리 ID
   * @example 25
   */
  categoryID?: number;
  /**
   * 중고 아이템 색상 ID 리스트
   * @example [2,4,6]
   */
  colorIDs?: number[];
  /** 중고 아이템 성별 */
  genderWear?: DomainGenderWearType;
}

export interface DomainPatchMarketItemImageWithAIMSImageIDRequest {
  /**
   * AIMS 이미지 ID
   * @example "6251"
   */
  aimsImageID: string;
  /**
   * 이미지 높이
   * @example 100
   */
  height?: number;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  imageURL?: string;
  /** @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp" */
  thumbnailURL?: string;
  /**
   * 이미지 폭
   * @example 100
   */
  width?: number;
}

export interface DomainPatchMarketItemImagesWithAIMSImageIDRequest {
  images: DomainPatchMarketItemImageWithAIMSImageIDRequest[];
}

export interface DomainPatchMarketItemLogixRequest {
  /**
   * 수정할 배송 방식 ID
   * @example 1
   */
  logixID: number;
}

export interface DomainPatchMarketItemRequest {
  discountPrice?: number;
  /** @example true */
  force?: boolean;
  status?: DomainMarketItemStatus;
}

export interface DomainPatchMarketItemReviewForLookoAIRequest {
  /**
   * 리뷰 답글
   * @example "힝"
   */
  commentReply?: string;
}

export interface DomainPatchNotificationsRequest {
  /**
   * 알림 메시지 "읽음" 여부
   * @example true
   */
  isSeen: boolean;
  /**
   * 알림 타입 - 특정 알림 타입만 읽음 처리
   * @example "1"
   */
  viewType: DomainNotificationViewType;
}

export interface DomainPatchOrderRequest {
  logix?: DomainOrderBuyerLogix;
}

export interface DomainPatchShopDescription {
  /** 상점 키워드 (예: 클래식, 펑키) */
  keywords?: DomainKeywordsType[];
  /** 상점 원산지 국가 */
  originCountries?: DomainOriginCountryType[];
  /** 상점이 주로 판매하는 상품 카테고리 (예: 가성비, 명품) */
  productFocuses?: DomainProductFocusType[];
  /** 상점이 제공하는 서비스 (예: 세탁, 스팀살균, 빠른배송, 반품가능) */
  serviceOptions?: DomainServiceOptionsType[];
  /** 상점 위치 */
  storeLocations?: DomainStoreLocations;
  /** 상점 타겟 연령 */
  targetAges?: DomainTargetAgeType[];
  /** 상점 타겟 성별 */
  targetGenders?: DomainTargetGenderType[];
}

export interface DomainPatchUserProSellerRequest {
  /** 배송 공지사항 게시 여부 */
  IsLogixNoticePublished?: boolean;
  /** 예금주 */
  accountHolder?: string;
  /** 계좌번호 */
  accountNumber?: string;
  backgroundImageURL?: string;
  /** 은행명 */
  bankName?: string;
  bio?: string;
  businessAddress?: string;
  businessContact?: string;
  /** proseller_info 테이블 반영 */
  businessName?: string;
  /** nc_usr_account 테이블 반영 */
  email?: string;
  inquiryContact?: string;
  inquiryPossibleTime?: string;
  /** 정식 입점 여부 */
  isOfficiallyEntered?: boolean;
  isPartnerShop?: boolean;
  isProductionVisible?: boolean;
  link?: string;
  /** 배송 공지사항 */
  logixNotice?: string;
  /** ReviewPushNotificationAgreed *bool                 `json:"reviewPushNotificationAgreed"` */
  logixPolicy?: string;
  logixPriceByArea?: boolean;
  minOrderAmountForOffer?: number;
  nickname?: string;
  /** 정식 입점 날짜 */
  officiallyEnteredDate?: string;
  /**
   * `MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE` 현재 api 에서 허용안함<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY` 현재 api 에서 허용안함<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_FREE` 배송비 무료<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_PAY` 배송비 유료 (logixPrice 필수)<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_FREE-ON-AMOUNT` 배송 (order_logix_type_free_on_amount 필수)<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_PAY-ON-QUANTITY` 배송 (order_logix_type_pay_on_quantity 필수)<br/>
   */
  orderLogixType?: DomainLogixType;
  /** MARKET-ITEM_LOGIX-TYPE_FREE-ON_AMOUNT 선택시 무료 배송이 되는 금액, 입력시 최소 1이상 */
  orderLogixTypeFreeOnAmount?: number;
  /** MARKET-ITEM_LOGIX-TYPE_PAY-ON-QUANTITY 선택시 지정된 갯수마다 배송비 부과, 입력시 최소 1 이상 */
  orderLogixTypePayOnQuantity?: number;
  orderShippingFee?: DomainPatchLogixPrice;
  proSellerInterviewImages?: string[];
  profileImageURL?: string;
  purchaseQuantityLimit?: number;
  refundAddressInfo?: DomainAddressInfoProSeller;
  refundCourierName?: string;
  refundLogixType?: DomainRefundLogixType;
  refundPolicy?: string;
  refundShippingFee?: DomainPatchLogixPrice;
  /** lookoai에서 받아오는 샵 소개를 위한 정보 */
  shopDescription?: DomainPatchShopDescription;
}

export interface DomainPatchUserRequest {
  /**
   * 변경할 프로필 - 배경이미지 (수정 안할 시 null)
   * @example "https://www.naver.com"
   */
  backgroundImageURL?: string;
  /**
   * 변경할 프로필 - 소개문구 (수정 안할 시 null)
   * @example "ㅎㅇㅎㅇ 여러분"
   */
  bio?: string;
  /**
   * 변경할 생일 [FORMAT: YYYY-MM-DD](수정 안할 시 null)
   * @example "1997-01-30"
   */
  birth?: string;
  /**
   * 변경할 클라이언트 설정 (수정 안할 시 null)
   * @example "{"ClientConfig":"hello"}"
   */
  clientConfig?: string;
  /**
   * 알림 설정 필드
   * @example true
   */
  commentNotificationAgreed?: boolean;
  /**
   * 라운지 알림: 내 게시글에 새로운 댓글이 달렸을 때
   * @example true
   */
  communityCommentNotifAgreed?: boolean;
  /**
   * 라운지 알림: 댓글을 단 글에 새로운 댓글이 달렸을 때
   * @example true
   */
  communityCommentOnNotifAgreed?: boolean;
  /**
   * 라운지 알림: 내 게시글에 좋아요가 눌렸을 때
   * @example true
   */
  communityLikeNotifAgreed?: boolean;
  /**
   * 변경할 국가 코드 (수정 안할 시 null)
   * @example "true"
   */
  countryCode?: string;
  /**
   * 쿠폰 만료 알림
   * @example true
   */
  couponExpiredNotificationAgreed?: boolean;
  /**
   * 코디 생성 독려 푸시 알림 허용 여부(수정 안할 시 null)
   * @example true
   */
  createClothesEncouragementNotificationAgreed?: boolean;
  /**
   * 변경할 통화 단위 코드 (수정 안할 시 null)
   * @example "USD"
   */
  currency?: string;
  /**
   * 변경할 이메일
   * @example "sssang97@naver.com"
   */
  email?: string;
  /**
   * 변경할 팔로우 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  followNotificationAgreed?: boolean;
  /** 변경할 유저 성별(MALE:남성, FEMALE:여성, RATHERNOTSAY:밝히지 않음, NONBINARY: 지정되지 않음) (수정 안할 시 null) */
  gender?: 'MALE' | 'FEMALE' | 'RATHERNOTSAY' | 'NONBINARY';
  /**
   * 변경할 사용자 이메일 인증 여부 (수정 안할 시 null)a
   * @example true
   */
  isVerified?: boolean;
  /**
   * 변경할 사용어 언어코드 (수정 안할 시 null)
   * @example "ko"
   */
  language?: string;
  /**
   * 변경할 좋아요 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  likeNotificationAgreed?: boolean;
  /**
   * 변경할 프로필 - 웹사이트 (수정 안할 시 null)
   * @example "https://www.naver.com"
   */
  link?: string;
  /**
   * 변경할 중고 북마크 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  marketItemBookmarkNotificationAgreed?: boolean;
  /**
   * 변경할 중고 채팅 푸시 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  marketItemChattingPushNotificationAgreed?: boolean;
  /**
   * 변경할 중고 할인 푸시 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  marketItemDiscountPushNotificationAgreed?: boolean;
  /**
   * 변경할 가격 제안 알림 허용 여부(수정 안할 시 null)
   * @example true
   */
  marketItemPriceOfferNotificationAgreed?: boolean;
  /**
   * 변경할 중고 리뷰 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  marketItemReviewNotificationAgreed?: boolean;
  /**
   * 마이그레이션 진행 대상자인지 확인 (수정 안할 시 null)
   * @example true
   */
  migrationFlag?: boolean;
  /**
   * ReviewPushNotificationAgreed                        *bool       `json:"reviewPushNotificationAgreed"                        validate:"optional" example:"true"`                                                 // '배송 중' 도달 120 시간 이후 리뷰 작성 독려 푸시 알림 허용(수정 안할 시 null)
   * @example true
   */
  newMarketItemFromBookmarkedSellerNotificationAgreed?: boolean;
  /**
   * 변경할 닉네임 (수정 안할 시 null)
   * @example "코딩하는기린"
   */
  nickname?: string;
  /**
   * 변경할 코디 나만 보기 모드 (수정 안할 시 null)
   * @example true
   */
  outfitPrivacy?: boolean;
  portoneVerificationConnectingInformation?: string;
  /**
   * 변경할 코디 추천 온도감 설정(-2: 더 따뜻하게 입을래요, -1: 조금 따뜻하게 입을래요, 0: 적당해요, 1: 조금 시원하게 입을래요, 2: 더 시원하게 입을래요) (수정 안할 시 null)
   * @example 1
   */
  tempSenseLevel?: -2 | -1 | 0 | 1 | 2;
  /**
   * 변경할 거래 푸시 알림 허용 여부(수정 안할 시 null)
   * @example true
   */
  transactionPushNotificationAgreed?: boolean;
  /**
   * 변경할 업데이트 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  updateNotificationAgreed?: boolean;
  /** 사용자 AB */
  userABTest?: DomainUserABTest;
}

export interface DomainPatchWishlistRequest {
  /**
   * 알람 여부
   * @example true
   */
  isNotification?: boolean;
  /**
   * 마켓 아이템 생성 시 알람 여부
   * @example true
   */
  isNotificationByCreateMarketItem?: boolean;
  /**
   * 새로 생성된 아이템을 확인했는지 여부 (true: 확인함, false: 확인하지 않음)
   * @example true
   */
  isSeen?: boolean;
  /**
   * 빈 문자열은 안됨. 글자수 제한 없음
   * @example "스포츠 관심상품"
   */
  name?: string;
}

export interface DomainPatternFilter {
  filterPatternItems: DomainFilterPatternItem[];
}

export type DomainPayMethod = 'card' | 'kakaopay' | 'naverpay' | 'trans' | 'vbank' | 'tosspay';

export type DomainPaymentType = 'ONLINE' | 'STORE';

export interface DomainPendingRefundOrder {
  marketItemThumbnail: string;
  marketItemTitle: string;
  orderID: number;
  sellerNickname: string;
}

export interface DomainPopularKeywordDto {
  /** @example "나이키" */
  keyword: string;
}

export interface DomainPopularUserResponse {
  /** 상점 이미지 */
  images?: string[];
  /** 프로셀러 여부 */
  isProSeller?: boolean;
  /** 상점 노출 여부 */
  isVisibleProSeller?: boolean;
  nickname?: string;
  /** 상점 정보 키워드 - 프로셀러만 존재함 */
  proSellerInfoKeywords?: string[];
  /** 프로필 이미지 */
  profileImage?: string;
  /** 판매중인 아이템 수 */
  remainingMarketItemCount?: number;
  /** 아이템 총 갯수 */
  totalMarketItemCount?: number;
  userID?: number;
}

export interface DomainPortoneDoneRequest {
  imp_uid?: string;
  merchant_uid?: string;
  status?: string;
}

export interface DomainPortoneVerificationRequest {
  identityVerificationID: string;
}

export interface DomainPrefClosets {
  /**
   * 선호하는 옷장 아이디들
   * @example [1]
   */
  closetIDs?: number[];
  /**
   * 모든 옷장 사용 여부
   * @example false
   */
  isAll: boolean;
}

export interface DomainProSellerInfo {
  avgDaysFromOrderConfirmToShipStart?: number;
  businessAddress?: string;
  businessContact?: string;
  businessName?: string;
  inquiryContact?: string;
  inquiryPossibleTime?: string;
  /** 배송 공지사항 게시 여부 */
  isLogixNoticePublished: boolean;
  /** 정식 입점 여부 */
  isOfficiallyEntered?: boolean;
  isProductionVisible?: boolean;
  /** 배송 공지사항 */
  logixNotice: string;
  minOrderAmountForOffer?: number;
  officiallyEnteredDate?: string;
  orderLogixType?: DomainLogixType;
  orderLogixTypeFreeOnAmount?: number;
  orderLogixTypePayOnQuantity?: number;
  orderShippingFee?: DomainLogixPrice;
  /** 임시 서비스, 프로셀러가 최대 200명 내외 */
  proSellerInterviewImages?: string[];
  purchaseQuantityLimit?: number;
  refundAddressInfo?: DomainAddressInfoProSeller;
  refundCourierName?: string;
  refundLogixType?: DomainRefundLogixType;
  refundPolicy?: string;
  refundShippingFee?: DomainLogixPrice;
  /** lookoai에서 받아오는 샵 소개를 위한 정보 */
  shopDescription?: DomainShopDescription;
  userID?: number;
}

export type DomainProSellerLabelType =
  | 'PRO-SELLER-LABEL-TYPE_ISSUED-COUPON'
  | 'PRO-SELLER-LABEL-TYPE_RATING-ABOVE-FOUR-POINT-NINE'
  | 'PRO-SELLER-LABEL-TYPE_HIGH-REPURCHASE-RATE'
  | 'PRO-SELLER-INFO_LABEL-TYPE_ON-DISCOUNT';

export interface DomainProSellerLogixDTO {
  /** CS 담당 연락처 */
  afterServicePhoneNumber: string;
  /** 택배사 */
  courierCompany: string;
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeOnAmount: number;
  /** 기본 배송지 여부 */
  isDefault: boolean;
  /** 공급사명 노출 여부 */
  isVisible: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea: boolean;
  /** 배송정보 ID */
  logixID: number;
  /** 공급사명(지점명) */
  logixName: string;
  /** 배송 정책 */
  logixPolicy: string;
  /** 배송비 */
  logixPrice: DomainLogixPrice;
  /** 배송 타입 */
  logixType: DomainLogixType;
  /** 프로 셀러 ID */
  proSellerID: number;
  /** 최대 구매 수량 */
  purchaseQuantity: number;
  /** 수거 방법 */
  refundLogixType: DomainRefundLogixType;
  /** 반품 주소 */
  returnAddress: string;
  /** 반품 상세 주소 */
  returnAddressDetail: string;
  /** 반품 배송비 */
  returnFee: number;
  /** 반품 이름 */
  returnName?: string;
  /** 반품 정책 */
  returnPolicy: string;
  /** 반품 우편 번호 */
  returnZipCode: string;
}

export interface DomainProSellerMarketItemResponse {
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  marketItemID: number;
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  score?: number;
  thumbnailURL?: string;
  /**
   * Size                string  `json:"size"                validate:"optional" example:"FREE"`       // 중고 옷 사이즈 TODO: 사이즈 태그 임시 제거
   * @example "SOUTH FACE"
   */
  title: string;
}

export type DomainProSellerOrderField = 'officiallyEnteredDate';

export interface DomainProSellerPartnerShopResponse {
  /** 매장 영업시간 */
  businessHours?: string;
  /** 매장 소개 컨텐츠 글 */
  contentDescription?: string;
  /** 매장소개 컨텐츠 이미지들 */
  contentImages?: string[];
  /** 매장 소개 활성화 여부 */
  enabled?: boolean;
  /** 대표 이미지 URL */
  mainImageUrl?: string;
  /** 지도 이미지 URL */
  mapImageUrl?: string;
  /** 닉네임 */
  nickname?: string;
  /** 파트너 샵 정보 ID */
  partnerShopInfoID?: number;
  /** 프로셀러 키워드 */
  prosellerKeywords?: string[];
  /** 한줄소개 */
  shortIntroduction?: string;
  /** 매장 쿠폰 */
  storeCoupons?: DomainPartnerShopStoreCouponResponse[];
  /** 간략 위치 */
  storeLocations?: DomainPartnerShopInfoStoreLocations;
  /** 유저 아이디 */
  userID?: number;
}

export type DomainProSellerPurchaseHistoryType =
  | 'PRO_SELLER_PURCHASE_HISTORY_EXIST_OR_NOT'
  | 'PRO_SELLER_PURCHASE_HISTORY_EXIST'
  | 'PRO_SELLER_PURCHASE_HISTORY_NOT_EXIST';

export interface DomainProSellerReviewStatisticsResponse {
  averageReviewRating?: number;
  totalReviewCount?: number;
}

export interface DomainProSellerUserItem {
  /** 상점 소개 */
  bio?: string;
  /** 상품수가 많은 브랜드 3개 */
  brandTop3?: string[];
  /** 상점 이미지 */
  images?: string[];
  /** 조회한 유저 기준 팔로우 여부 */
  isFollowing?: boolean;
  /** 상점 노출 여부 */
  isVisibleProSeller?: boolean;
  /** 가장 최근 할인 날짜 */
  lastDiscountPriceModifyDate?: string;
  /** 해당 프로셀러의 상품 수 */
  marketItemCount?: number;
  /** 샵의 대표 아이템 */
  marketItems?: DomainProSellerMarketItemResponse[];
  /** 최대 할인율 */
  maximumDiscountRate?: number;
  nickname?: string;
  /** Deprecated: 프로필 이미지 */
  profileImage?: string;
  /** 프로필 이미지 URL */
  profileImageURL?: string;
  /** 상점 키워드 */
  prosellerKeywords?: string[];
  /** 판매중인 아이템 수 (DiscountPriceModifyDateStart, End 에 따라 값이 달라짐. 안 넣으면 전체) */
  remainingMarketItemCount?: number;
  /** 셀러 알림 여부 */
  sellerNotificationAgreed?: boolean;
  /** 아이템 총 갯수 (DiscountPriceModifyDateStart, End 에 따라 값이 달라짐. 안 넣으면 전체) */
  totalMarketItemCount?: number;
  userID?: number;
}

export interface DomainProSellerUserItemV2 {
  /** 상점 소개 */
  bio?: string;
  /** 유저 팔로워 수 */
  followerCount?: number;
  /** 조회한 유저 기준 팔로우 여부 */
  isFollowing?: boolean;
  /** 상점 노출 여부 */
  isVisibleProSeller?: boolean;
  /** 최대 할인율 */
  maximumDiscountRate?: number;
  nickname?: string;
  /** 상점 정보 키워드 */
  proSellerInfoKeywords?: string[];
  /** 상점 키워드 */
  proSellerKeywords?: string[];
  /** 상점 라벨 */
  proSellerLabels?: DomainProSellerLabelType[];
  /** 리뷰 통계 */
  proSellerReviewStatistcs?: DomainProSellerReviewStatisticsResponse;
  /** Deprecated: 프로필 이미지 */
  profileImage?: string;
  /** 프로필 이미지 URL */
  profileImageURL?: string;
  /** 판매중인 아이템 수 */
  remainingMarketItemCount?: number;
  /** 아이템 총 갯수 */
  totalMarketItemCount?: number;
  userID: number;
}

export type DomainProductFocusType =
  | 'PROSELLER-INFO_PRODUCT-FOCUS-TYPE_COST-EFFECTIVE'
  | 'PROSELLER-INFO_PRODUCT-FOCUS-TYPE_LUXURY'
  | 'PROSELLER-INFO_PRODUCT-FOCUS-TYPE_UNIQUE';

export interface DomainPromotionBannerImages {
  /**
   * 바텀시트 배너 이미지
   * @example "https://image.com/bottom-sheet-banner.png"
   */
  bottomSheetImageURL?: string;
  /**
   * 옷장 배너 이미지
   * @example "https://image.com/closet-banner.png"
   */
  closetImageURL?: string;
  /**
   * 마켓 배너 이미지
   * @example "https://image.com/market-banner.png"
   */
  marketImageURL?: string;
  /**
   * 마이페이지 배너 이미지
   * @example "https://image.com/my-page-banner.png"
   */
  myPageImageURL?: string;
}

export type DomainPromotionBannerType = 'DIRECT' | 'SPECIAL_SALE_AUTO';

export interface DomainPromotionContentNavigation {
  /** @example "market://items" */
  deeplink: string;
  /** @example "https://image.com/deeplink.png" */
  imageURL: string;
}

export type DomainPromotionCreationType = 'BANNER' | 'POPUP';

export interface DomainPromotionDisplay {
  /**
   * Deprecated: TODO 하위 호환을 위해 남겨둠
   * @example "https://image.com/banner.png"
   */
  bannerImageURL?: string;
  bannerImages: DomainPromotionBannerImages;
  /** @example "" */
  clientCustomConfig?: string;
  /** @example ["컨텐츠 이미지"] */
  contentImageURLs?: string[];
  contentNavigation?: DomainPromotionContentNavigation;
  positions: DomainPromotionDisplayPosition[];
  /** @example "프로모션 제목" */
  promotionTitle: string;
  /** @example "" */
  sellerNickname?: string;
}

export type DomainPromotionDisplayPosition = 'MARKET' | 'CLOSET' | 'MY_PAGE' | 'BOTTOM_SHEET';

export interface DomainPromotionDisplayRequest {
  /**
   * Deprecated: TODO 하위 호환을 위해 남겨둠
   * @example "https://image.com/banner.png"
   */
  bannerImageURL?: string;
  bannerImages: DomainPromotionBannerImages;
  /** @example "" */
  clientCustomConfig?: string;
  /** @example ["컨텐츠 이미지"] */
  contentImageURLs?: string[];
  contentNavigation?: DomainPromotionContentNavigation;
  positions: DomainPromotionDisplayPosition[];
  /** @example "프로모션 제목" */
  promotionTitle: string;
  /** @example "" */
  sellerNickname?: string;
}

export interface DomainPromotionInfoDTO {
  GAParameter: string;
  bannerType?: DomainPromotionBannerType;
  /** @example 1 */
  order: number;
  /**
   * web
   * 		- 쿼리/키워드: webservice/path (서버)
   * 		- 판매자 프로필 유형: "" (프론트)
   * 		- 외부유형: /path (백오피스)
   * 		app
   * 		- 쿼리/키워드: /path (서버)
   * 		- 판매자 프로필 유형: "" (프론트)
   * 		- 외부유형: /path (백오피스)
   * @example "/market-items"
   */
  path: string;
  promotionDisplay: DomainPromotionDisplay;
  promotionInfoID: number;
  /**
   * 프론트에서 사용하는 키 (unix second)
   * @example 1687324366
   */
  promotionKey: number;
  promotionQuery: DomainPromotionQuery;
  promotionType: DomainPromotionType;
  sellerID?: number;
  userVisibleCondition: DomainUserVisibleCondition;
}

export interface DomainPromotionInfoRequest {
  GAParameter: string;
  bannerType?: DomainPromotionBannerType;
  creationType: 'BANNER' | 'POPUP';
  /** @example 1 */
  order: number;
  /**
   * web
   * 		- 쿼리/키워드: webservice/path (서버)
   * 		- 판매자 프로필 유형: "필요없음" (프론트)
   * 		- 외부유형: /path (백오피스)
   * 		- 이미지/컨텐츠: "필요없음" (서버)
   * 		- 쿠폰 유형: "필요없음" (서버)
   * 		app
   * 		- 쿼리/키워드: /path (서버)
   * 		- 판매자 프로필 유형: "필요없음" (프론트)
   * 		- 외부유형: /path (백오피스)
   * 		- 이미지/컨텐츠: "필요없음" (서버)
   * 		- 쿠폰 유형: "필요없음" (서버)
   * @example "/market-items"
   */
  path: string;
  promotionDisplay: DomainPromotionDisplayRequest;
  promotionInfoID?: number;
  /**
   * 프론트에서 사용하는 키 (unix second)
   * @example 1687324366
   */
  promotionKey: number;
  promotionQuery: DomainPromotionQueryRequest;
  promotionType: DomainPromotionType;
  sellerID?: number;
  userVisibleCondition: DomainUserVisibleConditionRequest;
}

export interface DomainPromotionQuery {
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /**
   * 포함할 브랜드 태그 ID
   * @example [1,2,3]
   */
  brandTagIDs?: number[];
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /** @example 1 */
  couponID?: number;
  /** @example 50 */
  discountRateMax?: number;
  /** @example 10 */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?: string;
  /**
   * 포함할 성별
   * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
   */
  genderWears?: DomainGenderWearType[];
  /**
   * 무료 배송만
   * @example true
   */
  isFreeShipping?: boolean;
  /**
   * 포함할 공식 브랜드 ID
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  orderField?: DomainMarketItemOrderField;
  /**
   * 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /**
   * 검색어
   * @example "검색어"
   */
  searchKeyword?: string;
  /** @example 1 */
  sellerID?: number;
  sortOrder?: DomainSortOrder;
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: DomainMarketItemStatus[];
  /** @example "" */
  textSearch?: string;
}

export interface DomainPromotionQueryRequest {
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /**
   * 포함할 브랜드 태그 ID
   * @example [1,2,3]
   */
  brandTagIDs?: number[];
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  couponID?: number;
  /** @example 50 */
  discountRateMax?: number;
  /** @example 10 */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?: string;
  /**
   * 포함할 성별
   * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
   */
  genderWears?: DomainGenderWearType[];
  /**
   * 무료 배송만
   * @example true
   */
  isFreeShipping?: boolean;
  /**
   * 포함할 공식 브랜드 ID
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  orderField?: DomainMarketItemOrderField;
  /**
   * 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /**
   * 검색어
   * @example "검색어"
   */
  searchKeyword?: string;
  /** @example 1 */
  sellerID?: number;
  sortOrder?: DomainSortOrder;
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: DomainMarketItemStatus[];
  /** @example "" */
  textSearch?: string;
}

export type DomainPromotionType =
  | 'MARKET_ITEM_CURATION'
  | 'MARKET_ITEM_EXTERNAL_URL'
  | 'MARKET_ITEM_SELLER_PROFILE'
  | 'MARKET_ITEM_IMAGE_CONTENT'
  | 'COUPON';

export interface DomainQuery {
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /**
   * 포함할 브랜드 태그 ID
   * @example [1,2,3]
   */
  brandTagIDs?: number[];
  /**
   * 포함할 브랜드 태그 타이틀
   * @example ["스포츠","아웃도어"]
   */
  brandTagTitles?: string[];
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 최대가격
   * @example 100000
   */
  discountPriceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  discountPriceMin?: number;
  /**
   * 최대 할인율
   * @example 50
   */
  discountRateMax?: number;
  /**
   * 최소 할인율 (최소 할인율 0 이상)
   * @example 10
   */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
   */
  genderWears?: DomainGenderWearType[];
  /**
   * 무료 배송만
   * @example true
   */
  isFreeShipping?: boolean;
  /**
   * 포함할 공식 브랜드 ID
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /** 정렬 필드 */
  orderField?: DomainMarketItemOrderField;
  /**
   * 검색어 기반 개인화                                                                                                                                                                                                                     // 개인화 추천 - 검색 기록 기반                                               // 검색어 기반 개인화 추천 여부
   * @example true
   */
  personalizedWithSearchKeyword?: boolean;
  /**
   * 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /**
   * 검색어
   * @example "검색어"
   */
  searchKeyword?: string;
  /** @example 1 */
  sellerID?: number;
  /** 정렬 순서 */
  sortOrder?: DomainSortOrder;
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: string[];
  /** @example "" */
  textSearch?: string;
}

export interface DomainQueryRequest {
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /**
   * 포함할 브랜드 태그 ID
   * @example [1,2,3]
   */
  brandTagIDs?: number[];
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 최대 가격
   * @example 100000
   */
  discountPriceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  discountPriceMin?: number;
  /** @example 50 */
  discountRateMax?: number;
  /** @example 10 */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
   */
  genderWears?: DomainGenderWearType[];
  /**
   * 프로셀러 공식 입점 날짜 시작일 (Gte)
   * @example "2024-04-05T04:24:25.966Z"
   */
  gteOfficiallyEnteredDate?: string;
  /**
   * 무료 배송만
   * @example true
   */
  isFreeShipping?: boolean;
  /**
   * 포함할 공식 브랜드 ID
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /** 마켓 아이템 정렬 필드 */
  orderField?: DomainMarketItemOrderField;
  personalizedWithSearchKeyword?: boolean;
  /**
   * TODO 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * TODO 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /** 프로셀러 정렬 필드 */
  proSellerOrderField?: DomainProSellerOrderField;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /**
   * 검색어
   * @example "검색어"
   */
  searchKeyword?: string;
  /** @example 1 */
  sellerID?: number;
  sortOrder?: DomainSortOrder;
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: string[];
  /** @example "" */
  textSearch?: string;
}

export interface DomainReReturnOrderByBuyerRequest {
  orderItems: DomainReturnOrderItem[];
}

export interface DomainRealtimeBunjangCrawlingRequest {
  /**
   * 중고 아이템 ID
   * @example [1,2,3,4,5]
   */
  marketItemIDs: number[];
  /**
   * 상품의 판매자 UserID
   * @example 1
   */
  sellerID: number;
}

export interface DomainRealtimeBunjangCrawlingResponse {
  /** 가격이 변경된 상품이 있는지 여부 */
  hasModifiedPrice?: boolean;
  /** 품절된 상품이 있는지 여부 */
  hasSoldout?: boolean;
}

export interface DomainRecommSectionInfoHistory {
  createDate: string;
  sectionInfoHistoryID: number;
  sectionInfos: DomainSectionInfo[];
}

export interface DomainRefreshTokenResponse {
  accessToken?: string;
}

export type DomainRefundLogixType =
  | 'REFUND_LOGIX-TYPE_ALL'
  | 'REFUND_LOGIX-TYPE_BUYER_DIRECT'
  | 'REFUND_LOGIX-TYPE_SELLER_DIRECT';

export type DomainRefundReason =
  | 'REFUND_REASON_NOT_SATISFIED'
  | 'REFUND_REASON_BUYER_MISTAKE'
  | 'REFUND_REASON_WRONG_ITEM'
  | 'REFUND_REASON_WRONG_DELIVERY';

export interface DomainRejectRefundSellerRequest {
  orderItemIDs: number[];
}

export interface DomainRejectReturnProSellerRequest {
  orderItemIDs: number[];
  rejectReturnReason: DomainOrderReturnRejectReason;
  rejectReturnReasonDetails?: string;
}

export interface DomainReplacePromotionInfosRequest {
  promotionInfos?: DomainPromotionInfoRequest[];
}

export interface DomainReplaceRecommInfosRequest {
  sectionInfos?: DomainSectionInfoRequest[];
}

export interface DomainReportItem {
  count?: number;
  createDate?: string;
  detail?: string;
  modifyDate?: string;
  nickname?: string;
  reason?: string;
  reportID?: number;
  reportType?: string;
  reportedID?: number;
  reportedUserID?: number;
  userID?: number;
}

export interface DomainReturnOrderByBuyerRequest {
  /** 메모 */
  address: string;
  /** 상세주소 */
  addressDetail: string;
  /** 수거해주세요, 직접 보낼게요 */
  method: DomainRefundLogixType;
  /** 수거 정보의 사람 이름 */
  name: string;
  orderItems: DomainReturnOrderItem[];
  /** 연락처 */
  phone: string;
  photos: string[];
  /** 우편번호 */
  zipCode: string;
}

export interface DomainReturnOrderInfoByBuyerResponse {
  /** 취소 금액 */
  cancelAmount?: number;
  /** 환불 수단 */
  payMethod?: DomainPayMethod;
  /** 환불 차감 쿠폰 금액 */
  refundDeductionCouponAmount?: number;
  /** 환불 차감 배송비 */
  refundDeductionLogixAmount?: number;
  /** 환불 차감 반품 배송비 */
  refundDeductionLogixReturnAmount?: number;
  /** 환불 차감 포인트 금액 */
  refundDeductionPointAmount?: number;
  /** 환불 차감 금액 */
  refundDeductionTotalAmount?: number;
  /** 반품 추가 주소 */
  returnAdditionalAddress?: string;
  /** 반품 주소 */
  returnAddress?: string;
  /** 환불 금액 */
  returnAmount?: number;
  /** 반품 받는 사람 연락처 */
  returnPhone?: string;
  /** 반품 받는 사람 */
  returnRecipient?: string;
  /** 반품 우편번호 */
  returnZipCode?: string;
  /** 반품 가능 여부 */
  returnable?: boolean;
}

export interface DomainReturnOrderItem {
  orderItemID: number;
  reasonDetails: string;
  reasonTags: DomainReturnReasonTagType[];
  reasonType: DomainRefundReason;
}

export interface DomainReturnProcessingDay {
  /** 평균 반품처리 속도 (일 단위) */
  days?: number;
  /** 등급 (A, B, C, D, E) */
  grade?: string;
  /** 상위 5%의 점수 */
  top5Days?: number;
}

export interface DomainReturnReasonRate {
  /** 반품사유 태그별 개수 */
  count?: number;
  /** 반품사유 태그 */
  returnReasonTag?: DomainReturnReasonTagType;
}

export type DomainReturnReasonTagType =
  | 'RETURN_REASON_NOT_SATISFIED'
  | 'RETURN_REASON_SIZE_MISMATCH'
  | 'RETURN_REASON_NOT_CLEAN'
  | 'RETURN_REASON_DESCRIPTION_MISMATCH'
  | 'RETURN_REASON_COLOR_MISMATCH'
  | 'RETURN_REASON_MATERIAL_MISMATCH'
  | 'RETURN_REASON_NOT_AUTHENTIC'
  | 'RETURN_REASON_OTHER';

export interface DomainReturnablePurchaseOrderItemsResponse {
  orderItems?: DomainOrderItemDetailDto[];
}

export interface DomainReviewUserResponse {
  /**
   * 리뷰를 하는/받는 유저 닉네임
   * @example "GiraffeWithCode"
   */
  nickname: string;
  /**
   * 리뷰를 하는/받는 유저 프로필 이미지 URL
   * @example "https://s3.ap-northeast-2.amazonaws.com/brandi-static/brandi_profile_image/162615/162615_2019-11-27_15:00:00.000000.png"
   */
  profileImageURL?: string;
  /**
   * 리뷰를 하는/받는 유저 ID
   * @example 162615
   */
  userID: number;
}

export interface DomainRewardPointResponse {
  /** @example "" */
  createDate: string;
  /** @example "" */
  issueDate: string;
  /** @example 1000 */
  point: number;
  /** @example "리뷰작성 포인트(Title...)" */
  text: string;
}

export type DomainRewardPointStatus =
  | 'REWARD-POINT_STATUS_SAVED'
  | 'REWARD-POINT_STATUS_SAVE-CANCELED'
  | 'REWARD-POINT_STATUS_SAVE-AWAITED'
  | 'REWARD-POINT_STATUS_USED';

export interface DomainSearchABTestDto {
  createdAt?: string;
  deletedAt?: string;
  id?: number;
  /** not empty 조건 */
  policies?: DomainSearchPolicyName[];
  testName?: DomainMarketItemOrderField;
  updatedAt?: string;
}

export interface DomainSearchBrandResponse {
  /** @example "THE NORTH FACE" */
  brandName: string;
}

export interface DomainSearchCategoriesResponse {
  categories?: DomainCategoryHierarchyWithGenderWear[];
}

export interface DomainSearchNicknameResponse {
  /** @example true */
  hasNext?: boolean;
  users?: DomainSearchNicknameUser[];
}

export interface DomainSearchNicknameUser {
  /**
   * 배경 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  backgroundImageURL?: string;
  /**
   * 조회한 유저 기준 팔로우 여부
   * @example true
   */
  isFollowing: boolean;
  /**
   * 해당 유저가 프로 셀러인지 여부
   * @example false
   */
  isProSeller: boolean;
  /**
   * 닉네임
   * @example "hkja1"
   */
  nickname: string;
  /**
   * 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  profileImageURL?: string;
  /** 판매중인 아이템 수 */
  remainingMarketItemCount?: number;
  /**
   * 유저 아이디
   * @example 620687
   */
  userID: number;
}

export type DomainSearchPolicyName =
  | 'SearchPolicyByGeneral'
  | '취향 분석/내 사이즈/추천순 로직'
  | '업로드 후 2주 이내 조회수 + 찜 수'
  | '신상품에 가점';

export type DomainSearchType = 'LIKE' | 'EQUAL';

export interface DomainSectionInfo {
  display: DomainDisplay;
  /** @example 1 */
  order: number;
  /**
   * api path
   * @example "/market-items"
   */
  path: string;
  query: DomainQuery;
  /**
   * 프론트에서 사용하는 키 (unix second)
   * @example 1687324366
   */
  sectionKey: number;
  sectionType: DomainSectionType;
  /** Deprecated: TODO 하위 호환을 위해 남겨둠. 삭제 필요 */
  userPreferenceFilter?: DomainUserPreferenceFilter;
  userVisibleCondition: DomainUserVisibleCondition;
}

export interface DomainSectionInfoRequest {
  display: DomainDisplayRequest;
  /** @example 1 */
  order: number;
  query: DomainQueryRequest;
  /**
   * 프론트에서 사용하는 키 (unix second)
   * @example 1687324366
   */
  sectionKey: number;
  sectionType: DomainSectionType;
  userVisibleCondition: DomainUserVisibleConditionRequest;
}

export type DomainSectionType =
  | 'MARKET_ITEM_CURATION'
  | 'MARKET_ITEM_RECENTLY_VIEWED'
  | 'MARKET_ITEM_SPECIFIC_USER'
  | 'MARKET_ITEM_ONBOARDING_PREFERENCE'
  | 'MARKET_ITEM_REALTIME_REVIEW'
  | 'MARKET_ITEM_POPULAR_BRANDS'
  | 'MARKET_ITEM_POPULAR_USERS'
  | 'MARKET_ITEM_COORDINATES'
  | 'MARKET_ITEM_SELLER_RECOMMEND'
  | 'MARKET_ITEM_NEWLY_PROSELLER';

export interface DomainSendEmailVerificationCodeRequest {
  /** @example "123@naver.com" */
  email: string;
}

export interface DomainSendMobileVerificationCodeRequest {
  /**
   * 국가 전화번호
   * @example "+82"
   */
  dialingCode: string;
  /**
   * 휴대폰 번호
   * @example "01012345678"
   */
  mobile: string;
  /** @example "asjklfjekljke" */
  recaptcha: string;
}

export interface DomainSendMobileVerificationCodeResponse {
  /** 인증코드 만료 시간 */
  expiredAt: number;
}

export type DomainServiceOptionsType =
  | 'PROSELLER-INFO_SERVICE-OPTIONS-TYPE_LAUNDRY'
  | 'PROSELLER-INFO_SERVICE-OPTIONS-TYPE_STEAM';

export interface DomainSettlementResponse {
  /** 판매자 예금주명 */
  accountHolder: string;
  /** 판매자 계좌번호 */
  accountNumber: string;
  /** 에이클로젯 보상비 (배송비 지원+반품 배송비) */
  aclosetSupportedAmount: number;
  /** TODO Deprecated: 5.2.0 LegacyAmount */
  amount: number;
  /** 요율이 제거된 판매 금액 (!!!json tag = amountWithoutPgFee) */
  amountWithoutPgFee: number;
  /** 판매자 은행 */
  bankName: string;
  /** 구매자가 결제한 금액 */
  buyerAmount: number;
  /** 쿠폰 할인 금액 */
  couponDiscountAmount: number;
  /** 구매확정일 */
  createDate: number;
  /** 정산일 */
  endDate?: number;
  includeFirstOrderReturn: boolean;
  isFirstOrder: boolean;
  isPriceOffered: boolean;
  marketItemThumbnail: string;
  marketItemTitle: string;
  modifyDate: number;
  /** 결제 타입. enum = [ONLINE, STORE] */
  paymentType: DomainPaymentType;
  /** 포인트 할인 금액 */
  pointDiscountAmount: number;
  /** 포트원 정산일 */
  portonePaidAt?: number;
  /** 정산이 취소된다면 취소 사유 */
  reason?: string;
  /** 환불 대기 여부 */
  refundPending: boolean;
  /** 판매자가 정산받을 금액 */
  sellerAmount: number;
  /** 셀러 쿠폰 할인 금액 */
  sellerCouponDiscountAmount: number;
  /** 정산 아이디 */
  settlementID: number;
  /** 판매 상태 */
  status:
    | 'SETTLEMENT_STATUS_UNAUDITED'
    | 'SETTLEMENT_STATUS_SCHEDULED'
    | 'SETTLEMENT_STATUS_COMPLETED'
    | 'SETTLEMENT_STATUS_HOLD';
  /** 거래 아이디 */
  txID: number;
  /** 판매자 아이디 */
  userID: number;
}

export interface DomainShipStartOrderRate {
  /** 등급 (A, B, C, D, E) */
  grade?: string;
  /** 배송시작 점수 (2일 이내 처리된 비율. 0-100 범위) */
  rating?: number;
  /** 1일 이내 처리된 개수 */
  shipStartIn1D?: number;
  /** 1일 초과 2일 이내 처리된 개수 */
  shipStartIn2D?: number;
  /** 2일 초과 3일 이내 처리된 개수 */
  shipStartIn3D?: number;
  /** 3일 초과 4일 이내 처리된 개수 */
  shipStartIn4D?: number;
  /** 4일 초과로 처리된 개수 */
  shipStartIn5D?: number;
  /** 상위 5%의 점수 */
  top5Rating?: number;
}

export interface DomainShopDescription {
  /** 상점 키워드 (예: 클래식, 펑키) */
  keywords?: DomainKeywordsType[];
  /** 상점 원산지 국가 */
  originCountries?: DomainOriginCountryType[];
  /** 상점이 주로 판매하는 상품 카테고리 (예: 가성비, 명품) */
  productFocuses?: DomainProductFocusType[];
  /** 상점이 제공하는 서비스 (예: 세탁, 스팀살균, 빠른배송, 반품가능) */
  serviceOptions?: DomainServiceOptionsType[];
  /** 상점 위치 */
  storeLocations?: DomainStoreLocations;
  /** 상점 타겟 연령 */
  targetAges?: DomainTargetAgeType[];
  /** 상점 타겟 성별 */
  targetGenders?: DomainTargetGenderType[];
}

export interface DomainShopTaskItemSizeLength {
  prefix?: string;
  sizeTarget?: string;
  value?: number;
}

export type DomainShoppingType = 'costEffectiveness' | 'luxury' | 'vintageLimited';

export interface DomainSignInForLookoAIRequest {
  email: string;
  password: string;
}

export interface DomainSignInForLookoAIResponse {
  /** @example "accessToken" */
  accessToken: string;
  /** @example "refreshToken" */
  refreshToken: string;
  /** @example 620687 */
  userID: number;
  /** @example "ROLE_OWNER" */
  userRole: string;
}

export interface DomainSignInServiceRequest {
  /**
   * 3rd party access token
   * @example "access_token"
   */
  accessToken?: string;
  /** @example "secondsold" */
  appName?: string;
  /** @example "1.0" */
  appVersion?: string;
  /** @example "Mobile" */
  device?: string;
  /** @example "abcd" */
  deviceID?: string;
  /**
   * Provider, OAuth or OIDC 제공업체
   * @example "NORMAL|GOOGLE|FACEBOOK|KAKAO|APPLE"
   */
  division: string;
  /** original fields */
  email: string;
  /** @example "fcm_token" */
  fcmToken?: string;
  /**
   * (현재) APPLE 로그인의 경우에만 필요
   * @example "id_token"
   */
  idToken?: string;
  /** @example "OSX" */
  os?: string;
  /** @example "1.0" */
  osVersion?: string;
  /** 일반 로그인시 필요 */
  password?: string;
  /** @example "UTC|KST" */
  timezoneStr?: string;
}

export interface DomainSignInServiceResponse {
  /** @example "accessToken" */
  accessToken: string;
  duplicateDivisions?: string[];
  existUserInfo?: DomainExistUser;
  isGuest?: boolean;
  /** @example "refreshToken" */
  refreshToken: string;
  success?: boolean;
  /** @example 620687 */
  userID: number;
}

export interface DomainSignInWithLoginTokenRequest {
  /** @example "1.0" */
  appVersion?: string;
  /** @example "Mobile" */
  device?: string;
  /** @example "abcd" */
  deviceID?: string;
  /**
   * original fields
   * @example "fcm_token"
   */
  fcmToken?: string;
  /** @example "OSX" */
  os?: string;
  /** @example "1.0" */
  osVersion?: string;
  /** @example "UTC|KST" */
  timezoneStr?: string;
  /** 로그인 토큰 */
  token: string;
}

export interface DomainSignInWithLoginTokenResponse {
  /**
   * 액세스토큰
   * @example "accessToken"
   */
  accessToken: string;
  /**
   * 게스트 여부
   * @example false
   */
  isGuest: boolean;
  /**
   * 리프레시토큰
   * @example "refreshToken"
   */
  refreshToken: string;
  /**
   * 성공 여부
   * @example true
   */
  success: boolean;
  /**
   * UserID
   * @example 620687
   */
  userID: number;
}

export interface DomainSignUpGuestRequest {
  /** @example "1.0" */
  appVersion?: string;
  /** @example "Mobile" */
  device?: string;
  /** Username으로 등록 */
  deviceID?: string;
  language?: string;
  nation?: string;
  onboardingItemAttachID?: number;
  /** @example "OSX" */
  os?: string;
  /** @example "1.0" */
  osVersion?: string;
  /** @example "UTC|KST" */
  timezoneStr?: string;
}

export interface DomainSignUpGuestResponse {
  accessToken?: string;
  refreshToken?: string;
  success?: boolean;
  userID?: number;
}

export interface DomainSignUpNormalRequest {
  /** @example "2000-01-01" */
  dateOfBirth: string;
  email: string;
  fcmToken: string;
  /** @example "FEMALE, MALE, NONBINARY, RATHERNOTSAY" */
  gender: string;
  language: string;
  nation: string;
  nickname: string;
  onboardingItemAttachID?: number;
  password: string;
  /** portone CI 등록을 위한 portone 인증 결과 값 */
  portoneIdentityVerificationID?: string;
  /**
   * 기타 정보들
   * @example "ROLE_USER, ROLE_OWNER, ROLE_MANAGER"
   */
  role: string;
}

export interface DomainSignUpProSellerRequest {
  /** 예금주 */
  accountHolder: string;
  /** 계좌번호 */
  accountNumber: string;
  /** 은행명 */
  bankName: string;
  /** 사업자 주소 */
  businessAddress: string;
  /** 사업자 연락처 */
  businessContact: string;
  /** 사업자 이름 */
  businessName?: string;
  /**
   * 임의의 값
   * @example "2000-01-01"
   */
  dateOfBirth: string;
  email: string;
  /**
   * 중요하지 않은 정보들
   * @example "FEMALE, MALE, NONBINARY, RATHERNOTSAY"
   */
  gender: string;
  /** CS 담당 연락처 */
  inquiryContact: string;
  /** 채팅 답변 가능시간 */
  inquiryPossibleTime: string;
  /** 공식 입점 여부 */
  isOfficiallyEntered?: boolean;
  /** 임의의 값 */
  language: string;
  /** 배송 정책 */
  logixPolicy?: string;
  /** 지역별 배송비 */
  logixPriceByArea?: boolean;
  /** 할인 적용 최소 주문 금액 */
  minOrderAmountForOffer?: number;
  /** 임의의 값 */
  nation: string;
  /** 샵이름 */
  nickname: string;
  /**
   * `MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE` 현재 api 에서 허용안함<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY` 현재 api 에서 허용안함<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_FREE` 배송비 무료<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_PAY` 배송비 유료 (logixPrice 필수)<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_FREE-ON-AMOUNT` 배송 (order_logix_type_free_on_amount 필수)<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_PAY-ON-QUANTITY` 배송 (order_logix_type_pay_on_quantity 필수)<br/>
   */
  orderLogixType: DomainLogixType;
  /** MARKET-ITEM_LOGIX-TYPE_FREE-ON_AMOUNT 선택시 무료 배송이 되는 금액, 입력시 최소 1이상 */
  orderLogixTypeFreeOnAmount?: number;
  /** MARKET-ITEM_LOGIX-TYPE_PAY-ON-QUANTITY 선택시 지정된 갯수마다 배송비 부과, 입력시 최소 1 이상 */
  orderLogixTypePayOnQuantity?: number;
  /** 주문 배송비 */
  orderShippingFee: DomainLogixPrice;
  password: string;
  /** 구매 수량 */
  purchaseQuantityLimit?: number;
  refundAddressInfo: DomainAddressInfoProSeller;
  /** 지정 택배사 이름 */
  refundCourierName?: string;
  /** 반품 방법 */
  refundLogixType: DomainRefundLogixType;
  /** 반품 정책 */
  refundPolicy: string;
  /** 반품 배송비 */
  refundShippingFee: DomainLogixPrice;
  /**
   * role이 다양해질 수 있음
   * @example "ROLE_OWNER"
   */
  role: string;
  /** lookoai에서 받아오는 샵 소개를 위한 정보 */
  shopDescription?: DomainShopDescription;
}

export interface DomainSignUpProSellerResponse {
  /** @example "accessToken" */
  accessToken: string;
  /** @example "refreshToken" */
  refreshToken: string;
  /** @example 620687 */
  userID: number;
}

export interface DomainSignUpSNSRequest {
  accessToken: string;
  /** @example "2006-01-02" */
  dateOfBirth: string;
  /** @example "KAKAO, APPLE, GOOGLE, FACEBOOK" */
  division: string;
  email: string;
  fcmToken: string;
  /** @example "FEMALE, MALE, NONBINARY, RATHERNOTSAY" */
  gender: string;
  /**
   * (현재) APPLE 로그인의 경우에만 필요
   * @example "identity_token"
   */
  idToken?: string;
  /** @example "en" */
  language: string;
  /** @example "KR, US, JP, CN, etc..." */
  nation: string;
  nickname: string;
  /** @example 1 */
  onboardingItemAttachID?: number;
  /** portone CI 등록을 위한 portone 인증 결과 값 */
  portoneIdentityVerificationID?: string;
  /**
   * 기타 정보들
   * @example "ROLE_USER, ROLE_OWNER, ROLE_MANAGER"
   */
  role: string;
}

export interface DomainSize {
  categoryGroup: string;
  eu: string;
  genderWear: string;
  /** International */
  it: string;
  kr: string;
  sizeID: number;
  uk: string;
  us: string;
}

export interface DomainSizeForDisplay {
  clothesFeatures?: DomainClothesFeatures[];
  clothesSizeType: DomainClothesSizeType;
  sizeLength?: DomainShopTaskItemSizeLength[];
}

export interface DomainSizeLengthFilter {
  filterSizeLengthItems: DomainFilterSizeLengthItem[];
}

export type DomainSortOrder = 'asc' | 'desc';

export interface DomainStoreCouponItem {
  /** 쿠폰 이름 */
  couponName: string;
  /** 생성일 */
  createdAt: string;
  /** 할인 금액 */
  discountAmount: number;
  /** 파트너 샵 ID */
  partnerShopInfoID: number;
  /** 판매자 userID */
  sellerID: number;
  /** 매장 쿠폰 ID */
  storeCouponID: number;
  /** 최소 결제 금액 */
  txAmountMin: number;
}

export interface DomainStoreCouponResponse {
  /** 쿠폰 이름 */
  couponName: string;
  /** 생성일 */
  createdAt: string;
  /** 할인 금액 */
  discountAmount: number;
  /** 파트너 샵 ID */
  partnerShopInfoID: number;
  /** 판매자 userID */
  sellerID: number;
  /** 매장 쿠폰 ID */
  storeCouponID: number;
  /** 최소 결제 금액 */
  txAmountMin: number;
}

export interface DomainStoreLocations {
  /** 도, 특별시, 광역시 */
  region?: string;
  /** Region에 해당하는 지역범위 */
  subRegion?: string;
}

export interface DomainSurveyHistoryResponse {
  /** 설문 히스토리 아이디 */
  id: number;
  /** 객관식 답변 리스트 */
  multipleChoiceAnswers: string[];
  /** 주관식 답변 */
  subjectiveAnswer: string;
  /** 설문 답변 타입 (주관식, 객관식) */
  surveyAnswerType: string;
  /** 설문 조사가 속한 그룹 */
  surveyGroupType: string;
  /** 설문 조사 버전 (회차) */
  surveyGroupVersion: string;
  /** 프론트 분들께서 추가해주실 설문에 대한 부가적인 json 데이터 */
  surveyMetadata: string;
  /** 설문 제목 */
  surveyTitle: string;
  /** 유저 아이디 */
  userID: number;
}

export type DomainTargetAgeType =
  | 'PROSELLER-INFO_TARGET-AGE-TYPE_INFANTS-CHILDREN'
  | 'PROSELLER-INFO_TARGET-AGE-TYPE_TEENS-TWENTIES'
  | 'PROSELLER-INFO_TARGET-AGE-TYPE_TWENTIES-THIRTIES'
  | 'PROSELLER-INFO_TARGET-AGE-TYPE_THIRTIES-FORTIES'
  | 'PROSELLER-INFO_TARGET-AGE-TYPE_FORTIES-AND-ABOVE';

export type DomainTargetGenderType =
  | 'PROSELLER-INFO_TARGET-GENDER-TYPE_WOMEN'
  | 'PROSELLER-INFO_TARGET-GENDER-TYPE_MEN'
  | 'PROSELLER-INFO_TARGET-GENDER-TYPE_KIDS'
  | 'PROSELLER-INFO_TARGET-GENDER-TYPE_UNISEX';

export interface DomainTopCategory {
  id?: number;
  middleCategory?: DomainMiddleCategory[];
  name?: string;
}

export interface DomainTranslation {
  code: string;
  en: string;
  es: string;
  fr: string;
  ko: string;
  ru: string;
}

export interface DomainUnbanUserRequest {
  bannedUserID: number;
}

export interface DomainUpdateCommunityPostRequest {
  /**
   * 게시판 종류
   * @example "VINTAGE_SHOP_RECOMMENDATION"
   */
  board: DomainCommunityBoard;
  /**
   * 게시글 내용. 5000자 이내
   * @example "Test Content"
   */
  content: string;
  /**
   * 게시글에 등록할 이미지 URL 목록. (기존 목록을 덮어씌움)
   * @example ["https://test.com/test1.jpg","https://test.com/test2.jpg"]
   */
  imageURLs?: string[];
  /**
   * 게시글에 등록할 중고마켓 아이템 ID 목록. (기존 목록을 덮어씌움)
   * @example [13,2434,123143]
   */
  marketItemIDs?: number[];
  /**
   * 게시글 제목. 50자 이내
   * @example "Test Title"
   */
  title: string;
}

export interface DomainUpdateMarketItemImageRequest {
  /**
   * 중고 아이템 수정 시 수정할 이미지 ID
   * @example 6251
   */
  imageID: number;
  /**
   * 대표이미지 여부
   * @example false
   */
  isMain: boolean;
  /**
   * 순서 수정 시 순서 번호
   * @example 1
   */
  order: number;
  /** @example "http://naver.com" */
  thumbnailURL: string;
}

export interface DomainUpdateMarketItemReviewRequest {
  /**
   * 리뷰 내용
   * @example "매너도 좋고 친절하세요 가방을 샀는데 패딩을 덤으로 주시네요 ㅜㅜ"
   */
  comment: string;
  /** 리뷰 사진 */
  images: DomainMarketItemReviewImageRequest[];
  /**
   * 평점 5점 만점
   * @example 5
   */
  rating: number;
  /** 리뷰 태그 */
  reviewTags?: DomainMarketItemReviewTag[];
  /**
   * TODO: RevieweeID Validation 필요
   * @example 626723
   */
  revieweeID: number;
  /** 사이즈 태그 */
  sizeTags?: DomainMarketItemReviewSizeTag[];
  /** 보물 태그 */
  treasureTags?: DomainMarketItemReviewTreasureTag[];
}

export interface DomainUpdateMarketItemV2Request {
  bottomTotalLength?: number;
  bottomWaist?: number;
  /**
   * 중고 아이템 브랜드 이름
   * @example "ZARA"
   */
  brandName: string;
  /**
   * 중고 아이템 카테고리 ID
   * @example 25
   */
  categoryID: number;
  /**
   * 중고 아이템 색상 ID 리스트
   * @example [2,4,6]
   */
  colorIDs?: number[];
  /** 중고 아이템 추가 이미지 목록 */
  createImages?: DomainMarketItemImageRequest[];
  /** 중고 아이템 삭제 이미지 목록 */
  deleteImages?: DomainDeleteMarketItemImageRequest[];
  /**
   * 중고 아이템 내용
   * @example "직거래는 강남역에서"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 100000000
   */
  discountPrice: number;
  fabrics?: string[];
  /**
   * 중고 아이템 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear:
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_GIRL';
  itemOrigin?: string;
  keywords: string[];
  logixID?: number;
  /** 배송비 */
  logixPrice: DomainLogixPrice;
  /**
   * 배송 타입
   * @example "MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE,MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY"
   */
  logixType: string;
  /** @example 1 */
  materialID?: number;
  neck?: string;
  /** @example 1 */
  patternID?: number;
  /**
   * 중고 아이템 가격
   * @example 150000000
   */
  price: number;
  /**
   * 중고 아이템 깨끗함 상태
   * @example "TBD"
   */
  quality?: string;
  raglan?: DomainMarketItemRaglanType[];
  shoulderPad?: DomainMarketItemShoulderPadType[];
  /**
   * 중고 아이템 사이즈
   * @example "XS"
   */
  size?: string;
  sizeForDisplay?: DomainSizeForDisplay;
  /**
   * 중고 아이템 사이즈 ID
   * @example 1
   */
  sizeID?: number;
  /**
   * 중고 아이템 사이즈 지역
   * @example "us"
   */
  sizeRegion?: string;
  sleeveLength?: string;
  /**
   * 중고 아이템 제목
   * @example "그거 노스페이스가 아니라 사실 사우스 페이스였어요ㅠㅠ"
   */
  title: string;
  topChest?: number;
  topShoulder?: number;
  topSleeveLength?: number;
  topTotalLength?: number;
  /** 중고 아이템 수정 이미지 목록 */
  updateImages?: DomainUpdateMarketItemImageRequest[];
  waistBanding?: DomainMarketItemWaistBandingType[];
}

export interface DomainUpdateOrderItemTooltipRequest {
  shouldDisplayTooltip?: boolean;
}

export interface DomainUpdateProSellerLogixForLookoAIReponse {
  /** CS 담당 연락처 */
  afterServicePhoneNumber?: string;
  /** 택배사 */
  courierCompany?: string;
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeOnAmount?: number;
  /** 공급사명 노출 여부 */
  isVisible?: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea?: boolean;
  /** 배송정보 ID */
  logixID?: number;
  /** 공급사명(지점명) */
  logixName?: string;
  /** 배송 정책 */
  logixPolicy?: string;
  /** 배송비 */
  logixPrice?: DomainLogixPrice;
  /** 배송 타입 */
  logixType?: DomainLogixType;
  /** 프로 셀러 ID */
  proSellerID?: number;
  /** 최대 구매 수량 */
  purchaseQuantity?: number;
  /** 수거 방법 */
  refundLogixType?: DomainRefundLogixType;
  /** 반품 주소 */
  returnAddress?: string;
  /** 반품 상세 주소 */
  returnAddressDetail?: string;
  /** 반품 배송비 */
  returnFee?: number;
  /** 반품 이름 */
  returnName?: string;
  /** 반품 정책 */
  returnPolicy?: string;
  /** 반품 우편 번호 */
  returnZipCode?: string;
}

export interface DomainUpdateProSellerLogixForLookoAIRequest {
  /** CS 담당 연락처 */
  afterServicePhoneNumber?: string;
  /** 택배사 */
  courierCompany?: string;
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeOnAmount?: number;
  /** 공급사명 노출 여부 */
  isVisible?: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea?: boolean;
  /** 배송정보 ID */
  logixID?: number;
  /** 공급사명(지점명) */
  logixName?: string;
  /** 배송 정책 */
  logixPolicy?: string;
  /** 배송비 */
  logixPrice?: DomainLogixPrice;
  /** 배송 타입 */
  logixType?: DomainLogixType;
  /** 최대 구매 수량 */
  purchaseQuantity?: number;
  /** 수거 방법 */
  refundLogixType?: DomainRefundLogixType;
  /** 반품 주소 */
  returnAddress?: string;
  /** 반품 상세 주소 */
  returnAddressDetail?: string;
  /** 반품 배송비 */
  returnFee?: number;
  /** 반품 이름 */
  returnName?: string;
  /** 반품 정책 */
  returnPolicy?: string;
  /** 반품 우편 번호 */
  returnZipCode?: string;
}

export interface DomainUpdateProSellerPartnerShopForLookoAIRequest {
  /** 매장 영업시간 */
  businessHours?: string;
  /** 매장 소개 컨텐츠 글 */
  contentDescription?: string;
  /** 매장소개 컨텐츠 이미지들 */
  contentImages?: string[];
  /** 매장 소개 활성화 여부 */
  enabled?: boolean;
  /** 대표 이미지 URL */
  mainImageUrl?: string;
  /** 지도 이미지 URL */
  mapImageUrl?: string;
  /** 파트너 샵 정보 ID */
  partnerShopInfoID?: number;
  /** 한줄소개 */
  shortIntroduction?: string;
  /** 간략 위치 */
  storeLocations?: DomainPartnerShopInfoStoreLocations;
  userID?: number;
}

export type DomainUpdateReturnOrderItemAsSurveyCompletedRequest = object;

export interface DomainUpdateStoreCouponForLookoAIRequest {
  /** 쿠폰 이름 */
  couponName: string;
  /** 할인 금액 */
  discountAmount: number;
  /** 파트너 샵 ID */
  partnerShopInfoID: number;
  /** 매장 쿠폰 ID */
  storeCouponID: number;
  /** 최소 결제 금액 */
  txAmountMin: number;
}

export interface DomainUpdateUserBankAccountRequest {
  /** 예금주명 */
  accountHolder: string;
  /** 계좌번호 */
  accountNumber: string;
  /** 은행 코드 */
  bankCode: string;
  /** 은행명 */
  bankName: string;
  /** 환불 계좌 여부 */
  isRefundAccount: boolean;
  /** 정산 계좌 여부 */
  isSettlementAccount: boolean;
}

export interface DomainUpdateWishlistRequest {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 필터에 대한 설명
   * @example "1000~50000, ZARA, 남자, 옷파는야옹이, 파란색"
   */
  description?: string;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example ["MARKET-ITEM_GENDERWEAR_MEN","MARKET-ITEM_GENDERWEAR_WOMEN"]
   */
  genderWears?: DomainGenderWearType[];
  /** @example true */
  isNotification?: boolean;
  /**
   * 새로 생성된 아이템을 확인했는지 여부 (true: 확인함, false: 확인하지 않음)
   * @example true
   */
  isSeen?: boolean;
  /**
   * 빈 문자열은 안됨. 글자수 제한 없음
   * @example "스포츠 관심상품"
   */
  name?: string;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /**
   * 1,000원 단위. 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example 40000
   */
  priceMax?: number;
  /**
   * 1,000원 단위. 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example 1000
   */
  priceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  sellerIDs?: number[];
  /** @example 1 */
  shoeSizeMax?: number;
  /** @example 1 */
  shoeSizeMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 문자열이 아닌 null 로 받음
   * @example "나이키 집업"
   */
  textSearch?: string;
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
}

export interface DomainUpsertMarketItemCoordinateRequest {
  /**
   * 코디 ID
   * @example 1
   */
  id?: number;
  /**
   * 코디 이미지
   * @example "https://test-image.com"
   */
  imageURL: string;
  /**
   * 코디에 사용된 마켓 아이템 IDs
   * @example [1,2,3,4,5]
   */
  marketItemIDs: number[];
  /**
   * 섹션 Key
   * @example 1234567890234246
   */
  sectionKey?: number;
  /** @example "빈티지 코디" */
  title: string;
}

export interface DomainUpsertMarketItemCoordinatesRequest {
  coordinates: DomainUpsertMarketItemCoordinateRequest[];
}

export interface DomainUpsertMarketItemCoordinatesResponse {
  coordinates: DomainMarketItemCoordinateResponse[];
}

export interface DomainUpsertOfficialBrandRequest {
  brandID?: number;
  childBrands?: string[];
  logoImage: string;
  mainImage: string;
  nameEn: string;
  nameKr: string;
}

export interface DomainUpsertOfficialBrandTagsRequest {
  brandCategoryImage?: string;
  brandSectionTitle?: string;
  brandTagID?: number;
  isBrandCategoryVisible: boolean;
  isOnboardingVisible: boolean;
  name: string;
  officialBrandIDs: number[];
  onboardingImage?: string;
  resources?: DomainBrandTagResource[];
}

export interface DomainUserABTest {
  /** json tag name은 amplitude에 저장되는 값이라 convention과 맞지 않음 */
  AB_sort?: Record<string, DomainABTestModel>;
  initialPriceType?: DomainInitialPriceType;
}

export type DomainUserAgeGeneration = 'AGE_10GEN' | 'AGE_20GEN' | 'AGE_30GEN' | 'AGE_GTE_40GEN';

export interface DomainUserBankAccountDto {
  /** 예금주명 */
  accountHolder?: string;
  /** 계좌번호 */
  accountNumber?: string;
  /** 은행 코드 */
  bankCode?: string;
  /** 은행명 */
  bankName?: string;
  /** 은행 계좌 ID */
  id?: number;
  /** 환불 계좌 여부 */
  isRefundAccount?: boolean;
  /** 정산 계좌 여부 */
  isSettlementAccount?: boolean;
  userID?: number;
}

export type DomainUserChatRoomStatus = 'CHAT_ROOM-USER-STATUS_ACTIVE' | 'CHAT_ROOM-USER-STATUS_EXITED';

export interface DomainUserCouponItem {
  couponID: number;
  couponInfo: DomainCouponItem;
  /** 쿠폰 발급 주체 */
  couponIssuer: DomainCouponIssuer;
  createDate: string;
  /** 만기일 (0이면 만기일이 없음) */
  expirationDate: string;
  /** 쿠폰 사용 불가 여부 */
  isCouponGreyedOut?: boolean;
  isExpired: boolean;
  isUsed: boolean;
  /** 사용 결제 아이디 (0) */
  txID: number;
  /** 사용일 (0이면 사용하지 않음) */
  usageDate: string;
  userCouponID: number;
  userID: number;
}

export interface DomainUserItem {
  bio?: string;
  birth?: string;
  clientConfig?: string;
  cloudUri?: string;
  commentNotifAgreed?: boolean;
  createClothesNotifAgreed?: boolean;
  createDate?: string;
  currency?: string;
  delFlag?: boolean;
  dialingCode?: string;
  division?: string;
  email?: string;
  followNotifAgreed?: boolean;
  gender?: string;
  height?: number;
  id?: number;
  isBanned?: boolean;
  isGuest?: boolean;
  isPrivate?: boolean;
  isVerified?: boolean;
  language?: string;
  likeNotifAgreed?: boolean;
  link?: string;
  marketItemBookmarkNotifAgreed?: boolean;
  marketItemChattingPushNotifAgreed?: boolean;
  marketItemReviewNotifAgreed?: boolean;
  mobile?: string;
  name?: string;
  nation?: string;
  nickname?: string;
  portoneCI?: string;
  /** 마켓 판매중단 당했는지 여부 (상품 업로드만 차단) */
  productUploadBlocked?: boolean;
  role?: string;
  tempSenseLevel?: number;
  transactionPushNotifAgreed?: boolean;
  updateNotifAgreed?: boolean;
  updateNotifDate?: string;
  username?: string;
  weight?: number;
}

export interface DomainUserMarketItemResponse {
  /**
   * 해당 중고 물품에 북마크 한 수
   * @example 1
   */
  bookmarkCount: number;
  bottomTotalLength?: number;
  bottomWaist?: number;
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /** @example 1 */
  brandTagID: number;
  /**
   * 중고 아이템 구매자 유저 ID
   * @example 22612346
   */
  buyerID?: number;
  /** @example 2626123 */
  clothesID?: number;
  /**
   * 중고 아이템 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 중고 아이템 생성일
   * @example 1668080178342
   */
  createDate: number;
  /**
   * TODO: 아래필드는 삭제 예정 (4.4.0) <-- 진짜 삭제하는지 확인
   * @example "KRW"
   */
  currency: string;
  cursor?: string;
  /**
   * 중고 아이템 설명
   * @example "사실 2년 입었어유"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  /** @example "MARKET-ITEM_FABRIC_COTTON" */
  fabric: string;
  fabrics: string[];
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  /** @example false */
  isBookmarked: boolean;
  /**
   * 중고 아이템 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /**
   * 프로셀러 여부
   * @example true
   */
  isProSeller: boolean;
  /**
   * 판매자의 탈퇴 여부
   * @example false
   */
  isSellerDeleted: boolean;
  /** 비슷한 상품 여부 */
  isSimilar?: boolean;
  /**
   * 지점명 노출 여부
   * @example true
   */
  isVisible: boolean;
  /**
   * Looko AI 상품 코드
   * @example "1234567890"
   */
  itemCode: string;
  /**
   * 중고 아이템 검색 키워드
   * @example ["흰색","티셔츠","남성"]
   */
  keywords: string[];
  logixID: number;
  /**
   * 공급사명(지점명)
   * @example "공급사 없음"
   */
  logixName: string;
  logixPolicy: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 조회수
   * @example 1
   */
  marketItemView?: number;
  /**
   * 중고 아이템 수정일
   * @example 1668080178342
   */
  modifyDate: number;
  /**
   * 로그인한 유저가 해당 아이템에 리뷰를 한 경우, 해당 리뷰 ID (남기지 않았을 경우 false)
   * @example 1245125
   */
  myReviewID?: number;
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  /**
   * 중고 아이템의 상태 (깨끗함, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  score: number;
  shoeSize?: number;
  /**
   * 중고 옷 사이즈
   * @example "FREE"
   */
  size: string;
  sizeForDisplay?: DomainSizeForDisplay;
  /** 중고 아이템 판매 상태 */
  status: DomainMarketItemStatus;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
  /**
   * 중고 아이템 제목
   * @example "새것 같은 노스페이스 패딩 팔아유"
   */
  title: string;
  topChest?: number;
  topShoulder?: number;
  topSleeveLength?: number;
  topTotalLength?: number;
  /**
   * 중고 아이템 판매자 유저 ID
   * @example 22612346
   */
  userID: number;
  /** Deprecated: 6.7.0 이후 삭제 와우 할인가 */
  wowDiscountAmount?: number;
}

export type DomainUserPreferenceBottomSize =
  | 'USER_PREFERENCE_BOTTOM_SIZE_22_BELOW'
  | 'USER_PREFERENCE_BOTTOM_SIZE_23'
  | 'USER_PREFERENCE_BOTTOM_SIZE_24'
  | 'USER_PREFERENCE_BOTTOM_SIZE_25'
  | 'USER_PREFERENCE_BOTTOM_SIZE_26'
  | 'USER_PREFERENCE_BOTTOM_SIZE_27'
  | 'USER_PREFERENCE_BOTTOM_SIZE_28'
  | 'USER_PREFERENCE_BOTTOM_SIZE_29'
  | 'USER_PREFERENCE_BOTTOM_SIZE_30'
  | 'USER_PREFERENCE_BOTTOM_SIZE_31'
  | 'USER_PREFERENCE_BOTTOM_SIZE_32'
  | 'USER_PREFERENCE_BOTTOM_SIZE_33'
  | 'USER_PREFERENCE_BOTTOM_SIZE_34'
  | 'USER_PREFERENCE_BOTTOM_SIZE_35'
  | 'USER_PREFERENCE_BOTTOM_SIZE_36'
  | 'USER_PREFERENCE_BOTTOM_SIZE_37'
  | 'USER_PREFERENCE_BOTTOM_SIZE_38'
  | 'USER_PREFERENCE_BOTTOM_SIZE_39'
  | 'USER_PREFERENCE_BOTTOM_SIZE_40_ABOVE';

export interface DomainUserPreferenceFilter {
  userPreferenceGenderWears?: string[];
}

export type DomainUserPreferenceGenderWearType =
  | 'USER_PREFERENCE_GENDERWEAR_WOMEN'
  | 'USER_PREFERENCE_GENDERWEAR_MEN'
  | 'USER_PREFERENCE_GENDERWEAR_BOTH';

export type DomainUserPreferenceShoeSize =
  | 210
  | 215
  | 220
  | 225
  | 230
  | 235
  | 240
  | 245
  | 250
  | 255
  | 260
  | 265
  | 270
  | 275
  | 280
  | 285
  | 290
  | 295
  | 300;

export type DomainUserPreferenceTopSize =
  | 'USER_PREFERENCE_TOP_SIZE_80_BELOW'
  | 'USER_PREFERENCE_TOP_SIZE_85'
  | 'USER_PREFERENCE_TOP_SIZE_90'
  | 'USER_PREFERENCE_TOP_SIZE_95'
  | 'USER_PREFERENCE_TOP_SIZE_100'
  | 'USER_PREFERENCE_TOP_SIZE_105'
  | 'USER_PREFERENCE_TOP_SIZE_110_ABOVE'
  | 'USER_PREFERENCE_TOP_SIZE_33_BELOW'
  | 'USER_PREFERENCE_TOP_SIZE_44'
  | 'USER_PREFERENCE_TOP_SIZE_55'
  | 'USER_PREFERENCE_TOP_SIZE_66'
  | 'USER_PREFERENCE_TOP_SIZE_77'
  | 'USER_PREFERENCE_TOP_SIZE_88'
  | 'USER_PREFERENCE_TOP_SIZE_99_ABOVE';

export interface DomainUserSignUpDate {
  /**
   * RecentSignupDay 최근 가입일 기준으로 몇 일 이내인지?
   * @example 7
   */
  recentSignupDay?: number;
  /**
   * SignupGteDate 가입일 이후
   * @example "2021-01-01T00:00:00Z"
   */
  signupGteDate?: string;
  /**
   * SignupLteDate 가입일 이전
   * @example "2021-01-01T00:00:00Z"
   */
  signupLteDate?: string;
}

export interface DomainUserStoreCouponResponse {
  /** 쿠폰 이름 */
  couponName: string;
  /** 생성일 */
  createdAt: string;
  /** 할인 금액 */
  discountAmount: number;
  /** 쿠폰 사용 불가 여부 */
  isCouponGreyedOut?: boolean;
  isUsed: boolean;
  /** 파트너 샵 ID */
  partnerShopInfoID: number;
  /** 판매자 userID */
  sellerID: number;
  /** 매장 쿠폰 ID */
  storeCouponID: number;
  /** 최소 결제 금액 */
  txAmountMin: number;
  usageDate: string;
  userID: number;
  /** 내가 다운받은 매장 쿠폰 ID */
  userStoreCouponID: number;
}

export interface DomainUserSurveyResponse {
  /** 설문 로그 리스트 */
  surveyHistories: DomainSurveyHistoryResponse[];
}

export interface DomainUserVisibleCondition {
  /**
   * 앱에 노출 여부
   * @example false
   */
  isVisible: boolean;
  proSellerPurchaseHistoryType: DomainProSellerPurchaseHistoryType;
  userAgeGenerations?: DomainUserAgeGeneration[];
  userPreferenceFilter: DomainUserPreferenceFilter;
  userSignUpDate: DomainUserSignUpDate;
  /**
   * 노출 종료일
   * @example "2021-01-01T00:00:00Z"
   */
  visibleEndDate?: string;
  /**
   * 노출 시작일
   * @example "2021-01-01T00:00:00Z"
   */
  visibleStartDate: string;
}

export interface DomainUserVisibleConditionRequest {
  /** @example false */
  isVisible: boolean;
  proSellerPurchaseHistoryType: DomainProSellerPurchaseHistoryType;
  userAgeGenerations?: DomainUserAgeGeneration[];
  userPreferenceFilter: DomainUserPreferenceFilter;
  userSignUpDate: DomainUserSignUpDate;
  /**
   * 노출 종료일
   * @example "2021-01-01T00:00:00Z"
   */
  visibleEndDate?: string;
  /** 노출 시작일 */
  visibleStartDate?: string;
}

export interface DomainVerifyEmailVerificationCodeRequest {
  /** @example "123@naver.com" */
  email: string;
  /**
   * 인증코드
   * @example "123456"
   */
  verificationCode: string;
}

export interface DomainVerifyMobileVerificationCodeRequest {
  /**
   * 인증코드
   * @example "123456"
   */
  verificationCode: string;
}

export interface DomainVertex {
  /** X 좌표 */
  x: number;
  /** Y 좌표 */
  y: number;
}

export interface DomainWishlistDTO {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 필터에 대한 설명
   * @example "1000~50000, ZARA, 남자, 옷파는야옹이, 파란색"
   */
  description?: string;
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 null 로 반환함.
   * @example 40000
   */
  discountPriceMax?: number;
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 null 로 반환함.
   * @example 1000
   */
  discountPriceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example ["MARKET-ITEM_GENDERWEAR_MEN","MARKET-ITEM_GENDERWEAR_WOMEN"]
   */
  genderWears?: DomainGenderWearType[];
  /**
   * 알람 여부
   * @example true
   */
  isNotification: boolean;
  /**
   * 새로 생성된 아이템을 확인했는지 여부 (true: 확인함, false: 확인하지 않음)
   * @example true
   */
  isSeen: boolean;
  /**
   * 빈 문자열은 안됨. 글자수 제한 없음
   * @example "스포츠 관심상품"
   */
  name: string;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /**
   * Deprecated: 1,000원 단위 필터를 사용하지 않는 경우 null 로 반환함.
   * @example 40000
   */
  priceMax?: number;
  /**
   * Deprecated: 1,000원 단위 필터를 사용하지 않는 경우 null 로 반환함.
   * @example 1000
   */
  priceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  sellerIDs?: number[];
  /** @example 1 */
  shoeSizeMax?: number;
  /** @example 1 */
  shoeSizeMin?: number;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example "나이키 집업"
   */
  textSearch?: string;
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
  /** @example 1 */
  userID: number;
  /** @example 1 */
  wishlistID: number;
}

export interface ErrorutilErrorResponse {
  code?: string;
  message?: string;
}

export type VersionSemver = '6.0.0';

export interface AdminsListParams {
  /** @example 30 */
  limit: number;
  /** @example 0 */
  offset: number;
  /** @example 1668080178342 */
  searchTimestamp: number;
}

export interface CommunityPostsListParams {
  /** 게시판 종류 목록 */
  boards?: ('VINTAGE_SHOP_RECOMMENDATION' | 'GOOD_DEAL' | 'FREE_TALK')[];
  /**
   * 게시글 작성일시 종료 범위
   * @example "2024-04-05T04:24:25.966Z"
   */
  createDateEnd?: string;
  /**
   * 게시글 작성일시 시작 범위
   * @example "2024-04-05T04:24:25.966Z"
   */
  createDateStart?: string;
  /**
   * 신고된 게시글만 조회할지 여부
   * @example true
   */
  isReported?: boolean;
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
}

export interface ContactsListParams {
  answerStatus?: string;
  endDate?: number;
  id?: number;
  limit?: number;
  offset?: number;
  searchTimestamp?: number;
  startDate?: number;
  type?: 'CONTACT_TYPE_NORMAL' | 'CONTACT_TYPE_SHOP-RECOMMENDATION';
  userID?: number;
}

export interface MarketItemReviewsListParams {
  createDateEnd?: number;
  createDateStart?: number;
  /** @example 30 */
  limit: number;
  /** @example 0 */
  offset: number;
  paymentType?: 'ONLINE' | 'STORE';
  /** @example "hkja" */
  searchNickname?: string;
  statuses?: (
    | 'MARKET-ITEM-REVIEW_INSPECTION_PENDING'
    | 'MARKET-ITEM-REVIEW_INSPECTION_APPROVED'
    | 'MARKET-ITEM-REVIEW_INSPECTION_REJECTED'
  )[];
}

export interface MarketItemReviewsCountListParams {
  createDateEnd?: number;
  createDateStart?: number;
  paymentType?: 'ONLINE' | 'STORE';
  /** @example "hkja" */
  searchNickname?: string;
  statuses?: (
    | 'MARKET-ITEM-REVIEW_INSPECTION_PENDING'
    | 'MARKET-ITEM-REVIEW_INSPECTION_APPROVED'
    | 'MARKET-ITEM-REVIEW_INSPECTION_REJECTED'
  )[];
}

export interface MarketItemsListParams {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  brandTagIDs?: number[];
  /** @example 1 */
  buyerID?: number;
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 생성일 끝
   * @example 1668080178342
   */
  createDateEnd?: number;
  /**
   * 생성일 시작
   * @example 1668080178342
   */
  createDateStart?: number;
  /**
   * 할인 가격 수정일 끝
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateEnd?: string;
  /**
   * 할인 가격 수정일 시작
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateStart?: string;
  /**
   * 최대 할인율
   * @example 50
   */
  discountRateMax?: number;
  /**
   * 최소 할인율 (최소 할인율 0 이상)
   * @example 10
   */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?:
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX';
  /**
   * 포함할 성별
   * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
   */
  genderWears?: (
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
  )[];
  id?: number;
  /**
   * 무료배송 여부
   * @example true
   */
  isFreeShipping?: boolean;
  /** 상품관리에서 true로 요청 */
  isManage?: boolean;
  /** @example 30 */
  limit: number;
  marketItemIDs?: number[];
  /** 포함할 소재 ID */
  materialIDs?: number[];
  /** 포함할 공식 브랜드 */
  officialBrandIDs?: number[];
  /** @example 0 */
  offset: number;
  omitNoBrand?: boolean;
  /** 디폴트 최신순 */
  orderField?:
    | 'marketItemID'
    | 'discountPrice'
    | 'discountRate'
    | 'createDate'
    | 'modifyDate'
    | '_score'
    | 'aclosetScore'
    | 'popularity'
    | 'sellingDiscountRate'
    | 'discountPriceModifyDate'
    | 'similarUserPreferredItems'
    | 'recommendAfterSurvey'
    | 'bookmark';
  /** 포함할 패턴 ID */
  patternIDs?: number[];
  /**
   * 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /** @example 1668080178342 */
  searchTimestamp: number;
  /** 상품관리에서 상품 명 검색 */
  searchTitle?: string;
  /** 상품관리에서 상품 검색 타입 - 전체,신고됨 */
  searchType?: 'MARKET_ITEM_FILTER_ALL' | 'MARKET_ITEM_FILTER_REPORTED';
  /** @example 1 */
  sellerID?: number;
  /** @example [1,2,3] */
  sellerIDs?: number[];
  /** 판매자 타입 - 전체,일반,프로셀러 */
  sellerType?: 'MARKET_ITEM_SELLER-TYPE_ALL' | 'MARKET_ITEM_SELLER-TYPE_NORMAL' | 'MARKET_ITEM_SELLER-TYPE_PRO-SELLER';
  /** 내부 필드 */
  sellingDiscountRateMax?: number;
  /** 최소 할인율 (최소 할인율 0 이상) */
  sellingDiscountRateMin?: number;
  /**
   * 포함할 사이즈
   * @example [1,2,3]
   */
  sizeIDs?: number[];
  sortOrder?: 'asc' | 'desc';
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: (
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE'
  )[];
  /** @example "흰색 티셔츠" */
  textSearch?: string;
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
  /** 현장 결제로 생성된 가주문용 마켓아이템을 함께 조회할지 여부 */
  withStoreMarketItem?: boolean;
}

export interface MarketItemsBrandsListParams {
  /** default: 100 */
  limit?: number;
  /** default: 0 */
  offset?: number;
  omitCategorizedBrand?: boolean;
  orConditionsMarketItemCountMin?: number;
  orConditionsPriceMin?: number;
}

export interface MarketItemsBrandsCountListParams {
  omitCategorizedBrand?: boolean;
  orConditionsMarketItemCountMin?: number;
  orConditionsPriceMin?: number;
}

export interface MarketItemsCoordinatesListParams {
  /**
   * 코디 IDs
   * @example [1,2,3,4,5]
   */
  coordinateIDs?: number[];
  /** @example 30 */
  limit: number;
  /** @example 1 */
  nextCursor?: number;
  /** @example 0 */
  offset: number;
  /**
   * 섹션 Keys
   * @example [12312144554654]
   */
  sectionKeys?: number[];
}

export interface MarketItemsPromotionInfosListParams {
  /** 조회할 개수 */
  limit?: number;
}

export interface MarketItemsRecommendationInfosHistoryListParams {
  /** 페이지 번호 */
  nextCursor?: number;
  /** 페이지당 갯수 */
  limit?: number;
}

export interface MarketItemsSearchAbTestsListParams {
  testNames?: (
    | 'marketItemID'
    | 'discountPrice'
    | 'discountRate'
    | 'createDate'
    | 'modifyDate'
    | '_score'
    | 'aclosetScore'
    | 'popularity'
    | 'sellingDiscountRate'
    | 'discountPriceModifyDate'
    | 'similarUserPreferredItems'
    | 'recommendAfterSurvey'
    | 'bookmark'
  )[];
  withDeleted?: boolean;
}

export interface MarketItemsEditableListParams {
  /** @example "MODIFY,DELETE,CLOSE" */
  type?: string;
  userID?: number;
  /**
   * 중고 ID
   * @example 26124
   */
  id: number;
}

export interface OfficialBrandsListParams {
  /** QuickButtonOrder 기준으로 채워서 limit 만큼 반환 */
  fillToLimitWithQuickButtonOrder?: boolean;
  /** 팔로우한 브랜드만 가져올 지 여부 */
  followedOnly?: boolean;
  /** 해당 브랜드에 판매중인 아이템 수가 N개 이상인 것만 가져옵니다. */
  greaterThanOrEqualMarketItemCount?: number;
  /** 응답에 브랜드별 팔로우 여부를 가져올 지 여부입니다. 하위호환을 위해서 미전달시 true로 동작합니다. */
  includeIsFollowing?: boolean;
  /** 응답에 브랜드별 판매중인 아이템 수를 가져올 지 여부입니다. (totalMarketItemCount, remainingMarketItemCount) 하위호환을 위해서 미전달시 true로 동작합니다. */
  includeMarketItemCount?: boolean;
  /** 검색 초기 화면 - 인기 브랜드 목록을 가져올 지 여부 */
  isSearchVisible?: boolean;
  /** @default 20 */
  limit?: number;
  /** @default 0 */
  offset?: number;
  /** 맞춤 설정(내 취향 분석)을 위한 특수 정렬 */
  orderByCustomPreferences?: boolean;
  /** 판매중인 아이템 수를 기준으로 정렬 (기본 동작:내림차순) */
  orderByMarketItemCount?: boolean;
  searchText?: string;
  tagID?: number;
  withMarketItems?: boolean;
  /** 실제로는 limit 과 유사한 개념의 필드 */
  withMarketItemsCount?: number;
}

export interface OfficialBrandsDeleteParams {
  officialBrandID: number;
}

export interface OfficialBrandsCountListParams {
  searchText?: string;
  searchType?: 'LIKE' | 'EQUAL';
}

export interface OfficialBrandsTagsListParams {
  isBrandCategoryVisible?: boolean;
  isOnboardingVisible?: boolean;
}

export interface OfficialBrandsTagsDeleteParams {
  brandTagID: number;
}

export interface OrdersListParams {
  /** @example 30 */
  limit: number;
  marketItemID?: number;
  /** @example 0 */
  offset: number;
  orderIDs?: string[];
  orderItemIDs?: number[];
  /** @example 1668080178342 */
  searchTimestamp: number;
  searchType?: string;
  txStatus?:
    | 'TX_STATUS_CANCELED'
    | 'TX_STATUS_PAYMENT-PENDING'
    | 'TX_STATUS_PAYMENT-COMPLETED'
    | 'TX_STATUS_SHIPPING-PREPARING'
    | 'TX_STATUS_SHIPPING-IN-TRANSIT'
    | 'TX_STATUS_SHIPPING-COMPLETED'
    | 'TX_STATUS_TRANSACTION-COMPLETED-SAFE'
    | 'TX_STATUS_REFUND-REVIEW'
    | 'TX_STATUS_REFUND-WAIT'
    | 'TX_STATUS_REFUND-DENIED'
    | 'TX_STATUS_REFUND-COMPLETED';
  txStatuses?: (
    | 'TX_STATUS_CANCELED'
    | 'TX_STATUS_PAYMENT-PENDING'
    | 'TX_STATUS_PAYMENT-COMPLETED'
    | 'TX_STATUS_SHIPPING-PREPARING'
    | 'TX_STATUS_SHIPPING-IN-TRANSIT'
    | 'TX_STATUS_SHIPPING-COMPLETED'
    | 'TX_STATUS_TRANSACTION-COMPLETED-SAFE'
    | 'TX_STATUS_REFUND-REVIEW'
    | 'TX_STATUS_REFUND-WAIT'
    | 'TX_STATUS_REFUND-DENIED'
    | 'TX_STATUS_REFUND-COMPLETED'
  )[];
}

export interface ReportsListParams {
  limit?: number;
  offset?: number;
  reportType?:
    | 'REPORT_TYPE_USER'
    | 'REPORT_TYPE_COMMENT'
    | 'REPORT_TYPE_CLOTHES'
    | 'REPORT_TYPE_OUTFIT'
    | 'REPORT_TYPE_MARKET-ITEM';
  reportedID?: number;
  searchTimestamp?: number;
}

export interface SettlementsListParams {
  createDateEnd?: number;
  createDateStart?: number;
  /** @example true */
  isProSeller?: boolean;
  /** @example 30 */
  limit: number;
  /** @example 0 */
  offset: number;
  paymentType?: 'ONLINE' | 'STORE';
  /** @example 1668080178342 */
  searchTimestamp: number;
  statuses?: string[];
}

export interface StatisticsUserSurveyHistoryListParams {
  /**
   * 조회할 페이지 번호
   * @min 1
   * @example 1
   */
  pageNumber: number;
  /**
   * 페이지 당 크기
   * @min 1
   * @example 10
   */
  pageSize: number;
  /** 설문 조사가 속한 그룹 */
  surveyGroupType: string;
}

export interface TransactionsListParams {
  /** @example 30 */
  limit: number;
  marketItemID?: number;
  /** @example 0 */
  offset: number;
  /** @example 1668080178342 */
  searchTimestamp: number;
  txIDs?: number[];
  txStatus?:
    | 'TX_STATUS_CANCELED'
    | 'TX_STATUS_PAYMENT-PENDING'
    | 'TX_STATUS_PAYMENT-COMPLETED'
    | 'TX_STATUS_SHIPPING-PREPARING'
    | 'TX_STATUS_SHIPPING-IN-TRANSIT'
    | 'TX_STATUS_SHIPPING-COMPLETED'
    | 'TX_STATUS_TRANSACTION-COMPLETED-SAFE'
    | 'TX_STATUS_REFUND-REVIEW'
    | 'TX_STATUS_REFUND-WAIT'
    | 'TX_STATUS_REFUND-DENIED'
    | 'TX_STATUS_REFUND-COMPLETED';
  /** @example ["[TX_STATUS_PAYMENT-COMPLETED","TX_STATUS_PAYMENT-CANCELED","TX_STATUS_SHIPPING-PREPARING","TX_STATUS_SHIPPING-IN-TRANSIT","TX_STATUS_TRANSACTION-COMPLETED-SAFE","TX_STATUS_CANCELED","TX_STATUS_REFUND-REVIEW","TX_STATUS_REFUND-COMPLETED","TX_STATUS_CANCELED","TX_STATUS_REFUND-REVIEW","TX_STATUS_REFUND-COMPLETED","TX_STATUS_CANCELED]"] */
  txStatuses?: (
    | 'TX_STATUS_CANCELED'
    | 'TX_STATUS_PAYMENT-PENDING'
    | 'TX_STATUS_PAYMENT-COMPLETED'
    | 'TX_STATUS_SHIPPING-PREPARING'
    | 'TX_STATUS_SHIPPING-IN-TRANSIT'
    | 'TX_STATUS_SHIPPING-COMPLETED'
    | 'TX_STATUS_TRANSACTION-COMPLETED-SAFE'
    | 'TX_STATUS_REFUND-REVIEW'
    | 'TX_STATUS_REFUND-WAIT'
    | 'TX_STATUS_REFUND-DENIED'
    | 'TX_STATUS_REFUND-COMPLETED'
  )[];
}

export interface UsersListParams {
  email?: string;
  /** @example 30 */
  limit: number;
  mobile?: string;
  nickname?: string;
  /** @example 0 */
  offset: number;
  role?: string;
  /** @example 1668080178342 */
  searchTimestamp: number;
  userID?: number;
  userIDs?: number[];
  withDeletedUsers?: boolean;
}

export interface UsersProSellerListParams {
  /**
   * 할인 가격 수정 날짜 끝 (Lte)
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateEnd?: string;
  /**
   * 할인 가격 수정 날짜 시작 (Gte)
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateStart?: string;
  /**
   * default: 20
   * @example 10
   */
  limit?: number;
  /**
   * default: 0
   * @example 0
   */
  marketItemDiscountRateMin?: number;
  /**
   * default: 20 샵의 대표 아이템 갯수
   * @example 3
   */
  marketItemLimit?: number;
  /** default: aclosetScore */
  marketItemOrderField?:
    | 'marketItemID'
    | 'discountPrice'
    | 'discountRate'
    | 'createDate'
    | 'modifyDate'
    | '_score'
    | 'aclosetScore'
    | 'popularity'
    | 'sellingDiscountRate'
    | 'discountPriceModifyDate'
    | 'similarUserPreferredItems'
    | 'recommendAfterSurvey'
    | 'bookmark';
  /** default: desc */
  marketItemSortOrder?: 'asc' | 'desc';
  /** @example 0 */
  offset?: number;
  /** @example true */
  orderByDiscountPriceModifyDate?: boolean;
  /** 데이터를 Follower에 따라 정렬할 지에 대한 조건 */
  orderByFollowers?: boolean;
  /** @example 1668080178342 */
  searchTimestamp?: number;
  withInVisibleProSeller?: boolean;
}

export interface UsersSearchProSellerListParams {
  nickname?: string;
}

export interface V2UsersProSellerListParams {
  /**
   * 할인 가격 수정 날짜 끝 (Lte)
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateEnd?: string;
  /**
   * 할인 가격 수정 날짜 시작 (Gte)
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateStart?: string;
  /**
   * default: 20
   * @example 10
   */
  limit?: number;
  /**
   * default: 0
   * @example 0
   */
  marketItemDiscountRateMin?: number;
  /**
   * default: 20 샵의 대표 아이템 갯수
   * @example 3
   */
  marketItemLimit?: number;
  /** default: aclosetScore */
  marketItemOrderField?:
    | 'marketItemID'
    | 'discountPrice'
    | 'discountRate'
    | 'createDate'
    | 'modifyDate'
    | '_score'
    | 'aclosetScore'
    | 'popularity'
    | 'sellingDiscountRate'
    | 'discountPriceModifyDate'
    | 'similarUserPreferredItems'
    | 'recommendAfterSurvey'
    | 'bookmark';
  /** default: desc */
  marketItemSortOrder?: 'asc' | 'desc';
  /** @example 0 */
  offset?: number;
  /** @example true */
  orderByDiscountPriceModifyDate?: boolean;
  /** 데이터를 Follower에 따라 정렬할 지에 대한 조건 */
  orderByFollowers?: boolean;
  /** @example 1668080178342 */
  searchTimestamp?: number;
  withInVisibleProSeller?: boolean;
}

export interface BrandsListParams {
  brandDivision?: 'GLOBAL' | 'CUSTOM' | 'TOTAL';
  /** @example "THENORTHFACE" */
  brandName: string;
}

export interface GetBrandsParams {
  brandDivision?: 'GLOBAL' | 'CUSTOM' | 'TOTAL';
  /** @example "THENORTHFACE" */
  brandName: string;
  /**
   * default: 20
   * @example 10
   */
  limit?: number;
  /** @example 0 */
  offset?: number;
  searchType: 'LIKE' | 'EQUAL';
}

export interface CartsListParams {
  /**
   * default: 30
   * @example 10
   */
  limit?: number;
}

export interface RoomsListParams {
  /**
   * 채팅방 키
   * @example "ITEM-12345"
   */
  chatRoomKey?: string;
  /**
   * 채팅방 타입
   * @example "CHAT_ROOM_TYPE_ITEM"
   */
  chatRoomType?: 'CHAT_ROOM-TYPE_NORMAL-SELLER-MARKET-ITEM' | 'CHAT_ROOM-TYPE_PROSELLER';
  /** @example "00000000010000000015" */
  cursor?: string;
  /** @example 30 */
  limit: number;
  /**
   * 채팅방에 채팅이 있는 경우만 조회
   * @example true
   */
  notEmptyOnly?: boolean;
  /**
   * 조회할 채팅방 ID 목록
   * @example [1,2,3]
   */
  roomID?: number[];
}

export interface RoomsChatsListParams {
  /** @example "00000000010000000015" */
  cursor?: string;
  /** @example 30 */
  limit: number;
  /**
   * 읽음표시도 동시에 진행하기
   * @example true
   */
  withSeenMark?: boolean;
  /**
   * 채팅방 ID
   * @example 1
   */
  roomId: number;
}

export interface DetectionListParams {
  /** 분석할 이미지 URL */
  imageURL: string;
}

export interface PostsListParams {
  /**
   * 게시판 종류
   * @example "VINTAGE_SHOP_RECOMMENDATION"
   */
  board?: 'VINTAGE_SHOP_RECOMMENDATION' | 'GOOD_DEAL' | 'FREE_TALK';
  /**
   * 댓글 단 사용자 ID
   * @example 7
   */
  commentedByUserID?: number;
  /**
   * 게시글 작성일시 종료 범위
   * @example "2024-04-05T04:24:25.966Z"
   */
  createDateEnd?: string;
  /**
   * 게시글 작성일시 시작 범위
   * @example "2024-04-05T04:24:25.966Z"
   */
  createDateStart?: string;
  /**
   * 페이징 커서
   * @example "111"
   */
  cursor?: string;
  /**
   * 제외할 사용자 ID 목록
   * @example [7,8,9]
   */
  excludedUserIDs?: number[];
  /**
   * 이미지가 있는 게시글만 조회할지 여부
   * @example true
   */
  existsImage?: boolean;
  /**
   * 좋아요한 사용자 ID
   * @example 7
   */
  likedByUserID?: number;
  /**
   * 페이지 크기
   * @example 10
   */
  limit: number;
  /**
   * 게시글 사용자 ID
   * @example 7
   */
  userID?: number;
}

export interface PostsCommentsListParams {
  /**
   * 페이징 커서
   * @example "111"
   */
  cursor?: string;
  /**
   * 페이지 크기
   * @example 10
   */
  limit: number;
  /**
   * 게시글 ID
   * @example "1"
   */
  postId: string;
}

export interface AvailableCouponsListParams {
  includeStorePayment?: boolean;
  marketItemID?: number;
  sellerID?: number;
}

export interface DownloadableCouponListParams {
  couponIssuer?: 'COUPON_ISSUER_ACLOSET' | 'COUPON_ISSUER_PRO_SELLER';
}

export interface CouponsListParams {
  /**
   * 조회할 페이지 번호
   * @min 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * 페이지 당 크기
   * @min 0
   * @example 10
   */
  pageSize?: number;
}

export interface MarketItemsMissingLinkListParams {
  lookoAIID?: string;
}

export interface MarketItemsReviewsListParams {
  /** @example 30 */
  limit: number;
  /** @example 0 */
  offset: number;
}

export interface MarketItemsDetailParams1 {
  /**
   * 가격변동 이력 조회 종료일
   * @example "2024-04-05T04:24:25.966Z"
   */
  marketItemPriceHistoryEndDate?: string;
  /**
   * 가격변동 이력 조회 시작일
   * @example "2024-04-05T04:24:25.966Z"
   */
  marketItemPriceHistoryStartDate?: string;
  /** 마켓아이템 조회수 업데이트 여부 */
  skipUpdateView?: boolean;
  /**
   * 중고 ID
   * @example 525
   */
  marketItemId: number;
}

export interface MyProfileListParams {
  /** 프로셀러 정보 조회 여부 */
  withProSellerInfo?: boolean;
}

export interface OrdersListParams2 {
  from?: string;
  orderIDs?: number[];
  to?: string;
}

export interface StoreCouponsListParams {
  /** 판매자 userID */
  sellerID: number;
}

export interface UsersPartnerShopsListParams {
  limit?: number;
  offset?: number;
  /** 지역 */
  region?: string;
  userID?: number;
}

export interface UsersMarketItemsListParams {
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 최대 할인율
   * @example 50
   */
  discountRateMax?: number;
  /**
   * 최소 할인율 (최소 할인율 0 이상)
   * @example 10
   */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?: string;
  /**
   * 무료배송 여부
   * @example true
   */
  isFreeShipping?: boolean;
  /**
   * 페이징 Limit
   * @example 10
   */
  limit: number;
  /**
   * 포함할 중고 아이템 ID
   * @example [1,2,3]
   */
  marketItemIDs?: number[];
  /**
   * 페이징 Offset
   * @example 20
   */
  offset: number;
  /**
   * 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /**
   * 리스트 조회 기준 생성일시
   * @example 1668080178342
   */
  searchTimestamp: number;
  /**
   * 포함할 사이즈
   * @example [1,2,3]
   */
  sizeIDs?: number[];
  /**
   * 조회할 중고 아이템의 상태 (판매중, 판매완료)
   * @example "MARKET-ITEM_STATUS_FOR-SALE"
   */
  status?:
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE';
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: string[];
  /** @example "흰색 티셔츠" */
  textSearch?: string;
  /**
   * 조회할 거래내역 종류: 구매/판매 여부
   * @example "SALES"
   */
  type: 'PURCHASE' | 'SALES';
  /** 유저의 거래 내역 불러오기 */
  userId: number;
}

export interface ChatroomsListParams {
  /**
   * 채팅방 ID (Sendbird 한정 : channel_url)
   * @example ["sendbird_group_channel_25108471_a1bc35f5f0d237207bc1rd343562c878fc2fd426"]
   */
  chatroomID?: string[];
  /**
   * 중고 아이템 ID
   * @example 123883
   */
  marketItemID?: number;
}

export interface CompareSizesListParams {
  /**
   * 카테고리 소분류
   * @example 6252
   */
  categoryID: number;
}

export interface CoordinatesListParams {
  /**
   * 코디 IDs
   * @example [1,2,3,4,5]
   */
  coordinateIDs?: number[];
  /** @example 30 */
  limit: number;
  /** @example 1 */
  nextCursor?: number;
  /** @example 0 */
  offset: number;
  /**
   * 섹션 Keys
   * @example [12312144554654]
   */
  sectionKeys?: number[];
}

export interface DetailListParams {
  /**
   * 중고 아이템 ID
   * @example [1,2,3]
   */
  marketItemIDs: number[];
}

export interface FilterListParams {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  brandTagIDs?: number[];
  /** @example 1 */
  buyerID?: number;
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 생성일 끝 - 예전에 개발한거라 unixmilli로 받음
   * @example 1668080178342
   */
  createDateEnd?: number;
  /**
   * 생성일 시작 - 예전에 개발한거라 unixmilli로 받음
   * @example 1668080178342
   */
  createDateStart?: number;
  /** 브랜드는 종류가 너무 많아서 특정 Group by 하면 로드가 부담되어 현재 페이지 브랜드만 Group by */
  currentPageOfficialBrandIDs?: number[];
  /**
   * 최대 가격
   * @example 100000
   */
  discountPriceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  discountPriceMin?: number;
  /**
   * 할인 가격 수정일 끝
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateEnd?: string;
  /**
   * 할인 가격 수정일 시작
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateStart?: string;
  /**
   * 최대 할인율
   * @example 50
   */
  discountRateMax?: number;
  /**
   * 최소 할인율 (최소 할인율 0 이상)
   * @example 10
   */
  discountRateMin?: number;
  /**
   * 포함할 소재
   * @example ["MARKET-ITEM_FABRIC_COTTON"]
   */
  fabrics?: (
    | 'MARKET-ITEM_FABRIC_COTTON'
    | 'MARKET-ITEM_FABRIC_COTTON100'
    | 'MARKET-ITEM_FABRIC_WOOL'
    | 'MARKET-ITEM_FABRIC_WOOL100'
    | 'MARKET-ITEM_FABRIC_NYLON'
    | 'MARKET-ITEM_FABRIC_RAYON'
    | 'MARKET-ITEM_FABRIC_ACRYLIC'
    | 'MARKET-ITEM_FABRIC_ACRYLIC100'
    | 'MARKET-ITEM_FABRIC_POLYESTER'
    | 'MARKET-ITEM_FABRIC_POLYESTER100'
    | 'MARKET-ITEM_FABRIC_ANGORA'
    | 'MARKET-ITEM_FABRIC_ANGORA100'
    | 'MARKET-ITEM_FABRIC_SILK'
    | 'MARKET-ITEM_FABRIC_SILK100'
    | 'MARKET-ITEM_FABRIC_CASHMERE'
    | 'MARKET-ITEM_FABRIC_CASHMERE100'
    | 'MARKET-ITEM_FABRIC_LINEN'
    | 'MARKET-ITEM_FABRIC_MOHAIR'
    | 'MARKET-ITEM_FABRIC_ALPACA'
    | 'MARKET-ITEM_FABRIC_ALPACA100'
    | 'MARKET-ITEM_FABRIC_POLYURETHANE'
    | 'MARKET-ITEM_FABRIC_TRIACETATE'
    | 'MARKET-ITEM_FABRIC_ACETATE'
    | 'MARKET-ITEM_FABRIC_DENIM'
    | 'MARKET-ITEM_FABRIC_CORDUROY'
    | 'MARKET-ITEM_FABRIC_LEATHER'
    | 'MARKET-ITEM_FABRIC_SUEDE'
    | 'MARKET-ITEM_FABRIC_VISCOSE'
    | 'MARKET-ITEM_FABRIC_LYOCELL'
    | 'MARKET-ITEM_FABRIC_CUPRO'
    | 'MARKET-ITEM_FABRIC_RABBITFUR'
    | 'MARKET-ITEM_FABRIC_DOWN'
    | 'MARKET-ITEM_FABRIC_DUCKDOWN'
    | 'MARKET-ITEM_FABRIC_GOOSEDOWN'
    | 'MARKET-ITEM_FABRIC_COWLEATHER'
    | 'MARKET-ITEM_FABRIC_LAMBLEATHER'
    | 'MARKET-ITEM_FABRIC_PIGLEATHER'
    | 'MARKET-ITEM_FABRIC_GENUINELEATHER'
    | 'MARKET-ITEM_FABRIC_SYNTHETICLEATHER'
    | 'MARKET-ITEM_FABRIC_METAL'
    | 'MARKET-ITEM_FABRIC_VELVET'
    | 'MARKET-ITEM_FABRIC_UNKNOWN'
  )[];
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?:
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX';
  /**
   * 포함할 성별
   * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
   */
  genderWears?: (
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
  )[];
  /**
   * 무료배송 여부
   * @example true
   */
  isFreeShipping?: boolean;
  /** 포함할 소재 ID */
  materialIDs?: number[];
  /** 포함할 공식 브랜드 - marketItem 에 저장하고 있지 않아 따로 조회하여 brandName 으로 필터링 */
  officialBrandIDs?: number[];
  /** 포함할 패턴 ID */
  patternIDs?: number[];
  /** 검색어 기반 개인화 추천 여부 */
  personalizedWithSearchKeyword?: boolean;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /** @example [1,2,3] */
  sellerIDs?: number[];
  /** @example 1 */
  shoeSizeMax?: number;
  /** @example 1 */
  shoeSizeMin?: number;
  /**
   * 포함할 사이즈
   * @example [1,2,3]
   */
  sizeIDs?: number[];
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: (
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE'
  )[];
  /** @example "흰색 티셔츠" */
  textSearch?: string;
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
}

export interface PromotionInfosListParams {
  creationType?: 'BANNER' | 'POPUP';
  /** 노출 여부 */
  isVisible?: boolean;
}

export interface RecentlyViewedListParams {
  /**
   * 최근 본 중고 아이템 목록의 개수
   * @example 10
   */
  limit?: number;
}

export interface RelatedKeywordsListParams {
  /** @example "나이키" */
  keyword: string;
}

export interface ReviewsRealtimeListParams {
  sellerID?: number;
}

export interface RewardPointPolicyListParams {
  /**
   * 중고 상품 ID
   * @example 1
   */
  marketItemID?: number;
  /**
   * 주문 상품 ID
   * @example 1
   */
  orderItemID?: number;
}

export interface SimilarImageItemsListParams {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /** 포함할 브랜드 태그 IDs */
  brandTagIDs?: number[];
  /**
   * 카테고리 ID
   * @example 1
   */
  categoryID?: number;
  /**
   * 필터 조건
   * @example 100000
   */
  discountPriceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  discountPriceMin?: number;
  /**
   * 유사 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  imageURL?: string;
  /**
   * 반환할 데이터의 수
   * @example 30
   */
  limit: number;
  nextCursor?: string;
  /**
   * 포함할 공식 브랜드 IDs
   * @example [82]
   */
  officialBrandIDs?: number[];
  /** @example 1 */
  shoeSizeMax?: number;
  /** @example 1 */
  shoeSizeMin?: number;
  /**
   * 충족해야할 최소 유사도
   * @example 1.3
   */
  similarity?: number;
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: (
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE'
  )[];
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
}

export interface MarketItemsDetailParams3 {
  /**
   * 가격변동 이력 조회 종료일
   * @example "2024-04-05T04:24:25.966Z"
   */
  marketItemPriceHistoryEndDate?: string;
  /**
   * 가격변동 이력 조회 시작일
   * @example "2024-04-05T04:24:25.966Z"
   */
  marketItemPriceHistoryStartDate?: string;
  /** 마켓아이템 조회수 업데이트 여부 */
  skipUpdateView?: boolean;
  /**
   * 중고 ID
   * @example 525
   */
  marketItemId: number;
}

export interface EditableListParams {
  marketItemID?: number;
  /** @example "EDIT,DELETE,CLOSE" */
  type?: string;
  marketItemId: string;
}

export interface SellersOtherItemsListParams {
  /** @example 30 */
  limit: number;
  /**
   * 중고 ID
   * @example 525
   */
  marketItemId: number;
}

export interface SimilarBrandItemsListParams {
  /** @example 30 */
  limit: number;
  /**
   * 중고 ID
   * @example 525
   */
  marketItemId: number;
}

export interface SimilarFabricItemsListParams {
  /** @example 30 */
  limit: number;
  /**
   * 중고 ID
   * @example 525
   */
  marketItemId: number;
}

export interface SimilarImageItemsList2Params {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /** 포함할 브랜드 태그 IDs */
  brandTagIDs?: number[];
  /**
   * 카테고리 ID
   * @example 1
   */
  categoryID?: number;
  /**
   * 필터 조건
   * @example 100000
   */
  discountPriceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  discountPriceMin?: number;
  /**
   * 유사 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  imageURL?: string;
  /**
   * 반환할 데이터의 수
   * @example 30
   */
  limit: number;
  nextCursor?: string;
  /**
   * 포함할 공식 브랜드 IDs
   * @example [82]
   */
  officialBrandIDs?: number[];
  /** @example 1 */
  shoeSizeMax?: number;
  /** @example 1 */
  shoeSizeMin?: number;
  /**
   * 충족해야할 최소 유사도
   * @example 1.3
   */
  similarity?: number;
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: (
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE'
  )[];
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
  /**
   * 중고 ID
   * @example 525
   */
  marketItemId: number;
}

export interface SimilarItemsListParams {
  /** @example 30 */
  limit: number;
  /**
   * 중고 ID
   * @example 525
   */
  marketItemId: number;
}

export interface TransactionsListParams2 {
  /** @example 1 */
  buyerID?: number;
  /** @example 1 */
  sellerID?: number;
  /**
   * 중고 ID
   * @example 525
   */
  marketItemId: number;
}

export interface MetadataListParams {
  /**
   * 도메인
   * @example "outfit"
   */
  domain?: string;
  /**
   * 서브 도메인
   * @example "content"
   */
  subDomain?: string;
}

export interface SearchCategoriesListParams {
  /** @example 20 */
  limit: number;
  offset?: number;
  searchKeyword: string;
}

export interface MyInfoListParams {
  /** 프로셀러 정보 조회 여부 */
  withProSellerInfo?: boolean;
}

export interface NotificationsListParams {
  language: 'ko' | 'en' | 'es' | 'fr' | 'ru';
  /** @example 30 */
  limit: number;
  /** @example 0 */
  offset: number;
}

export interface ActivityListParams {
  /** @example 30 */
  limit: number;
  nextCursor?: number;
  /**
   * Deprecated: 5.16.0
   * @example 0
   */
  offset?: number;
}

export interface FavoriteListParams {
  /** @example 30 */
  limit: number;
  nextCursor?: number;
  /**
   * Deprecated: 5.16.0
   * @example 0
   */
  offset?: number;
}

export interface OfficialBrandsListParams2 {
  /** QuickButtonOrder 기준으로 채워서 limit 만큼 반환 */
  fillToLimitWithQuickButtonOrder?: boolean;
  /** 팔로우한 브랜드만 가져올 지 여부 */
  followedOnly?: boolean;
  /** 해당 브랜드에 판매중인 아이템 수가 N개 이상인 것만 가져옵니다. */
  greaterThanOrEqualMarketItemCount?: number;
  /** 응답에 브랜드별 팔로우 여부를 가져올 지 여부입니다. 하위호환을 위해서 미전달시 true로 동작합니다. */
  includeIsFollowing?: boolean;
  /** 응답에 브랜드별 판매중인 아이템 수를 가져올 지 여부입니다. (totalMarketItemCount, remainingMarketItemCount) 하위호환을 위해서 미전달시 true로 동작합니다. */
  includeMarketItemCount?: boolean;
  /** 검색 초기 화면 - 인기 브랜드 목록을 가져올 지 여부 */
  isSearchVisible?: boolean;
  /** @default 20 */
  limit?: number;
  /** @default 0 */
  offset?: number;
  /** 맞춤 설정(내 취향 분석)을 위한 특수 정렬 */
  orderByCustomPreferences?: boolean;
  /** 판매중인 아이템 수를 기준으로 정렬 (기본 동작:내림차순) */
  orderByMarketItemCount?: boolean;
  searchText?: string;
  tagID?: number;
  withMarketItems?: boolean;
  /** 실제로는 limit 과 유사한 개념의 필드 */
  withMarketItemsCount?: number;
}

export interface TagsListParams {
  isBrandCategoryVisible?: boolean;
  isOnboardingVisible?: boolean;
}

export interface AuthenticityTipsListParams {
  /** Bottom category ID */
  categoryID?: number;
  brandId: string;
}

export interface FollowsListParams {
  /** @example 10 */
  limit?: number;
  /** @example 0 */
  offset?: number;
  /** 유저 아이디 */
  userId: string;
}

export interface OrdersListParams4 {
  /**
   * 앱 버전. 6.0.0 이상일 경우에만 배송완료 상태가 보입니다.
   * @example "5.10.0"
   */
  appVersion?: '6.0.0';
  /** @example 30 */
  limit: number;
  needRepayment?: boolean;
  /** @example 0 */
  offset: number;
  /** Deprecated */
  paymentType?: 'ONLINE' | 'STORE';
  /** @example 1668080178342 */
  searchTimestamp: number;
  txIDs?: number[];
  txStatus?:
    | 'TX_STATUS_CANCELED'
    | 'TX_STATUS_PAYMENT-PENDING'
    | 'TX_STATUS_PAYMENT-COMPLETED'
    | 'TX_STATUS_SHIPPING-PREPARING'
    | 'TX_STATUS_SHIPPING-IN-TRANSIT'
    | 'TX_STATUS_SHIPPING-COMPLETED'
    | 'TX_STATUS_TRANSACTION-COMPLETED-SAFE'
    | 'TX_STATUS_REFUND-REVIEW'
    | 'TX_STATUS_REFUND-WAIT'
    | 'TX_STATUS_REFUND-DENIED'
    | 'TX_STATUS_REFUND-COMPLETED';
  txStatuses?: (
    | 'TX_STATUS_CANCELED'
    | 'TX_STATUS_PAYMENT-PENDING'
    | 'TX_STATUS_PAYMENT-COMPLETED'
    | 'TX_STATUS_SHIPPING-PREPARING'
    | 'TX_STATUS_SHIPPING-IN-TRANSIT'
    | 'TX_STATUS_SHIPPING-COMPLETED'
    | 'TX_STATUS_TRANSACTION-COMPLETED-SAFE'
    | 'TX_STATUS_REFUND-REVIEW'
    | 'TX_STATUS_REFUND-WAIT'
    | 'TX_STATUS_REFUND-DENIED'
    | 'TX_STATUS_REFUND-COMPLETED'
  )[];
  txType: 'SELL' | 'BUY';
}

export interface ReviewsListParams {
  /** @example 30 */
  limit: number;
  /** @example 0 */
  offset: number;
  /** @example 1668080178342 */
  searchTimestamp: number;
}

export interface OrdersDetailParams1 {
  /**
   * 앱 버전. 6.0.0 이상일 경우에만 배송완료 상태가 보입니다.
   * @example "5.10.0"
   */
  appVersion?: '6.0.0';
  /**
   * Order ID
   * @example 525
   */
  orderId: number;
}

export interface BuyerCancelInfoListParams {
  orderItemIDs: number[];
  /**
   * orderID ID
   * @example 525
   */
  orderId: number;
}

export interface BuyerReturnInfoListParams {
  /** @example "REFUND_LOGIX-TYPE_SELLER_DIRECT" */
  method: 'REFUND_LOGIX-TYPE_ALL' | 'REFUND_LOGIX-TYPE_BUYER_DIRECT' | 'REFUND_LOGIX-TYPE_SELLER_DIRECT';
  orderItemIDs: number[];
  /**
   * 귀책 사유 (단순 변심, 상품 오배송 등)
   * @example "REFUND_REASON_NOT_SATISFIED"
   */
  reasonType:
    | 'REFUND_REASON_NOT_SATISFIED'
    | 'REFUND_REASON_BUYER_MISTAKE'
    | 'REFUND_REASON_WRONG_ITEM'
    | 'REFUND_REASON_WRONG_DELIVERY';
  zoneCode?: string;
  /**
   * orderID ID
   * @example 525
   */
  orderId: number;
}

export interface PaymentInfoListParams {
  couponID?: number;
  /**
   * 주문할 상품 목록입니다. 일반적인 주문일 경우에는 필수로 보내야 합니다.
   * @example [1,2,3,4]
   */
  marketItemIDs?: number[];
  /**
   * Deprecated
   * @example 10000
   */
  payAmount?: number;
  /** Deprecated */
  sellerID?: number;
  zonecode?: string;
}

export interface PopularUsersListParams {
  /** 팔로우한 유저 제외 여부 */
  excludeFollowUser?: boolean;
  /** 프로셀러 여부 (null: 전체, true: 프로셀러, false: 일반 유저) */
  isProSeller?: boolean;
  /**
   * default: 20
   * @example 10
   */
  limit?: number;
}

export interface RewardPointsListParams {
  /**
   * 페이징 Limit
   * @example 30
   */
  limit: number;
  /**
   * 페이징 Offset
   * @example 0
   */
  offset: number;
  pointStatus?:
    | 'REWARD-POINT_STATUS_SAVED'
    | 'REWARD-POINT_STATUS_SAVE-CANCELED'
    | 'REWARD-POINT_STATUS_SAVE-AWAITED'
    | 'REWARD-POINT_STATUS_USED';
  /** @example 1668080178342 */
  searchTimestamp: number;
}

export interface SettlementsListParams2 {
  createDateEnd?: number;
  createDateStart?: number;
  /** @example true */
  isProSeller?: boolean;
  /** @example true */
  isZero?: boolean;
  /** @example 30 */
  limit: number;
  /** @example 0 */
  offset: number;
  paymentType?: 'ONLINE' | 'STORE';
  /** @example 1668080178342 */
  searchTimestamp: number;
  /** @example [1,2,3] */
  settlementID?: number[];
  statuses?: string[];
}

export interface AmountListParams {
  /**
   * 종료일 포함하여 조회함
   * @example "2022-01-02T00:00:00Z"
   */
  createDateEnd: string;
  /** @example "2022-01-01T00:00:00Z" */
  createDateStart: string;
  /** 정산 상태 */
  status?: (
    | 'SETTLEMENT_STATUS_UNAUDITED'
    | 'SETTLEMENT_STATUS_SCHEDULED'
    | 'SETTLEMENT_STATUS_COMPLETED'
    | 'SETTLEMENT_STATUS_HOLD'
  )[];
}

export interface MarketItemCountPerCategoryListParams {
  /**
   * 판매자 아이디
   * @example 1
   */
  sellerID: number;
  /**
   * 대분류 카테고리 아이디
   * @example 1
   */
  topCategoryID?: number;
}

export interface MarketItemStatisticsListParams {
  isProSeller?: boolean;
}

export interface OfficialBrandStatisticsListParams {
  /** @example 10 */
  limit: number;
  /** @example 0 */
  offset: number;
}

export interface StoreCouponsListParams2 {
  /** 판매자 userID */
  sellerID: number;
}

export interface UserProfileListParams {
  /**
   * 할인 가격 수정 종료 날짜
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateEnd?: string;
  /**
   * 할인 가격 수정 시작 날짜
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateStart?: string;
  /** 프로필 조회할 유저 닉네임 */
  nickname?: string;
  /** 프로필 조회할 유저 아이디 */
  userID?: number;
  /** 프로셀러 정보 조회 여부 */
  withProSellerInfo?: boolean;
}

export interface UserStoreCouponsListParams {
  marketItemIDs?: number[];
  sellerID?: number;
}

export interface EmailDuplicateListParams {
  /** 이메일 */
  email: string;
}

export interface FollowingsMarketItemsListParams {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 최대 할인 가격
   * @example 100000
   */
  discountPriceMax?: number;
  /**
   * 최소 할인 가격 (최소 가격 0 이상)
   * @example 10000
   */
  discountPriceMin?: number;
  /**
   * 최대 할인율
   * @example 50
   */
  discountRateMax?: number;
  /**
   * 최소 할인율 (최소 할인율 0 이상)
   * @example 10
   */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?:
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX';
  /**
   * 포함할 성별
   * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
   */
  genderWears?: (
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
  )[];
  /** @example 30 */
  limit: number;
  /** 포함할 소재 ID */
  materialIDs?: number[];
  /**
   * 포함할 공식 브랜드 ID
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /** @example 0 */
  offset: number;
  /** 디폴트 최신순 */
  orderField?:
    | 'marketItemID'
    | 'discountPrice'
    | 'discountRate'
    | 'createDate'
    | 'modifyDate'
    | '_score'
    | 'aclosetScore'
    | 'popularity'
    | 'sellingDiscountRate'
    | 'discountPriceModifyDate'
    | 'similarUserPreferredItems'
    | 'recommendAfterSurvey'
    | 'bookmark';
  /** 포함할 패턴 ID */
  patternIDs?: number[];
  /**
   * Deprecated: 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * Deprecated: 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /** @example 1668080178342 */
  searchTimestamp: number;
  /** @example [1,2,3] */
  sellerIDs?: number[];
  /**
   * 포함할 사이즈
   * @example [1,2,3]
   */
  sizeIDs?: number[];
  sortOrder?: 'asc' | 'desc';
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: (
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE'
  )[];
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
}

export interface PartnerShopsListParams {
  limit?: number;
  offset?: number;
  /** 지역 */
  region?: string;
  userID?: number;
}

export interface PreferenceSizesListParams {
  userPreferenceGenderWear:
    | 'USER_PREFERENCE_GENDERWEAR_WOMEN'
    | 'USER_PREFERENCE_GENDERWEAR_MEN'
    | 'USER_PREFERENCE_GENDERWEAR_BOTH';
}

export interface ProSellerAdditionalInformationListParams {
  /** 프로필 조회할 유저 닉네임 */
  nickname?: string;
  /** 프로필 조회할 유저 아이디 */
  userID?: number;
}

export interface ProSellerServiceScoreListParams {
  /** 조회하길 원하는 프로셀러 아이디 */
  userID: number;
}

export interface SearchNicknameListParams {
  /** @example 20 */
  limit: number;
  nickname?: string;
  offset?: number;
  /** @example 1668080178342 */
  searchTimestamp: number;
  /** @example true */
  skipSellersWithoutMarketItems?: boolean;
}

export interface V2FollowingsMarketItemsListParams {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  brandTagIDs?: number[];
  /** @example 1 */
  buyerID?: number;
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 최대 가격
   * @example 100000
   */
  discountPriceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  discountPriceMin?: number;
  /**
   * 최대 할인율
   * @example 50
   */
  discountRateMax?: number;
  /**
   * 최소 할인율 (최소 할인율 0 이상)
   * @example 10
   */
  discountRateMin?: number;
  /**
   * 포함할 소재
   * @example ["MARKET-ITEM_FABRIC_COTTON"]
   */
  fabrics?: (
    | 'MARKET-ITEM_FABRIC_COTTON'
    | 'MARKET-ITEM_FABRIC_COTTON100'
    | 'MARKET-ITEM_FABRIC_WOOL'
    | 'MARKET-ITEM_FABRIC_WOOL100'
    | 'MARKET-ITEM_FABRIC_NYLON'
    | 'MARKET-ITEM_FABRIC_RAYON'
    | 'MARKET-ITEM_FABRIC_ACRYLIC'
    | 'MARKET-ITEM_FABRIC_ACRYLIC100'
    | 'MARKET-ITEM_FABRIC_POLYESTER'
    | 'MARKET-ITEM_FABRIC_POLYESTER100'
    | 'MARKET-ITEM_FABRIC_ANGORA'
    | 'MARKET-ITEM_FABRIC_ANGORA100'
    | 'MARKET-ITEM_FABRIC_SILK'
    | 'MARKET-ITEM_FABRIC_SILK100'
    | 'MARKET-ITEM_FABRIC_CASHMERE'
    | 'MARKET-ITEM_FABRIC_CASHMERE100'
    | 'MARKET-ITEM_FABRIC_LINEN'
    | 'MARKET-ITEM_FABRIC_MOHAIR'
    | 'MARKET-ITEM_FABRIC_ALPACA'
    | 'MARKET-ITEM_FABRIC_ALPACA100'
    | 'MARKET-ITEM_FABRIC_POLYURETHANE'
    | 'MARKET-ITEM_FABRIC_TRIACETATE'
    | 'MARKET-ITEM_FABRIC_ACETATE'
    | 'MARKET-ITEM_FABRIC_DENIM'
    | 'MARKET-ITEM_FABRIC_CORDUROY'
    | 'MARKET-ITEM_FABRIC_LEATHER'
    | 'MARKET-ITEM_FABRIC_SUEDE'
    | 'MARKET-ITEM_FABRIC_VISCOSE'
    | 'MARKET-ITEM_FABRIC_LYOCELL'
    | 'MARKET-ITEM_FABRIC_CUPRO'
    | 'MARKET-ITEM_FABRIC_RABBITFUR'
    | 'MARKET-ITEM_FABRIC_DOWN'
    | 'MARKET-ITEM_FABRIC_DUCKDOWN'
    | 'MARKET-ITEM_FABRIC_GOOSEDOWN'
    | 'MARKET-ITEM_FABRIC_COWLEATHER'
    | 'MARKET-ITEM_FABRIC_LAMBLEATHER'
    | 'MARKET-ITEM_FABRIC_PIGLEATHER'
    | 'MARKET-ITEM_FABRIC_GENUINELEATHER'
    | 'MARKET-ITEM_FABRIC_SYNTHETICLEATHER'
    | 'MARKET-ITEM_FABRIC_METAL'
    | 'MARKET-ITEM_FABRIC_VELVET'
    | 'MARKET-ITEM_FABRIC_UNKNOWN'
  )[];
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?:
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX';
  /**
   * 포함할 성별
   * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
   */
  genderWears?: (
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
  )[];
  /**
   * 무료배송 여부
   * @example true
   */
  isFreeShipping?: boolean;
  /** @example 30 */
  limit: number;
  /** 포함할 소재 ID */
  materialIDs?: number[];
  nextCursor?: string;
  /** 포함할 공식 브랜드 - marketItem 에 저장하고 있지 않아 따로 조회하여 brandName 으로 필터링 */
  officialBrandIDs?: number[];
  orderField?:
    | 'marketItemID'
    | 'discountPrice'
    | 'discountRate'
    | 'createDate'
    | 'modifyDate'
    | '_score'
    | 'aclosetScore'
    | 'popularity'
    | 'sellingDiscountRate'
    | 'discountPriceModifyDate'
    | 'similarUserPreferredItems'
    | 'recommendAfterSurvey'
    | 'bookmark';
  /** 포함할 패턴 ID */
  patternIDs?: number[];
  /**
   * Deprecated: 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * Deprecated: 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /** @example 1668080178342 */
  searchTimestamp: number;
  /** @example [1,2,3] */
  sellerIDs?: number[];
  /** @example 1 */
  shoeSizeMax?: number;
  /** @example 1 */
  shoeSizeMin?: number;
  /**
   * 포함할 사이즈
   * @example [1,2,3]
   */
  sizeIDs?: number[];
  sortOrder?: 'asc' | 'desc';
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: (
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE'
  )[];
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
}

export interface VerificationBankAccountListParams {
  /** 판매자 예금주명 */
  accountHolder: string;
  /** 판매자 계좌번호 */
  accountNumber: string;
  bankCode: string;
  bankName: string;
}

export interface BookmarkMarketItemCountListParams {
  /**
   * 리스트 조회 기준 생성일시
   * @example 1668080178342
   */
  searchTimestamp: number;
  sellerIDs?: number[];
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: (
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE'
  )[];
  /**
   * 유저 ID
   * @example 26124
   */
  userId: number;
}

export interface BookmarkMarketItemsListParams {
  /**
   * 페이징 Limit
   * @example 30
   */
  limit: number;
  /**
   * 페이징 Offset
   * @example 0
   */
  offset: number;
  orderField?: 'marketItemID' | 'discountPrice' | 'discountRate' | 'bookmarkID' | 'createDate';
  /**
   * 리스트 조회 기준 생성일시
   * @example 1668080178342
   */
  searchTimestamp: number;
  sellerIDs?: number[];
  sortOrder?: 'asc' | 'desc';
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: (
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE'
  )[];
  /**
   * 유저 ID
   * @example 22124
   */
  userId: number;
}

export interface MarketItemReviewsListParams2 {
  /**
   * 매장 결제 포함 여부 (true로 전달하지 않는다면 매장결제는 포함하지 않습니다.)
   * @example true
   */
  includeStorePayment?: boolean;
  /**
   * 페이징 Limit
   * @example 30
   */
  limit: number;
  /**
   * 페이징 Offset
   * @example 0
   */
  offset: number;
  /** Deprecated */
  paymentType?: 'ONLINE' | 'STORE';
  /** 리뷰의 타입 (BUYING: 구매자가 작성한 리뷰, SELLING: 판매자가 작성한 리뷰) */
  reviewType?: 'MARKET-ITEM_REVIEW-TYPE_BUYING' | 'MARKET-ITEM_REVIEW-TYPE_SELLING';
  /**
   * 날짜 기준
   * @example 1668080178342
   */
  searchTimestamp: number;
  /**
   * 유저의 타입 (REVIEWER: 유저가 쓴 리뷰를 필터링, REVIEWEE: 유저가 받은 리뷰를 필터링)
   * @example "MARKET-ITEM_REVIEW-USER-TYPE_REVIEWER"
   */
  userType?: 'MARKET-ITEM_REVIEW-USER-TYPE_REVIEWER' | 'MARKET-ITEM_REVIEW-USER-TYPE_REVIEWEE';
  /**
   * 유저 ID
   * @example 2512
   */
  userId: number;
}

export interface MarketItemsListParams2 {
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 최대 할인율
   * @example 50
   */
  discountRateMax?: number;
  /**
   * 최소 할인율 (최소 할인율 0 이상)
   * @example 10
   */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?: string;
  /**
   * 무료배송 여부
   * @example true
   */
  isFreeShipping?: boolean;
  /**
   * 페이징 Limit
   * @example 10
   */
  limit: number;
  /**
   * 포함할 중고 아이템 ID
   * @example [1,2,3]
   */
  marketItemIDs?: number[];
  /**
   * 페이징 Offset
   * @example 20
   */
  offset: number;
  /**
   * 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /**
   * 리스트 조회 기준 생성일시
   * @example 1668080178342
   */
  searchTimestamp: number;
  /**
   * 포함할 사이즈
   * @example [1,2,3]
   */
  sizeIDs?: number[];
  /**
   * 조회할 중고 아이템의 상태 (판매중, 판매완료)
   * @example "MARKET-ITEM_STATUS_FOR-SALE"
   */
  status?:
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE';
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: string[];
  /** @example "흰색 티셔츠" */
  textSearch?: string;
  /**
   * 조회할 거래내역 종류: 구매/판매 여부
   * @example "SALES"
   */
  type: 'PURCHASE' | 'SALES';
  /** 유저의 거래 내역 불러오기 */
  userId: number;
}

export interface PopularMarketItemsListParams {
  /** @example 30 */
  limit: number;
  /** @example 0 */
  offset: number;
  userId: string;
}

export interface SellerFollowsListParams {
  limit: number;
  offset: number;
  /**
   * 리스트 조회 기준 생성일시
   * @example 1668080178342
   */
  searchTimestamp: number;
  /** 유저 아이디 */
  userId: number;
}

export interface MarketItemsListParams4 {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  brandTagIDs?: number[];
  /** @example 1 */
  buyerID?: number;
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 생성일 끝 - 예전에 개발한거라 unixmilli로 받음
   * @example 1668080178342
   */
  createDateEnd?: number;
  /**
   * 생성일 시작 - 예전에 개발한거라 unixmilli로 받음
   * @example 1668080178342
   */
  createDateStart?: number;
  /**
   * 최대 가격
   * @example 100000
   */
  discountPriceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  discountPriceMin?: number;
  /**
   * 할인 가격 수정일 끝
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateEnd?: string;
  /**
   * 할인 가격 수정일 시작
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateStart?: string;
  /**
   * 최대 할인율
   * @example 50
   */
  discountRateMax?: number;
  /**
   * 최소 할인율 (최소 할인율 0 이상)
   * @example 10
   */
  discountRateMin?: number;
  /**
   * 포함할 소재
   * @example ["MARKET-ITEM_FABRIC_COTTON"]
   */
  fabrics?: (
    | 'MARKET-ITEM_FABRIC_COTTON'
    | 'MARKET-ITEM_FABRIC_COTTON100'
    | 'MARKET-ITEM_FABRIC_WOOL'
    | 'MARKET-ITEM_FABRIC_WOOL100'
    | 'MARKET-ITEM_FABRIC_NYLON'
    | 'MARKET-ITEM_FABRIC_RAYON'
    | 'MARKET-ITEM_FABRIC_ACRYLIC'
    | 'MARKET-ITEM_FABRIC_ACRYLIC100'
    | 'MARKET-ITEM_FABRIC_POLYESTER'
    | 'MARKET-ITEM_FABRIC_POLYESTER100'
    | 'MARKET-ITEM_FABRIC_ANGORA'
    | 'MARKET-ITEM_FABRIC_ANGORA100'
    | 'MARKET-ITEM_FABRIC_SILK'
    | 'MARKET-ITEM_FABRIC_SILK100'
    | 'MARKET-ITEM_FABRIC_CASHMERE'
    | 'MARKET-ITEM_FABRIC_CASHMERE100'
    | 'MARKET-ITEM_FABRIC_LINEN'
    | 'MARKET-ITEM_FABRIC_MOHAIR'
    | 'MARKET-ITEM_FABRIC_ALPACA'
    | 'MARKET-ITEM_FABRIC_ALPACA100'
    | 'MARKET-ITEM_FABRIC_POLYURETHANE'
    | 'MARKET-ITEM_FABRIC_TRIACETATE'
    | 'MARKET-ITEM_FABRIC_ACETATE'
    | 'MARKET-ITEM_FABRIC_DENIM'
    | 'MARKET-ITEM_FABRIC_CORDUROY'
    | 'MARKET-ITEM_FABRIC_LEATHER'
    | 'MARKET-ITEM_FABRIC_SUEDE'
    | 'MARKET-ITEM_FABRIC_VISCOSE'
    | 'MARKET-ITEM_FABRIC_LYOCELL'
    | 'MARKET-ITEM_FABRIC_CUPRO'
    | 'MARKET-ITEM_FABRIC_RABBITFUR'
    | 'MARKET-ITEM_FABRIC_DOWN'
    | 'MARKET-ITEM_FABRIC_DUCKDOWN'
    | 'MARKET-ITEM_FABRIC_GOOSEDOWN'
    | 'MARKET-ITEM_FABRIC_COWLEATHER'
    | 'MARKET-ITEM_FABRIC_LAMBLEATHER'
    | 'MARKET-ITEM_FABRIC_PIGLEATHER'
    | 'MARKET-ITEM_FABRIC_GENUINELEATHER'
    | 'MARKET-ITEM_FABRIC_SYNTHETICLEATHER'
    | 'MARKET-ITEM_FABRIC_METAL'
    | 'MARKET-ITEM_FABRIC_VELVET'
    | 'MARKET-ITEM_FABRIC_UNKNOWN'
  )[];
  /**
   * 포함할 성별
   * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
   */
  genderWears?: (
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
  )[];
  /**
   * 무료배송 여부
   * @example true
   */
  isFreeShipping?: boolean;
  /** @example 30 */
  limit: number;
  /**
   * 로직스 ID
   * @example 1
   */
  logixID?: number;
  marketItemIDs?: number[];
  /** 포함할 소재 ID */
  materialIDs?: number[];
  nextCursor?: string;
  /** 포함할 공식 브랜드 - marketItem 에 저장하고 있지 않아 따로 조회하여 brandName 으로 필터링 */
  officialBrandIDs?: number[];
  omitNoBrand?: boolean;
  orderField?:
    | 'marketItemID'
    | 'discountPrice'
    | 'discountRate'
    | 'createDate'
    | 'modifyDate'
    | '_score'
    | 'aclosetScore'
    | 'popularity'
    | 'sellingDiscountRate'
    | 'discountPriceModifyDate'
    | 'similarUserPreferredItems'
    | 'recommendAfterSurvey'
    | 'bookmark';
  /** 포함할 패턴 ID */
  patternIDs?: number[];
  /** 검색어 기반 개인화 추천 여부 */
  personalizedWithSearchKeyword?: boolean;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /** @example 1668080178342 */
  searchTimestamp: number;
  /**
   * TODO: 섹션 조회를 위해 추가된 필드. 섹션 수정이 되면 삭제될 예정
   * @example 1
   */
  sellerID?: number;
  /** @example [1,2,3] */
  sellerIDs?: number[];
  /** @example 50 */
  sellingDiscountRateMax?: number;
  /**
   * A/B 테스트 및 세일 페이지 용 필드
   * B 그룹은 DiscountRateMin, DiscountRateMax 대신 SellingDiscountRateMin, SellingDiscountRateMax 사용 (MarketItemPriceABPolicyRequest)
   * 세일 페이지에서는 프론트도 사용
   * @example 10
   */
  sellingDiscountRateMin?: number;
  /** @example 1 */
  shoeSizeMax?: number;
  /** @example 1 */
  shoeSizeMin?: number;
  /**
   * 포함할 사이즈
   * @example [1,2,3]
   */
  sizeIDs?: number[];
  sortOrder?: 'asc' | 'desc';
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: (
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE'
  )[];
  /** @example "흰색 티셔츠" */
  textSearch?: string;
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
}

export interface NotificationsActivityListParams {
  /** @example 30 */
  limit: number;
  nextCursor?: number;
}

export interface NotificationsFavoriteListParams {
  /** @example 30 */
  limit: number;
  nextCursor?: number;
}

export interface UsersProSellerListParams2 {
  /** 상점 라벨 필터 - list 에 있는 값 and 조건 */
  andConditionProSellerLabels?: (
    | 'PRO-SELLER-LABEL-TYPE_ISSUED-COUPON'
    | 'PRO-SELLER-LABEL-TYPE_RATING-ABOVE-FOUR-POINT-NINE'
    | 'PRO-SELLER-LABEL-TYPE_HIGH-REPURCHASE-RATE'
    | 'PRO-SELLER-INFO_LABEL-TYPE_ON-DISCOUNT'
  )[];
  /**
   * 가입 날짜 시작일 (Gte)
   * @example "2024-04-05T04:24:25.966Z"
   */
  gteOfficiallyEnteredDate?: string;
  /**
   * default: 20
   * @example 10
   */
  limit?: number;
  /** @example 0 */
  offset?: number;
  /** 상점 정보 키워드 필터 - list 에 있는 값 or 조건 */
  orConditionProSellerInfoKeywords?: (
    | 'PROSELLER-INFO_KEYWORDS-TYPE_VINTAGE'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_BASIC'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_CLASSIC'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_FUNKY'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_CASUAL'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_STREET'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_FEMININE'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_SPORTY'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_MILITARY'
  )[];
  /** 프로셀러 정렬 필드 (officiallyEnteredDate: 입점 날짜 기준) */
  proSellerOrderField?: 'officiallyEnteredDate';
  /** @example 1668080178342 */
  searchTimestamp: number;
  /**
   * default: desc
   * @example "desc"
   */
  sortOrder?: 'asc' | 'desc';
  withInVisibleProSeller?: boolean;
}

export interface BrandsAllListParams {
  brandDivision?: 'GLOBAL' | 'CUSTOM' | 'TOTAL';
  /** @example "THENORTHFACE" */
  brandName: string;
  /**
   * default: 20
   * @example 10
   */
  limit?: number;
  /** @example 0 */
  offset?: number;
  searchType: 'LIKE' | 'EQUAL';
}

export interface MarketItemsListParams6 {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  brandTagIDs?: number[];
  /** @example 1 */
  buyerID?: number;
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 생성일 끝
   * @example 1668080178342
   */
  createDateEnd?: number;
  /**
   * 생성일 시작
   * @example 1668080178342
   */
  createDateStart?: number;
  /**
   * 할인 가격 수정일 끝
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateEnd?: string;
  /**
   * 할인 가격 수정일 시작
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateStart?: string;
  /**
   * 최대 할인율
   * @example 50
   */
  discountRateMax?: number;
  /**
   * 최소 할인율 (최소 할인율 0 이상)
   * @example 10
   */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?:
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX';
  /**
   * 포함할 성별
   * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
   */
  genderWears?: (
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
  )[];
  /**
   * 무료배송 여부
   * @example true
   */
  isFreeShipping?: boolean;
  /** @example 30 */
  limit: number;
  marketItemIDs?: number[];
  /** 포함할 소재 ID */
  materialIDs?: number[];
  /** 포함할 공식 브랜드 */
  officialBrandIDs?: number[];
  /** @example 0 */
  offset: number;
  omitNoBrand?: boolean;
  /** 디폴트 최신순 */
  orderField?:
    | 'marketItemID'
    | 'discountPrice'
    | 'discountRate'
    | 'createDate'
    | 'modifyDate'
    | '_score'
    | 'aclosetScore'
    | 'popularity'
    | 'sellingDiscountRate'
    | 'discountPriceModifyDate'
    | 'similarUserPreferredItems'
    | 'recommendAfterSurvey'
    | 'bookmark';
  /** 포함할 패턴 ID */
  patternIDs?: number[];
  /**
   * 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /** @example 1668080178342 */
  searchTimestamp: number;
  /** @example 1 */
  sellerID?: number;
  /** @example [1,2,3] */
  sellerIDs?: number[];
  /** 내부 필드 */
  sellingDiscountRateMax?: number;
  /** 최소 할인율 (최소 할인율 0 이상) */
  sellingDiscountRateMin?: number;
  /**
   * 포함할 사이즈
   * @example [1,2,3]
   */
  sizeIDs?: number[];
  sortOrder?: 'asc' | 'desc';
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: (
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE'
  )[];
  /** @example "흰색 티셔츠" */
  textSearch?: string;
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
  withStoreMarketItem?: boolean;
}

export interface MarketItemsCoordinatesListParams2 {
  /**
   * 코디 IDs
   * @example [1,2,3,4,5]
   */
  coordinateIDs?: number[];
  /** @example 30 */
  limit: number;
  /** @example 1 */
  nextCursor?: number;
  /** @example 0 */
  offset: number;
  /**
   * 섹션 Keys
   * @example [12312144554654]
   */
  sectionKeys?: number[];
}

export interface MarketItemsDetailListParams {
  /**
   * 중고 아이템 ID
   * @example [1,2,3]
   */
  marketItemIDs: number[];
}

export interface MarketItemsFilterListParams {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  brandTagIDs?: number[];
  /** @example 1 */
  buyerID?: number;
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 생성일 끝 - 예전에 개발한거라 unixmilli로 받음
   * @example 1668080178342
   */
  createDateEnd?: number;
  /**
   * 생성일 시작 - 예전에 개발한거라 unixmilli로 받음
   * @example 1668080178342
   */
  createDateStart?: number;
  /** 브랜드는 종류가 너무 많아서 특정 Group by 하면 로드가 부담되어 현재 페이지 브랜드만 Group by */
  currentPageOfficialBrandIDs?: number[];
  /**
   * 최대 가격
   * @example 100000
   */
  discountPriceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  discountPriceMin?: number;
  /**
   * 할인 가격 수정일 끝
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateEnd?: string;
  /**
   * 할인 가격 수정일 시작
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateStart?: string;
  /**
   * 최대 할인율
   * @example 50
   */
  discountRateMax?: number;
  /**
   * 최소 할인율 (최소 할인율 0 이상)
   * @example 10
   */
  discountRateMin?: number;
  /**
   * 포함할 소재
   * @example ["MARKET-ITEM_FABRIC_COTTON"]
   */
  fabrics?: (
    | 'MARKET-ITEM_FABRIC_COTTON'
    | 'MARKET-ITEM_FABRIC_COTTON100'
    | 'MARKET-ITEM_FABRIC_WOOL'
    | 'MARKET-ITEM_FABRIC_WOOL100'
    | 'MARKET-ITEM_FABRIC_NYLON'
    | 'MARKET-ITEM_FABRIC_RAYON'
    | 'MARKET-ITEM_FABRIC_ACRYLIC'
    | 'MARKET-ITEM_FABRIC_ACRYLIC100'
    | 'MARKET-ITEM_FABRIC_POLYESTER'
    | 'MARKET-ITEM_FABRIC_POLYESTER100'
    | 'MARKET-ITEM_FABRIC_ANGORA'
    | 'MARKET-ITEM_FABRIC_ANGORA100'
    | 'MARKET-ITEM_FABRIC_SILK'
    | 'MARKET-ITEM_FABRIC_SILK100'
    | 'MARKET-ITEM_FABRIC_CASHMERE'
    | 'MARKET-ITEM_FABRIC_CASHMERE100'
    | 'MARKET-ITEM_FABRIC_LINEN'
    | 'MARKET-ITEM_FABRIC_MOHAIR'
    | 'MARKET-ITEM_FABRIC_ALPACA'
    | 'MARKET-ITEM_FABRIC_ALPACA100'
    | 'MARKET-ITEM_FABRIC_POLYURETHANE'
    | 'MARKET-ITEM_FABRIC_TRIACETATE'
    | 'MARKET-ITEM_FABRIC_ACETATE'
    | 'MARKET-ITEM_FABRIC_DENIM'
    | 'MARKET-ITEM_FABRIC_CORDUROY'
    | 'MARKET-ITEM_FABRIC_LEATHER'
    | 'MARKET-ITEM_FABRIC_SUEDE'
    | 'MARKET-ITEM_FABRIC_VISCOSE'
    | 'MARKET-ITEM_FABRIC_LYOCELL'
    | 'MARKET-ITEM_FABRIC_CUPRO'
    | 'MARKET-ITEM_FABRIC_RABBITFUR'
    | 'MARKET-ITEM_FABRIC_DOWN'
    | 'MARKET-ITEM_FABRIC_DUCKDOWN'
    | 'MARKET-ITEM_FABRIC_GOOSEDOWN'
    | 'MARKET-ITEM_FABRIC_COWLEATHER'
    | 'MARKET-ITEM_FABRIC_LAMBLEATHER'
    | 'MARKET-ITEM_FABRIC_PIGLEATHER'
    | 'MARKET-ITEM_FABRIC_GENUINELEATHER'
    | 'MARKET-ITEM_FABRIC_SYNTHETICLEATHER'
    | 'MARKET-ITEM_FABRIC_METAL'
    | 'MARKET-ITEM_FABRIC_VELVET'
    | 'MARKET-ITEM_FABRIC_UNKNOWN'
  )[];
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?:
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX';
  /**
   * 포함할 성별
   * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
   */
  genderWears?: (
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
  )[];
  /**
   * 무료배송 여부
   * @example true
   */
  isFreeShipping?: boolean;
  /** 포함할 소재 ID */
  materialIDs?: number[];
  /** 포함할 공식 브랜드 - marketItem 에 저장하고 있지 않아 따로 조회하여 brandName 으로 필터링 */
  officialBrandIDs?: number[];
  /** 포함할 패턴 ID */
  patternIDs?: number[];
  /** 검색어 기반 개인화 추천 여부 */
  personalizedWithSearchKeyword?: boolean;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /** @example [1,2,3] */
  sellerIDs?: number[];
  /** @example 1 */
  shoeSizeMax?: number;
  /** @example 1 */
  shoeSizeMin?: number;
  /**
   * 포함할 사이즈
   * @example [1,2,3]
   */
  sizeIDs?: number[];
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: (
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE'
  )[];
  /** @example "흰색 티셔츠" */
  textSearch?: string;
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
}

export interface MarketItemsReviewsRealtimeListParams {
  sellerID?: number;
}

export interface MarketItemsDetailParams5 {
  /**
   * 가격변동 이력 조회 종료일
   * @example "2024-04-05T04:24:25.966Z"
   */
  marketItemPriceHistoryEndDate?: string;
  /**
   * 가격변동 이력 조회 시작일
   * @example "2024-04-05T04:24:25.966Z"
   */
  marketItemPriceHistoryStartDate?: string;
  /** 마켓아이템 조회수 업데이트 여부 */
  skipUpdateView?: boolean;
  /**
   * 중고 ID
   * @example 525
   */
  marketItemId: number;
}

export interface OfficialBrandsListParams4 {
  /** QuickButtonOrder 기준으로 채워서 limit 만큼 반환 */
  fillToLimitWithQuickButtonOrder?: boolean;
  /** 팔로우한 브랜드만 가져올 지 여부 */
  followedOnly?: boolean;
  /** 해당 브랜드에 판매중인 아이템 수가 N개 이상인 것만 가져옵니다. */
  greaterThanOrEqualMarketItemCount?: number;
  /** 응답에 브랜드별 팔로우 여부를 가져올 지 여부입니다. 하위호환을 위해서 미전달시 true로 동작합니다. */
  includeIsFollowing?: boolean;
  /** 응답에 브랜드별 판매중인 아이템 수를 가져올 지 여부입니다. (totalMarketItemCount, remainingMarketItemCount) 하위호환을 위해서 미전달시 true로 동작합니다. */
  includeMarketItemCount?: boolean;
  /** 검색 초기 화면 - 인기 브랜드 목록을 가져올 지 여부 */
  isSearchVisible?: boolean;
  /** @default 20 */
  limit?: number;
  /** @default 0 */
  offset?: number;
  /** 맞춤 설정(내 취향 분석)을 위한 특수 정렬 */
  orderByCustomPreferences?: boolean;
  /** 판매중인 아이템 수를 기준으로 정렬 (기본 동작:내림차순) */
  orderByMarketItemCount?: boolean;
  searchText?: string;
  tagID?: number;
  withMarketItems?: boolean;
  /** 실제로는 limit 과 유사한 개념의 필드 */
  withMarketItemsCount?: number;
}

export interface OfficialBrandsTagsListParams2 {
  isBrandCategoryVisible?: boolean;
  isOnboardingVisible?: boolean;
}

export interface StatisticsOfficialBrandStatisticsListParams {
  /** @example 10 */
  limit: number;
  /** @example 0 */
  offset: number;
}

export interface UserProfileListParams2 {
  /**
   * 할인 가격 수정 종료 날짜
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateEnd?: string;
  /**
   * 할인 가격 수정 시작 날짜
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateStart?: string;
  /** 프로필 조회할 유저 닉네임 */
  nickname?: string;
  /** 프로필 조회할 유저 아이디 */
  userID?: number;
  /** 프로셀러 정보 조회 여부 */
  withProSellerInfo?: boolean;
}

export interface UsersPartnerShopsListParams2 {
  limit?: number;
  offset?: number;
  /** 지역 */
  region?: string;
  userID?: number;
}

export interface UsersProSellerListParams4 {
  /**
   * 할인 가격 수정 날짜 끝 (Lte)
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateEnd?: string;
  /**
   * 할인 가격 수정 날짜 시작 (Gte)
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateStart?: string;
  /**
   * default: 20
   * @example 10
   */
  limit?: number;
  /**
   * default: 0
   * @example 0
   */
  marketItemDiscountRateMin?: number;
  /**
   * default: 20 샵의 대표 아이템 갯수
   * @example 3
   */
  marketItemLimit?: number;
  /** default: aclosetScore */
  marketItemOrderField?:
    | 'marketItemID'
    | 'discountPrice'
    | 'discountRate'
    | 'createDate'
    | 'modifyDate'
    | '_score'
    | 'aclosetScore'
    | 'popularity'
    | 'sellingDiscountRate'
    | 'discountPriceModifyDate'
    | 'similarUserPreferredItems'
    | 'recommendAfterSurvey'
    | 'bookmark';
  /** default: desc */
  marketItemSortOrder?: 'asc' | 'desc';
  /** @example 0 */
  offset?: number;
  /** @example true */
  orderByDiscountPriceModifyDate?: boolean;
  /** 데이터를 Follower에 따라 정렬할 지에 대한 조건 */
  orderByFollowers?: boolean;
  /** @example 1668080178342 */
  searchTimestamp?: number;
  withInVisibleProSeller?: boolean;
}

export interface UsersMarketItemsListParams2 {
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 최대 할인율
   * @example 50
   */
  discountRateMax?: number;
  /**
   * 최소 할인율 (최소 할인율 0 이상)
   * @example 10
   */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?: string;
  /**
   * 무료배송 여부
   * @example true
   */
  isFreeShipping?: boolean;
  /**
   * 페이징 Limit
   * @example 10
   */
  limit: number;
  /**
   * 포함할 중고 아이템 ID
   * @example [1,2,3]
   */
  marketItemIDs?: number[];
  /**
   * 페이징 Offset
   * @example 20
   */
  offset: number;
  /**
   * 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /**
   * 리스트 조회 기준 생성일시
   * @example 1668080178342
   */
  searchTimestamp: number;
  /**
   * 포함할 사이즈
   * @example [1,2,3]
   */
  sizeIDs?: number[];
  /**
   * 조회할 중고 아이템의 상태 (판매중, 판매완료)
   * @example "MARKET-ITEM_STATUS_FOR-SALE"
   */
  status?:
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE';
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: string[];
  /** @example "흰색 티셔츠" */
  textSearch?: string;
  /**
   * 조회할 거래내역 종류: 구매/판매 여부
   * @example "SALES"
   */
  type: 'PURCHASE' | 'SALES';
  /** 유저의 거래 내역 불러오기 */
  userId: number;
}

export interface V2MarketItemsListParams {
  /** @example 1 */
  bottomTotalLengthMax?: number;
  /** @example 1 */
  bottomTotalLengthMin?: number;
  /** @example 1 */
  bottomWaistMax?: number;
  /** @example 1 */
  bottomWaistMin?: number;
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  brandTagIDs?: number[];
  /** @example 1 */
  buyerID?: number;
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 생성일 끝 - 예전에 개발한거라 unixmilli로 받음
   * @example 1668080178342
   */
  createDateEnd?: number;
  /**
   * 생성일 시작 - 예전에 개발한거라 unixmilli로 받음
   * @example 1668080178342
   */
  createDateStart?: number;
  /**
   * 최대 가격
   * @example 100000
   */
  discountPriceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  discountPriceMin?: number;
  /**
   * 할인 가격 수정일 끝
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateEnd?: string;
  /**
   * 할인 가격 수정일 시작
   * @example "2024-04-05T04:24:25.966Z"
   */
  discountPriceModifyDateStart?: string;
  /**
   * 최대 할인율
   * @example 50
   */
  discountRateMax?: number;
  /**
   * 최소 할인율 (최소 할인율 0 이상)
   * @example 10
   */
  discountRateMin?: number;
  /**
   * 포함할 소재
   * @example ["MARKET-ITEM_FABRIC_COTTON"]
   */
  fabrics?: (
    | 'MARKET-ITEM_FABRIC_COTTON'
    | 'MARKET-ITEM_FABRIC_COTTON100'
    | 'MARKET-ITEM_FABRIC_WOOL'
    | 'MARKET-ITEM_FABRIC_WOOL100'
    | 'MARKET-ITEM_FABRIC_NYLON'
    | 'MARKET-ITEM_FABRIC_RAYON'
    | 'MARKET-ITEM_FABRIC_ACRYLIC'
    | 'MARKET-ITEM_FABRIC_ACRYLIC100'
    | 'MARKET-ITEM_FABRIC_POLYESTER'
    | 'MARKET-ITEM_FABRIC_POLYESTER100'
    | 'MARKET-ITEM_FABRIC_ANGORA'
    | 'MARKET-ITEM_FABRIC_ANGORA100'
    | 'MARKET-ITEM_FABRIC_SILK'
    | 'MARKET-ITEM_FABRIC_SILK100'
    | 'MARKET-ITEM_FABRIC_CASHMERE'
    | 'MARKET-ITEM_FABRIC_CASHMERE100'
    | 'MARKET-ITEM_FABRIC_LINEN'
    | 'MARKET-ITEM_FABRIC_MOHAIR'
    | 'MARKET-ITEM_FABRIC_ALPACA'
    | 'MARKET-ITEM_FABRIC_ALPACA100'
    | 'MARKET-ITEM_FABRIC_POLYURETHANE'
    | 'MARKET-ITEM_FABRIC_TRIACETATE'
    | 'MARKET-ITEM_FABRIC_ACETATE'
    | 'MARKET-ITEM_FABRIC_DENIM'
    | 'MARKET-ITEM_FABRIC_CORDUROY'
    | 'MARKET-ITEM_FABRIC_LEATHER'
    | 'MARKET-ITEM_FABRIC_SUEDE'
    | 'MARKET-ITEM_FABRIC_VISCOSE'
    | 'MARKET-ITEM_FABRIC_LYOCELL'
    | 'MARKET-ITEM_FABRIC_CUPRO'
    | 'MARKET-ITEM_FABRIC_RABBITFUR'
    | 'MARKET-ITEM_FABRIC_DOWN'
    | 'MARKET-ITEM_FABRIC_DUCKDOWN'
    | 'MARKET-ITEM_FABRIC_GOOSEDOWN'
    | 'MARKET-ITEM_FABRIC_COWLEATHER'
    | 'MARKET-ITEM_FABRIC_LAMBLEATHER'
    | 'MARKET-ITEM_FABRIC_PIGLEATHER'
    | 'MARKET-ITEM_FABRIC_GENUINELEATHER'
    | 'MARKET-ITEM_FABRIC_SYNTHETICLEATHER'
    | 'MARKET-ITEM_FABRIC_METAL'
    | 'MARKET-ITEM_FABRIC_VELVET'
    | 'MARKET-ITEM_FABRIC_UNKNOWN'
  )[];
  /**
   * 포함할 성별
   * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
   */
  genderWears?: (
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX'
    | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
  )[];
  /**
   * 무료배송 여부
   * @example true
   */
  isFreeShipping?: boolean;
  /** @example 30 */
  limit: number;
  /**
   * 로직스 ID
   * @example 1
   */
  logixID?: number;
  marketItemIDs?: number[];
  /** 포함할 소재 ID */
  materialIDs?: number[];
  nextCursor?: string;
  /** 포함할 공식 브랜드 - marketItem 에 저장하고 있지 않아 따로 조회하여 brandName 으로 필터링 */
  officialBrandIDs?: number[];
  omitNoBrand?: boolean;
  orderField?:
    | 'marketItemID'
    | 'discountPrice'
    | 'discountRate'
    | 'createDate'
    | 'modifyDate'
    | '_score'
    | 'aclosetScore'
    | 'popularity'
    | 'sellingDiscountRate'
    | 'discountPriceModifyDate'
    | 'similarUserPreferredItems'
    | 'recommendAfterSurvey'
    | 'bookmark';
  /** 포함할 패턴 ID */
  patternIDs?: number[];
  /** 검색어 기반 개인화 추천 여부 */
  personalizedWithSearchKeyword?: boolean;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /** @example 1668080178342 */
  searchTimestamp: number;
  /**
   * TODO: 섹션 조회를 위해 추가된 필드. 섹션 수정이 되면 삭제될 예정
   * @example 1
   */
  sellerID?: number;
  /** @example [1,2,3] */
  sellerIDs?: number[];
  /** @example 50 */
  sellingDiscountRateMax?: number;
  /**
   * A/B 테스트 및 세일 페이지 용 필드
   * B 그룹은 DiscountRateMin, DiscountRateMax 대신 SellingDiscountRateMin, SellingDiscountRateMax 사용 (MarketItemPriceABPolicyRequest)
   * 세일 페이지에서는 프론트도 사용
   * @example 10
   */
  sellingDiscountRateMin?: number;
  /** @example 1 */
  shoeSizeMax?: number;
  /** @example 1 */
  shoeSizeMin?: number;
  /**
   * 포함할 사이즈
   * @example [1,2,3]
   */
  sizeIDs?: number[];
  sortOrder?: 'asc' | 'desc';
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: (
    | 'MARKET-ITEM_STATUS_SOLD'
    | 'MARKET-ITEM_STATUS_PROCESSING'
    | 'MARKET-ITEM_STATUS_FOR-SALE'
    | 'MARKET-ITEM_STATUS_STOP-SALE'
    | 'MARKET-ITEM_STATUS_NO-SALE'
  )[];
  /** @example "흰색 티셔츠" */
  textSearch?: string;
  /** @example 1 */
  topChestMax?: number;
  /** @example 1 */
  topChestMin?: number;
  /** @example 1 */
  topShoulderMax?: number;
  /** @example 1 */
  topShoulderMin?: number;
  /** @example 1 */
  topSleeveLengthMax?: number;
  /** @example 1 */
  topSleeveLengthMin?: number;
  /** @example 1 */
  topTotalLengthMax?: number;
  /** @example 1 */
  topTotalLengthMin?: number;
}

export interface V2UsersProSellerListParams2 {
  /** 상점 라벨 필터 - list 에 있는 값 and 조건 */
  andConditionProSellerLabels?: (
    | 'PRO-SELLER-LABEL-TYPE_ISSUED-COUPON'
    | 'PRO-SELLER-LABEL-TYPE_RATING-ABOVE-FOUR-POINT-NINE'
    | 'PRO-SELLER-LABEL-TYPE_HIGH-REPURCHASE-RATE'
    | 'PRO-SELLER-INFO_LABEL-TYPE_ON-DISCOUNT'
  )[];
  /**
   * 가입 날짜 시작일 (Gte)
   * @example "2024-04-05T04:24:25.966Z"
   */
  gteOfficiallyEnteredDate?: string;
  /**
   * default: 20
   * @example 10
   */
  limit?: number;
  /** @example 0 */
  offset?: number;
  /** 상점 정보 키워드 필터 - list 에 있는 값 or 조건 */
  orConditionProSellerInfoKeywords?: (
    | 'PROSELLER-INFO_KEYWORDS-TYPE_VINTAGE'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_BASIC'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_CLASSIC'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_FUNKY'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_CASUAL'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_STREET'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_FEMININE'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_SPORTY'
    | 'PROSELLER-INFO_KEYWORDS-TYPE_MILITARY'
  )[];
  /** 프로셀러 정렬 필드 (officiallyEnteredDate: 입점 날짜 기준) */
  proSellerOrderField?: 'officiallyEnteredDate';
  /** @example 1668080178342 */
  searchTimestamp: number;
  /**
   * default: desc
   * @example "desc"
   */
  sortOrder?: 'asc' | 'desc';
  withInVisibleProSeller?: boolean;
}

export interface WishlistListParams {
  /** @example 10 */
  limit?: number;
  /** @example 0 */
  offset?: number;
}

export interface NewMarketItemListParams {
  /** @example 10 */
  limit?: number;
  /** @example 0 */
  offset?: number;
}

export namespace Chats {
  /**
   * @description 사용자가 참여한 채팅방 목록을 최신 채팅순으로 조회합니다.
   * @tags Chat
   * @name RoomsList
   * @summary 채팅방 목록 조회 ✅
   * @request GET:/chats/rooms
   * @secure
   * @response `200` `DomainListChatRoomsResponse` 채팅방 목록 조회 성공
   */
  export namespace RoomsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 채팅방 키
       * @example "ITEM-12345"
       */
      chatRoomKey?: string;
      /**
       * 채팅방 타입
       * @example "CHAT_ROOM_TYPE_ITEM"
       */
      chatRoomType?: 'CHAT_ROOM-TYPE_NORMAL-SELLER-MARKET-ITEM' | 'CHAT_ROOM-TYPE_PROSELLER';
      /** @example "00000000010000000015" */
      cursor?: string;
      /** @example 30 */
      limit: number;
      /**
       * 채팅방에 채팅이 있는 경우만 조회
       * @example true
       */
      notEmptyOnly?: boolean;
      /**
       * 조회할 채팅방 ID 목록
       * @example [1,2,3]
       */
      roomID?: number[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListChatRoomsResponse;
  }

  /**
   * @description 새로운 채팅방을 생성합니다. 동일한 조건의 채팅방이 이미 있을 경우, 생성하지 않고 활성화한 이후 ID를 반환합니다.
   * @tags Chat
   * @name RoomsCreate
   * @summary 채팅방 생성 ✅
   * @request POST:/chats/rooms
   * @secure
   * @response `200` `DomainCreateChatRoomResponse` 채팅방 생성 성공
   */
  export namespace RoomsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCreateChatRoomRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateChatRoomResponse;
  }

  /**
   * @description 특정 채팅방의 채팅 목록을 최신순으로 조회합니다.
   * @tags Chat
   * @name RoomsChatsList
   * @summary 채팅 목록 조회 ✅
   * @request GET:/chats/rooms/{roomID}/chats
   * @secure
   * @response `200` `DomainListChatsResponse` 채팅 목록 조회 성공
   */
  export namespace RoomsChatsList {
    export type RequestParams = {
      /**
       * 채팅방 ID
       * @example 1
       */
      roomId: number;
    };
    export type RequestQuery = {
      /** @example "00000000010000000015" */
      cursor?: string;
      /** @example 30 */
      limit: number;
      /**
       * 읽음표시도 동시에 진행하기
       * @example true
       */
      withSeenMark?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListChatsResponse;
  }

  /**
   * @description 특정 채팅방에 새로운 채팅을 생성합니다
   * @tags Chat
   * @name RoomsChatsCreate
   * @summary 채팅 생성 ✅
   * @request POST:/chats/rooms/{roomID}/chats
   * @secure
   * @response `200` `DomainCreateChatResponse` 채팅 생성 성공
   */
  export namespace RoomsChatsCreate {
    export type RequestParams = {
      /**
       * 채팅방 ID
       * @example 1
       */
      roomId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateChatRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateChatResponse;
  }

  /**
   * @description 사용자가 채팅방에서 나갑니다. 이전 메세지를 비활성화하기 때문에 재진입해도 이전의 채팅은 보이지 않습니다.
   * @tags Chat
   * @name RoomsExitCreate
   * @summary 채팅방 나가기 ✅
   * @request POST:/chats/rooms/{roomID}/exit
   * @secure
   * @response `200` `DomainExitChatRoomResponse` 채팅방 나가기 성공
   */
  export namespace RoomsExitCreate {
    export type RequestParams = {
      /**
       * 채팅방 ID
       * @example 1
       */
      roomId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainExitChatRoomResponse;
  }

  /**
   * @description 특정 채팅방에서 사용자가 읽지 않은 메시지 개수를 조회합니다
   * @tags Chat
   * @name RoomsUnreadChatCountList
   * @summary CountUnreadChatsInRoom - 특정 채팅방의 안읽은 메시지 개수 조회 ✅
   * @request GET:/chats/rooms/{roomID}/unread-chat-count
   * @secure
   * @response `200` `DomainCountUnreadChatsInRoomResponse` 특정 채팅방의 안읽은 메시지 개수 조회 성공
   */
  export namespace RoomsUnreadChatCountList {
    export type RequestParams = {
      /**
       * 채팅방 ID
       * @example 1
       */
      roomId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCountUnreadChatsInRoomResponse;
  }

  /**
   * @description 내가 읽지 않은 채팅 수를 조회합니다
   * @tags Chat
   * @name UnreadChatCountList
   * @summary CountUnreadChats - 내가 읽지 않은 채팅 수 조회 ✅
   * @request GET:/chats/unread-chat-count
   * @secure
   * @response `200` `DomainCountUnreadChatsResponse` 읽지 않은 채팅 수 조회 성공
   */
  export namespace UnreadChatCountList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCountUnreadChatsResponse;
  }
}

export namespace File {
  /**
   * No description
   * @tags File
   * @name PresignedCreate
   * @summary CreatePresignedUrl
   * @request POST:/file/presigned
   * @secure
   * @response `200` `DomainCreatePresignedUrlResponse` presigned url 생성 반환값
   */
  export namespace PresignedCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCreatePresignedUrlRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreatePresignedUrlResponse;
  }
}

export namespace MarketItems {
  /**
   * @description 중고 (단건) 생성
   * @tags Markets
   * @name MarketItemsCreate
   * @summary CreateMarketItem
   * @request POST:/market-items
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MarketItemsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCreateMarketItemRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 중고 북마크 다건 삭제
   * @tags Markets
   * @name BookmarksDelete
   * @summary DeleteMarketItemBookmarks
   * @request DELETE:/market-items/bookmarks
   * @secure
   * @response `200` `DomainDeleteMarketItemBookmarksResponse` 중고 북마크 다건 삭제 응답값
   */
  export namespace BookmarksDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainDeleteMarketItemBookmarksRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainDeleteMarketItemBookmarksResponse;
  }

  /**
   * @description ### 채팅방에 필요한 데이터들을 조회합니다. : https://github.com/looko-corp/acloset-api/issues/530 #### 해당 API는 채팅방 리스트를 보여줄 때 사용자의 닉네임, 이미지 또는 상품의 이미지등을 보여주기 위해서 부르는 API 입니다. 샌드버드에서 관리하는 channel_url로 chatroomID를 query filter 하기를 기대하고 있습니다. --- ### QueryParam - chatroomID : 샌드버드 ID를 요청받으면 해당 값을 기준으로 필터링 (group_channel의 channel_url값을 기대) (collectionFormat": "multi") - marketItemID : 중고 ID를 요청받으면 해당 값을 기준으로 필터링 ### Authorization 헤더에 서비스 토큰을 넣어주시면 해당 유저를 기준으로 채팅방리스트를 전부 조회합니다. ### 만약 서비스 토큰이 유효하지 않은 경우 아래와 같은 에러를 내뱉습니다. - ### `[401] {AUTH_UNAUTHORIZED} - 인증에 실패하였습니다.}` Swagger 문서작성 (2022-01-11)
   * @tags Markets
   * @name ChatroomsList
   * @summary ListMarketItemChatrooms
   * @request GET:/market-items/chatrooms
   * @secure
   * @response `200` `DomainListMarketItemChatroomsResponse` 채팅방 리스트 응답 값
   */
  export namespace ChatroomsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 채팅방 ID (Sendbird 한정 : channel_url)
       * @example ["sendbird_group_channel_25108471_a1bc35f5f0d237207bc1rd343562c878fc2fd426"]
       */
      chatroomID?: string[];
      /**
       * 중고 아이템 ID
       * @example 123883
       */
      marketItemID?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemChatroomsResponse;
  }

  /**
   * @description 중고 채팅방 삭제 (marketItemID or chatroomIDs 값중 하나는 필수 값)
   * @tags Markets
   * @name ChatroomsDelete
   * @summary DeleteMarketItemChatrooms
   * @request DELETE:/market-items/chatrooms
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ChatroomsDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainDeleteMarketItemChatroomsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 구매자의 리뷰 거절
   * @tags Markets
   * @name ClaimPurchaseCreate
   * @summary ClaimPurchase
   * @request POST:/market-items/claim-purchase
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ClaimPurchaseCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainClaimPurchaseRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 중고 아이템 판매 종료
   * @tags Markets
   * @name CloseCreate
   * @summary CloseMarketItem
   * @request POST:/market-items/close
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ErrorutilErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_UPDATION_NOT_ALLOWED
   * @response `404` `ErrorutilErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
   */
  export namespace CloseCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCloseMarketItemRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 실측 사이즈 비교
   * @tags Markets
   * @name CompareSizesList
   * @summary ListMarketItemsForCompareSizes
   * @request GET:/market-items/compare-sizes
   * @secure
   * @response `200` `DomainListMarketItemsForCompareSizesResponse` 실측 사이즈 비교 응답값
   */
  export namespace CompareSizesList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 카테고리 소분류
       * @example 6252
       */
      categoryID: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemsForCompareSizesResponse;
  }

  /**
   * @description 마켓 아이템 코디 목록 조회
   * @tags Markets
   * @name CoordinatesList
   * @summary ListMarketItemCoordinates
   * @request GET:/market-items/coordinates
   * @secure
   * @response `200` `DomainListMarketItemCoordinatesResponse` 마켓 아이템 코디 목록 조회 응답값
   */
  export namespace CoordinatesList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 코디 IDs
       * @example [1,2,3,4,5]
       */
      coordinateIDs?: number[];
      /** @example 30 */
      limit: number;
      /** @example 1 */
      nextCursor?: number;
      /** @example 0 */
      offset: number;
      /**
       * 섹션 Keys
       * @example [12312144554654]
       */
      sectionKeys?: number[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemCoordinatesResponse;
  }

  /**
   * @description 중고 리스트 조회
   * @tags Markets
   * @name DetailList
   * @summary ListMarketItemDetails
   * @request GET:/market-items/detail
   * @secure
   * @response `200` `DomainListMarketItemDetailsResponse` 중고 리스트 응답 값
   */
  export namespace DetailList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 중고 아이템 ID
       * @example [1,2,3]
       */
      marketItemIDs: number[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemDetailsResponse;
  }

  /**
   * No description
   * @tags Markets
   * @name FilterList
   * @summary ListFilterMarketItemCounts
   * @request GET:/market-items/filter
   * @secure
   * @response `200` `DomainListFilterMarketItemCountsResponse` 주간 마켓아이템 갯수
   */
  export namespace FilterList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @example 1 */
      bottomTotalLengthMax?: number;
      /** @example 1 */
      bottomTotalLengthMin?: number;
      /** @example 1 */
      bottomWaistMax?: number;
      /** @example 1 */
      bottomWaistMin?: number;
      /**
       * 포함할 브랜드
       * @example ["NIKE","ADIDAS"]
       */
      brandNames?: string[];
      brandTagIDs?: number[];
      /** @example 1 */
      buyerID?: number;
      /**
       * 포함할 카테고리 ID
       * @example [1,2,3]
       */
      categoryIDs?: number[];
      /**
       * 포함할 컬러 ID
       * @example [1,2,3]
       */
      colorIDs?: number[];
      /**
       * 생성일 끝 - 예전에 개발한거라 unixmilli로 받음
       * @example 1668080178342
       */
      createDateEnd?: number;
      /**
       * 생성일 시작 - 예전에 개발한거라 unixmilli로 받음
       * @example 1668080178342
       */
      createDateStart?: number;
      /** 브랜드는 종류가 너무 많아서 특정 Group by 하면 로드가 부담되어 현재 페이지 브랜드만 Group by */
      currentPageOfficialBrandIDs?: number[];
      /**
       * 최대 가격
       * @example 100000
       */
      discountPriceMax?: number;
      /**
       * 최소 가격 (최소 가격 0 이상)
       * @example 10000
       */
      discountPriceMin?: number;
      /**
       * 할인 가격 수정일 끝
       * @example "2024-04-05T04:24:25.966Z"
       */
      discountPriceModifyDateEnd?: string;
      /**
       * 할인 가격 수정일 시작
       * @example "2024-04-05T04:24:25.966Z"
       */
      discountPriceModifyDateStart?: string;
      /**
       * 최대 할인율
       * @example 50
       */
      discountRateMax?: number;
      /**
       * 최소 할인율 (최소 할인율 0 이상)
       * @example 10
       */
      discountRateMin?: number;
      /**
       * 포함할 소재
       * @example ["MARKET-ITEM_FABRIC_COTTON"]
       */
      fabrics?: (
        | 'MARKET-ITEM_FABRIC_COTTON'
        | 'MARKET-ITEM_FABRIC_COTTON100'
        | 'MARKET-ITEM_FABRIC_WOOL'
        | 'MARKET-ITEM_FABRIC_WOOL100'
        | 'MARKET-ITEM_FABRIC_NYLON'
        | 'MARKET-ITEM_FABRIC_RAYON'
        | 'MARKET-ITEM_FABRIC_ACRYLIC'
        | 'MARKET-ITEM_FABRIC_ACRYLIC100'
        | 'MARKET-ITEM_FABRIC_POLYESTER'
        | 'MARKET-ITEM_FABRIC_POLYESTER100'
        | 'MARKET-ITEM_FABRIC_ANGORA'
        | 'MARKET-ITEM_FABRIC_ANGORA100'
        | 'MARKET-ITEM_FABRIC_SILK'
        | 'MARKET-ITEM_FABRIC_SILK100'
        | 'MARKET-ITEM_FABRIC_CASHMERE'
        | 'MARKET-ITEM_FABRIC_CASHMERE100'
        | 'MARKET-ITEM_FABRIC_LINEN'
        | 'MARKET-ITEM_FABRIC_MOHAIR'
        | 'MARKET-ITEM_FABRIC_ALPACA'
        | 'MARKET-ITEM_FABRIC_ALPACA100'
        | 'MARKET-ITEM_FABRIC_POLYURETHANE'
        | 'MARKET-ITEM_FABRIC_TRIACETATE'
        | 'MARKET-ITEM_FABRIC_ACETATE'
        | 'MARKET-ITEM_FABRIC_DENIM'
        | 'MARKET-ITEM_FABRIC_CORDUROY'
        | 'MARKET-ITEM_FABRIC_LEATHER'
        | 'MARKET-ITEM_FABRIC_SUEDE'
        | 'MARKET-ITEM_FABRIC_VISCOSE'
        | 'MARKET-ITEM_FABRIC_LYOCELL'
        | 'MARKET-ITEM_FABRIC_CUPRO'
        | 'MARKET-ITEM_FABRIC_RABBITFUR'
        | 'MARKET-ITEM_FABRIC_DOWN'
        | 'MARKET-ITEM_FABRIC_DUCKDOWN'
        | 'MARKET-ITEM_FABRIC_GOOSEDOWN'
        | 'MARKET-ITEM_FABRIC_COWLEATHER'
        | 'MARKET-ITEM_FABRIC_LAMBLEATHER'
        | 'MARKET-ITEM_FABRIC_PIGLEATHER'
        | 'MARKET-ITEM_FABRIC_GENUINELEATHER'
        | 'MARKET-ITEM_FABRIC_SYNTHETICLEATHER'
        | 'MARKET-ITEM_FABRIC_METAL'
        | 'MARKET-ITEM_FABRIC_VELVET'
        | 'MARKET-ITEM_FABRIC_UNKNOWN'
      )[];
      /**
       * 포함할 성별
       * @example "MARKET-ITEM_GENDERWEAR_MEN"
       */
      genderWear?:
        | 'MARKET-ITEM_GENDERWEAR_WOMEN'
        | 'MARKET-ITEM_GENDERWEAR_MEN'
        | 'MARKET-ITEM_GENDERWEAR_GIRL'
        | 'MARKET-ITEM_GENDERWEAR_BOY'
        | 'MARKET-ITEM_GENDERWEAR_UNISEX'
        | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX';
      /**
       * 포함할 성별
       * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
       */
      genderWears?: (
        | 'MARKET-ITEM_GENDERWEAR_WOMEN'
        | 'MARKET-ITEM_GENDERWEAR_MEN'
        | 'MARKET-ITEM_GENDERWEAR_GIRL'
        | 'MARKET-ITEM_GENDERWEAR_BOY'
        | 'MARKET-ITEM_GENDERWEAR_UNISEX'
        | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
      )[];
      /**
       * 무료배송 여부
       * @example true
       */
      isFreeShipping?: boolean;
      /** 포함할 소재 ID */
      materialIDs?: number[];
      /** 포함할 공식 브랜드 - marketItem 에 저장하고 있지 않아 따로 조회하여 brandName 으로 필터링 */
      officialBrandIDs?: number[];
      /** 포함할 패턴 ID */
      patternIDs?: number[];
      /** 검색어 기반 개인화 추천 여부 */
      personalizedWithSearchKeyword?: boolean;
      /**
       * 포함할 상품 상태
       * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
       */
      qualities?: (
        | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
        | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
        | 'MARKET-ITEM_QUALITY_GOOD'
        | 'MARKET-ITEM_QUALITY_LITTLE-USE'
        | 'MARKET-ITEM_QUALITY_MANY-USE'
        | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
      )[];
      /** @example [1,2,3] */
      sellerIDs?: number[];
      /** @example 1 */
      shoeSizeMax?: number;
      /** @example 1 */
      shoeSizeMin?: number;
      /**
       * 포함할 사이즈
       * @example [1,2,3]
       */
      sizeIDs?: number[];
      /**
       * 포함할 판매 상태
       * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
       */
      statuses?: (
        | 'MARKET-ITEM_STATUS_SOLD'
        | 'MARKET-ITEM_STATUS_PROCESSING'
        | 'MARKET-ITEM_STATUS_FOR-SALE'
        | 'MARKET-ITEM_STATUS_STOP-SALE'
        | 'MARKET-ITEM_STATUS_NO-SALE'
      )[];
      /** @example "흰색 티셔츠" */
      textSearch?: string;
      /** @example 1 */
      topChestMax?: number;
      /** @example 1 */
      topChestMin?: number;
      /** @example 1 */
      topShoulderMax?: number;
      /** @example 1 */
      topShoulderMin?: number;
      /** @example 1 */
      topSleeveLengthMax?: number;
      /** @example 1 */
      topSleeveLengthMin?: number;
      /** @example 1 */
      topTotalLengthMax?: number;
      /** @example 1 */
      topTotalLengthMin?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListFilterMarketItemCountsResponse;
  }

  /**
   * @description 인기 키워드 리스트 조회
   * @tags Markets
   * @name PopularKeywordsList
   * @summary ListPopularKeywords
   * @request GET:/market-items/popular-keywords
   * @secure
   * @response `200` `DomainListPopularKeywordsResponse` 응답 값
   */
  export namespace PopularKeywordsList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPopularKeywordsResponse;
  }

  /**
   * @description 프로모션 정보 리스트 조회
   * @tags Markets
   * @name PromotionInfosList
   * @summary ListPromotionInfos 프로모션 정보 리스트 조회
   * @request GET:/market-items/promotion-infos
   * @secure
   * @response `200` `DomainListPromotionInfosResponse` 프로모션 정보 리스트 응답 값
   */
  export namespace PromotionInfosList {
    export type RequestParams = {};
    export type RequestQuery = {
      creationType?: 'BANNER' | 'POPUP';
      /** 노출 여부 */
      isVisible?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPromotionInfosResponse;
  }

  /**
   * @description 번장 불러오기 상품 실시간 크롤링 (동시에 한 셀러만 가능합니다.)
   * @tags Markets
   * @name RealtimeBunjangCrawlingCreate
   * @summary RealtimeBunjangCrawling
   * @request POST:/market-items/realtime-bunjang-crawling
   * @secure
   * @response `200` `DomainRealtimeBunjangCrawlingResponse` OK
   */
  export namespace RealtimeBunjangCrawlingCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainRealtimeBunjangCrawlingRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainRealtimeBunjangCrawlingResponse;
  }

  /**
   * @description 조회한 결과로 나온 마켓아이템의 판매자가 내가 차단한 사용자라면, 해당 마켓아이템은 제외합니다. 추가적으로 hasNext 필드를 추가하여, 다음 페이지가 있는지 없는지를 알려줍니다. 최대 150개 까지만 조회할 수 있습니다. 최근 본 마켓아이템 리스트 조회, 작동확인 (없으면 빈 리스트)
   * @tags Markets
   * @name RecentlyViewedList
   * @summary ListRecentlyViewedMarketItems
   * @request GET:/market-items/recently-viewed
   * @secure
   * @response `200` `DomainListRecentlyViewedMarketItemsResponse` 최근 본 마켓아이템 응답값
   */
  export namespace RecentlyViewedList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 최근 본 중고 아이템 목록의 개수
       * @example 10
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListRecentlyViewedMarketItemsResponse;
  }

  /**
   * @description 추천 정보 리스트 조회
   * @tags Markets
   * @name RecommendationInfosList
   * @summary ListRecommInfos 추천 정보 리스트 조회
   * @request GET:/market-items/recommendation-infos
   * @secure
   * @response `200` `DomainListRecommInfosResponse` 중고 리스트 응답 값
   */
  export namespace RecommendationInfosList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListRecommInfosResponse;
  }

  /**
   * @description 연관 키워드 리스트 조회
   * @tags Markets
   * @name RelatedKeywordsList
   * @summary ListRelatedKeywords
   * @request GET:/market-items/related-keywords
   * @secure
   * @response `200` `DomainListRelatedKeywordsResponse` 중고 리뷰 리스트 응답 값
   */
  export namespace RelatedKeywordsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @example "나이키" */
      keyword: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListRelatedKeywordsResponse;
  }

  /**
   * @description 실시간 리뷰 리스트
   * @tags Markets
   * @name ReviewsRealtimeList
   * @summary ListMarketItemRealtimeReviews
   * @request GET:/market-items/reviews/realtime
   * @secure
   * @response `200` `DomainListMarketItemRealtimeReviewsResponse` 실시간 리뷰 리스트 응답값
   */
  export namespace ReviewsRealtimeList {
    export type RequestParams = {};
    export type RequestQuery = {
      sellerID?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemRealtimeReviewsResponse;
  }

  /**
   * @description 중고 리뷰 단건 조회, 작동확인
   * @tags Markets
   * @name ReviewsDetail
   * @summary GetMarketItemReviewV2
   * @request GET:/market-items/reviews/{reviewID}
   * @secure
   * @response `200` `DomainGetMarketItemReviewResponse` 중고 리뷰 조회 반환 값
   */
  export namespace ReviewsDetail {
    export type RequestParams = {
      /**
       * 조회할 중고 리뷰 ID
       * @example 26124
       */
      reviewId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetMarketItemReviewResponse;
  }

  /**
   * @description 현재 유효한 포인트 정책
   * @tags Markets
   * @name RewardPointPolicyList
   * @summary 포인트 정책
   * @request GET:/market-items/reward-point-policy
   * @secure
   * @response `200` `DomainGetRewardPointPolicyResponse` 포인트 정책 값
   */
  export namespace RewardPointPolicyList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 중고 상품 ID
       * @example 1
       */
      marketItemID?: number;
      /**
       * 주문 상품 ID
       * @example 1
       */
      orderItemID?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetRewardPointPolicyResponse;
  }

  /**
   * @description 유사 이미지 상품 추천
   * @tags Markets
   * @name SimilarImageItemsList
   * @summary ListSimilarImageMarketItems ✅
   * @request GET:/market-items/similar-image-items
   * @secure
   * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
   */
  export namespace SimilarImageItemsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @example 1 */
      bottomTotalLengthMax?: number;
      /** @example 1 */
      bottomTotalLengthMin?: number;
      /** @example 1 */
      bottomWaistMax?: number;
      /** @example 1 */
      bottomWaistMin?: number;
      /**
       * 포함할 브랜드
       * @example ["NIKE","ADIDAS"]
       */
      brandNames?: string[];
      /** 포함할 브랜드 태그 IDs */
      brandTagIDs?: number[];
      /**
       * 카테고리 ID
       * @example 1
       */
      categoryID?: number;
      /**
       * 필터 조건
       * @example 100000
       */
      discountPriceMax?: number;
      /**
       * 최소 가격 (최소 가격 0 이상)
       * @example 10000
       */
      discountPriceMin?: number;
      /**
       * 유사 이미지 URL
       * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
       */
      imageURL?: string;
      /**
       * 반환할 데이터의 수
       * @example 30
       */
      limit: number;
      nextCursor?: string;
      /**
       * 포함할 공식 브랜드 IDs
       * @example [82]
       */
      officialBrandIDs?: number[];
      /** @example 1 */
      shoeSizeMax?: number;
      /** @example 1 */
      shoeSizeMin?: number;
      /**
       * 충족해야할 최소 유사도
       * @example 1.3
       */
      similarity?: number;
      /**
       * 포함할 판매 상태
       * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
       */
      statuses?: (
        | 'MARKET-ITEM_STATUS_SOLD'
        | 'MARKET-ITEM_STATUS_PROCESSING'
        | 'MARKET-ITEM_STATUS_FOR-SALE'
        | 'MARKET-ITEM_STATUS_STOP-SALE'
        | 'MARKET-ITEM_STATUS_NO-SALE'
      )[];
      /** @example 1 */
      topChestMax?: number;
      /** @example 1 */
      topChestMin?: number;
      /** @example 1 */
      topShoulderMax?: number;
      /** @example 1 */
      topShoulderMin?: number;
      /** @example 1 */
      topSleeveLengthMax?: number;
      /** @example 1 */
      topSleeveLengthMin?: number;
      /** @example 1 */
      topTotalLengthMax?: number;
      /** @example 1 */
      topTotalLengthMin?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemsResponse;
  }

  /**
   * No description
   * @tags Markets
   * @name WeeklyCountList
   * @summary CountWeeklyMarketItem
   * @request GET:/market-items/weekly-count
   * @secure
   * @response `200` `DomainCountWeeklyMarketItemResponse` 주간 마켓아이템 갯수
   */
  export namespace WeeklyCountList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCountWeeklyMarketItemResponse;
  }

  /**
   * @description 중고 단건 조회, 작동확인
   * @tags Markets
   * @name MarketItemsDetail
   * @summary GetMarketItem
   * @request GET:/market-items/{marketItemID}
   * @secure
   * @response `200` `DomainGetMarketItemResponse` 중고 단건 응답값
   */
  export namespace MarketItemsDetail {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /**
       * 가격변동 이력 조회 종료일
       * @example "2024-04-05T04:24:25.966Z"
       */
      marketItemPriceHistoryEndDate?: string;
      /**
       * 가격변동 이력 조회 시작일
       * @example "2024-04-05T04:24:25.966Z"
       */
      marketItemPriceHistoryStartDate?: string;
      /** 마켓아이템 조회수 업데이트 여부 */
      skipUpdateView?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetMarketItemResponse;
  }

  /**
   * @description 중고(단건) 삭제
   * @tags Markets
   * @name MarketItemsDelete
   * @summary DeleteMarketItem
   * @request DELETE:/market-items/{marketItemID}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ErrorutilErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_DELETION_NOT_ALLOWED
   * @response `404` `ErrorutilErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
   */
  export namespace MarketItemsDelete {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 26124
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 중고(단건) 갱신
   * @tags Markets
   * @name MarketItemsPartialUpdate
   * @summary PatchMarketItem
   * @request PATCH:/market-items/{marketItemID}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ErrorutilErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_UPDATION_NOT_ALLOWED
   * @response `404` `ErrorutilErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
   */
  export namespace MarketItemsPartialUpdate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 2515
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchMarketItemRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 중고 마켓아이템 판매중변경
   * @tags Markets
   * @name AsProcessingPartialUpdate
   * @summary PatchMarketItemAsProcessing
   * @request PATCH:/market-items/{marketItemID}/as-processing
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ErrorutilErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: TX_DUPLICATED<br />마켓 아이템이 판매중이 아닐때 Code: MARKET_ITEM_NOT_FOR_SALE
   * @response `404` `ErrorutilErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
   */
  export namespace AsProcessingPartialUpdate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 2515
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 중고 마켓아이템 판매중으로 변경
   * @tags Markets
   * @name AsSellingPartialUpdate
   * @summary PatchMarketItemAsSelling
   * @request PATCH:/market-items/{marketItemID}/as-selling
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ErrorutilErrorResponse` 마켓 아이템 상태가 Processing가 아닐때 Code: MARKET_ITEM_NOT_PROCESSING
   * @response `404` `ErrorutilErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
   */
  export namespace AsSellingPartialUpdate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 2515
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchMarketItemAsSellingRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 중고 북마크 생성
   * @tags Markets
   * @name BookmarksCreate
   * @summary CreateMarketItemBookmark
   * @request POST:/market-items/{marketItemID}/bookmarks
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BookmarksCreate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 26124
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 중고 북마크 삭제
   * @tags Markets
   * @name BookmarksDelete2
   * @summary DeleteMarketItemBookmark
   * @request DELETE:/market-items/{marketItemID}/bookmarks
   * @originalName bookmarksDelete
   * @duplicate
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BookmarksDelete2 {
    export type RequestParams = {
      /** 중고 ID */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 중고 채팅방 생성, mSwagger 문서작성 (2023-01-19)
   * @tags Markets
   * @name ChatroomsCreate
   * @summary CreateMarketItemChatroom
   * @request POST:/market-items/{marketItemID}/chatrooms
   * @secure
   * @response `200` `DomainCreateMarketItemChatroomResponse` 중고 채팅방 생성 응답 값
   */
  export namespace ChatroomsCreate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 26124
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateMarketItemChatroomRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateMarketItemChatroomResponse;
  }

  /**
   * No description
   * @tags Markets
   * @name EditableList
   * @summary GetMarketItemEditable
   * @request GET:/market-items/{marketItemID}/editable
   * @secure
   * @response `200` `DomainGetMarketItemEditableResponse` 삭제 수정 가능 여부 응답값
   */
  export namespace EditableList {
    export type RequestParams = {
      marketItemId: string;
    };
    export type RequestQuery = {
      marketItemID?: number;
      /** @example "EDIT,DELETE,CLOSE" */
      type?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetMarketItemEditableResponse;
  }

  /**
   * @description 중고 리뷰 생성
   * @tags Markets
   * @name ReviewsCreate
   * @summary CreateMarketItemReview
   * @request POST:/market-items/{marketItemID}/reviews
   * @secure
   * @response `200` `DomainCreateMarketItemReviewResponse` 중고 리뷰 생성 응답값
   */
  export namespace ReviewsCreate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 26124
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateMarketItemReviewRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateMarketItemReviewResponse;
  }

  /**
   * @description 중고 리뷰 단건 조회, 작동확인
   * @tags Markets
   * @name ReviewsDetail2
   * @summary GetMarketItemReview
   * @request GET:/market-items/{marketItemID}/reviews/{reviewID}
   * @originalName reviewsDetail
   * @duplicate
   * @secure
   * @response `200` `DomainGetMarketItemReviewResponse` 중고 리뷰 조회 반환 값
   */
  export namespace ReviewsDetail2 {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 26124
       */
      marketItemId: number;
      /**
       * 조회할 중고 리뷰 ID
       * @example 26124
       */
      reviewId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetMarketItemReviewResponse;
  }

  /**
   * @description 중고 리뷰 수정
   * @tags Markets
   * @name ReviewsUpdate
   * @summary UpdateMarketItemReview ✅
   * @request PUT:/market-items/{marketItemID}/reviews/{reviewID}
   * @secure
   * @response `204` `void` 중고 리뷰 수정 성공
   */
  export namespace ReviewsUpdate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 26124
       */
      marketItemId: number;
      reviewId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateMarketItemReviewRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description 비슷한 상품 추천
   * @tags Markets
   * @name SellersOtherItemsList
   * @summary ListSellersOtherMarketItems
   * @request GET:/market-items/{marketItemID}/sellers-other-items
   * @secure
   * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
   */
  export namespace SellersOtherItemsList {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /** @example 30 */
      limit: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemsResponse;
  }

  /**
   * @description 비슷한 상품 추천
   * @tags Markets
   * @name SimilarBrandItemsList
   * @summary ListSimilarBrandMarketItems
   * @request GET:/market-items/{marketItemID}/similar-brand-items
   * @secure
   * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
   */
  export namespace SimilarBrandItemsList {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /** @example 30 */
      limit: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemsResponse;
  }

  /**
   * @description 소재 상품 모음전
   * @tags Markets
   * @name SimilarFabricItemsList
   * @summary ListSimilarFabricMarketItems
   * @request GET:/market-items/{marketItemID}/similar-fabric-items
   * @secure
   * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
   */
  export namespace SimilarFabricItemsList {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /** @example 30 */
      limit: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemsResponse;
  }

  /**
   * @description 유사 이미지 상품 추천
   * @tags Markets
   * @name SimilarImageItemsList2
   * @summary ListSimilarImageMarketItems ✅
   * @request GET:/market-items/{marketItemID}/similar-image-items
   * @originalName similarImageItemsList
   * @duplicate
   * @secure
   * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
   */
  export namespace SimilarImageItemsList2 {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /** @example 1 */
      bottomTotalLengthMax?: number;
      /** @example 1 */
      bottomTotalLengthMin?: number;
      /** @example 1 */
      bottomWaistMax?: number;
      /** @example 1 */
      bottomWaistMin?: number;
      /**
       * 포함할 브랜드
       * @example ["NIKE","ADIDAS"]
       */
      brandNames?: string[];
      /** 포함할 브랜드 태그 IDs */
      brandTagIDs?: number[];
      /**
       * 카테고리 ID
       * @example 1
       */
      categoryID?: number;
      /**
       * 필터 조건
       * @example 100000
       */
      discountPriceMax?: number;
      /**
       * 최소 가격 (최소 가격 0 이상)
       * @example 10000
       */
      discountPriceMin?: number;
      /**
       * 유사 이미지 URL
       * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
       */
      imageURL?: string;
      /**
       * 반환할 데이터의 수
       * @example 30
       */
      limit: number;
      nextCursor?: string;
      /**
       * 포함할 공식 브랜드 IDs
       * @example [82]
       */
      officialBrandIDs?: number[];
      /** @example 1 */
      shoeSizeMax?: number;
      /** @example 1 */
      shoeSizeMin?: number;
      /**
       * 충족해야할 최소 유사도
       * @example 1.3
       */
      similarity?: number;
      /**
       * 포함할 판매 상태
       * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
       */
      statuses?: (
        | 'MARKET-ITEM_STATUS_SOLD'
        | 'MARKET-ITEM_STATUS_PROCESSING'
        | 'MARKET-ITEM_STATUS_FOR-SALE'
        | 'MARKET-ITEM_STATUS_STOP-SALE'
        | 'MARKET-ITEM_STATUS_NO-SALE'
      )[];
      /** @example 1 */
      topChestMax?: number;
      /** @example 1 */
      topChestMin?: number;
      /** @example 1 */
      topShoulderMax?: number;
      /** @example 1 */
      topShoulderMin?: number;
      /** @example 1 */
      topSleeveLengthMax?: number;
      /** @example 1 */
      topSleeveLengthMin?: number;
      /** @example 1 */
      topTotalLengthMax?: number;
      /** @example 1 */
      topTotalLengthMin?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemsResponse;
  }

  /**
   * @description 비슷한 상품 추천
   * @tags Markets
   * @name SimilarItemsList
   * @summary ListSimilarMarketItems
   * @request GET:/market-items/{marketItemID}/similar-items
   * @secure
   * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
   */
  export namespace SimilarItemsList {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /** @example 30 */
      limit: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemsResponse;
  }

  /**
   * No description
   * @tags Orders
   * @name TransactionsList
   * @summary GetOrderRecently
   * @request GET:/market-items/{marketItemID}/transactions
   * @secure
   * @response `200` `DomainGetOrderResponse` 거래 상세 조회 응답값
   * @response `404` `ErrorutilErrorResponse` 거래가 존재하지 않을 경우 Code: TX_NOT_FOUND
   */
  export namespace TransactionsList {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /** @example 1 */
      buyerID?: number;
      /** @example 1 */
      sellerID?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetOrderResponse;
  }

  /**
   * @description 중고 아이템 조회수 증가
   * @tags Markets
   * @name ViewCreate
   * @summary CreateMarketItemView
   * @request POST:/market-items/{marketItemID}/view
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ViewCreate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Sendbird {
  /**
   * @description Swagger 문서작성 (2022-01-11) ### 특정 유저의 샌드버드 토큰을 조회합니다. : https://github.com/looko-corp/acloset-api/issues/511 --- ### Authorization 헤더에 서비스 토큰을 넣어주시면 샌드버드 토큰을 반환합니다. ### 만약 샌드버드 계정이 없는 경우에 토큰을 요청하면 아래와 같은 에러가 발생합니다. - ### `[404] {SENDBIRD_TOKEN_NOT_FOUND - 토큰을 찾을 수 없습니다.}`
   * @tags Sendbird
   * @name TokenList
   * @summary GetSendbirdToken
   * @request GET:/sendbird/token
   * @secure
   * @response `200` `DomainGetSendbirdTokenResponse` 토큰 요청 응답 값
   */
  export namespace TokenList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetSendbirdTokenResponse;
  }

  /**
   * @description ### 특정 유저의 샌드버드 토큰을 만듭니다 : https://github.com/looko-corp/acloset-api/issues/522 --- ### Authorization 헤더에 서비스 토큰을 요청하면 만들어 집니다. ### 만약 샌드버드 계정이 이미 있는 경우에는 아래와 같은 에러가 발생합니다. - ### `[409] {SENDBIRD_TOKEN_ALREADY_EXISTS - 이미 토큰이 존재합니다}` Swagger 문서작성 (2022-01-11)
   * @tags Sendbird
   * @name TokenCreate
   * @summary CreateSendbirdToken
   * @request POST:/sendbird/token
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TokenCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Swagger 문서작성 (2022-01-11) ### 특정유저의 샌드버드 채팅에서 안읽은 메세지수 조회 : https://github.com/looko-corp/acloset-api/issues/528 --- ### Authorization 헤더에 서비스 토큰을 요청하면 만들어 집니다. ### 만약 샌드버드 계정이 없는 경우에 토큰을 요청하면 아래와 같은 에러가 발생합니다. - ### `[404] {SENDBIRD_TOKEN_NOT_FOUND - 토큰을 찾을 수 없습니다.}`
   * @tags Sendbird
   * @name UnreadMessageCountList
   * @summary CountSendbirdUnreadMessage
   * @request GET:/sendbird/unread-message-count
   * @secure
   * @response `200` `DomainCountSendbirdUnreadMessageResponse` 안읽은 메세지 개수 응답 값
   */
  export namespace UnreadMessageCountList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCountSendbirdUnreadMessageResponse;
  }
}

export namespace UserProfile {
  /**
   * @description https://github.com/looko-corp/acloset-api/issues/205 - 개발 완료
   * @tags Users
   * @name UserProfileList
   * @summary GetUserProfile (4.7.0)
   * @request GET:/user-profile
   * @secure
   * @response `200` `DomainGetUserProfileResponse` 유저 프로필 응답값
   */
  export namespace UserProfileList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 할인 가격 수정 종료 날짜
       * @example "2024-04-05T04:24:25.966Z"
       */
      discountPriceModifyDateEnd?: string;
      /**
       * 할인 가격 수정 시작 날짜
       * @example "2024-04-05T04:24:25.966Z"
       */
      discountPriceModifyDateStart?: string;
      /** 프로필 조회할 유저 닉네임 */
      nickname?: string;
      /** 프로필 조회할 유저 아이디 */
      userID?: number;
      /** 프로셀러 정보 조회 여부 */
      withProSellerInfo?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetUserProfileResponse;
  }
}

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),

        // NOTE: FormData 타입 수정(https://github.com/acacode/swagger-typescript-api/issues/671)
        ...{ 'Content-Type': type },
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title No title
 * @contact
 */
export class SwaggerApi<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  chats = {
    /**
     * @description 사용자가 참여한 채팅방 목록을 최신 채팅순으로 조회합니다.
     *
     * @tags Chat
     * @name RoomsList
     * @summary 채팅방 목록 조회 ✅
     * @request GET:/chats/rooms
     * @secure
     * @response `200` `DomainListChatRoomsResponse` 채팅방 목록 조회 성공
     */
    roomsList: (query: RoomsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListChatRoomsResponse, any>({
        path: `/chats/rooms`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 새로운 채팅방을 생성합니다. 동일한 조건의 채팅방이 이미 있을 경우, 생성하지 않고 활성화한 이후 ID를 반환합니다.
     *
     * @tags Chat
     * @name RoomsCreate
     * @summary 채팅방 생성 ✅
     * @request POST:/chats/rooms
     * @secure
     * @response `200` `DomainCreateChatRoomResponse` 채팅방 생성 성공
     */
    roomsCreate: (CreateChatRoomRequest: DomainCreateChatRoomRequest, params: RequestParams = {}) =>
      this.http.request<DomainCreateChatRoomResponse, any>({
        path: `/chats/rooms`,
        method: 'POST',
        body: CreateChatRoomRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 특정 채팅방의 채팅 목록을 최신순으로 조회합니다.
     *
     * @tags Chat
     * @name RoomsChatsList
     * @summary 채팅 목록 조회 ✅
     * @request GET:/chats/rooms/{roomID}/chats
     * @secure
     * @response `200` `DomainListChatsResponse` 채팅 목록 조회 성공
     */
    roomsChatsList: ({ roomId, ...query }: RoomsChatsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListChatsResponse, any>({
        path: `/chats/rooms/${roomId}/chats`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 특정 채팅방에 새로운 채팅을 생성합니다
     *
     * @tags Chat
     * @name RoomsChatsCreate
     * @summary 채팅 생성 ✅
     * @request POST:/chats/rooms/{roomID}/chats
     * @secure
     * @response `200` `DomainCreateChatResponse` 채팅 생성 성공
     */
    roomsChatsCreate: (roomId: number, request: DomainCreateChatRequest, params: RequestParams = {}) =>
      this.http.request<DomainCreateChatResponse, any>({
        path: `/chats/rooms/${roomId}/chats`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 사용자가 채팅방에서 나갑니다. 이전 메세지를 비활성화하기 때문에 재진입해도 이전의 채팅은 보이지 않습니다.
     *
     * @tags Chat
     * @name RoomsExitCreate
     * @summary 채팅방 나가기 ✅
     * @request POST:/chats/rooms/{roomID}/exit
     * @secure
     * @response `200` `DomainExitChatRoomResponse` 채팅방 나가기 성공
     */
    roomsExitCreate: (roomId: number, params: RequestParams = {}) =>
      this.http.request<DomainExitChatRoomResponse, any>({
        path: `/chats/rooms/${roomId}/exit`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 특정 채팅방에서 사용자가 읽지 않은 메시지 개수를 조회합니다
     *
     * @tags Chat
     * @name RoomsUnreadChatCountList
     * @summary CountUnreadChatsInRoom - 특정 채팅방의 안읽은 메시지 개수 조회 ✅
     * @request GET:/chats/rooms/{roomID}/unread-chat-count
     * @secure
     * @response `200` `DomainCountUnreadChatsInRoomResponse` 특정 채팅방의 안읽은 메시지 개수 조회 성공
     */
    roomsUnreadChatCountList: (roomId: number, params: RequestParams = {}) =>
      this.http.request<DomainCountUnreadChatsInRoomResponse, any>({
        path: `/chats/rooms/${roomId}/unread-chat-count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 내가 읽지 않은 채팅 수를 조회합니다
     *
     * @tags Chat
     * @name UnreadChatCountList
     * @summary CountUnreadChats - 내가 읽지 않은 채팅 수 조회 ✅
     * @request GET:/chats/unread-chat-count
     * @secure
     * @response `200` `DomainCountUnreadChatsResponse` 읽지 않은 채팅 수 조회 성공
     */
    unreadChatCountList: (params: RequestParams = {}) =>
      this.http.request<DomainCountUnreadChatsResponse, any>({
        path: `/chats/unread-chat-count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  file = {
    /**
     * No description
     *
     * @tags File
     * @name PresignedCreate
     * @summary CreatePresignedUrl
     * @request POST:/file/presigned
     * @secure
     * @response `200` `DomainCreatePresignedUrlResponse` presigned url 생성 반환값
     */
    presignedCreate: (CreatePresignedUrlRequest: DomainCreatePresignedUrlRequest, params: RequestParams = {}) =>
      this.http.request<DomainCreatePresignedUrlResponse, any>({
        path: `/file/presigned`,
        method: 'POST',
        body: CreatePresignedUrlRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  marketItems = {
    /**
     * @description 중고 (단건) 생성
     *
     * @tags Markets
     * @name MarketItemsCreate
     * @summary CreateMarketItem
     * @request POST:/market-items
     * @secure
     * @response `204` `void` No Content
     */
    marketItemsCreate: (CreateMarketItemRequest: DomainCreateMarketItemRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/market-items`,
        method: 'POST',
        body: CreateMarketItemRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 중고 북마크 다건 삭제
     *
     * @tags Markets
     * @name BookmarksDelete
     * @summary DeleteMarketItemBookmarks
     * @request DELETE:/market-items/bookmarks
     * @secure
     * @response `200` `DomainDeleteMarketItemBookmarksResponse` 중고 북마크 다건 삭제 응답값
     */
    bookmarksDelete: (
      DeleteMarketItemBookmarksRequest: DomainDeleteMarketItemBookmarksRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainDeleteMarketItemBookmarksResponse, any>({
        path: `/market-items/bookmarks`,
        method: 'DELETE',
        body: DeleteMarketItemBookmarksRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ### 채팅방에 필요한 데이터들을 조회합니다. : https://github.com/looko-corp/acloset-api/issues/530 #### 해당 API는 채팅방 리스트를 보여줄 때 사용자의 닉네임, 이미지 또는 상품의 이미지등을 보여주기 위해서 부르는 API 입니다. 샌드버드에서 관리하는 channel_url로 chatroomID를 query filter 하기를 기대하고 있습니다. --- ### QueryParam - chatroomID : 샌드버드 ID를 요청받으면 해당 값을 기준으로 필터링 (group_channel의 channel_url값을 기대) (collectionFormat": "multi") - marketItemID : 중고 ID를 요청받으면 해당 값을 기준으로 필터링 ### Authorization 헤더에 서비스 토큰을 넣어주시면 해당 유저를 기준으로 채팅방리스트를 전부 조회합니다. ### 만약 서비스 토큰이 유효하지 않은 경우 아래와 같은 에러를 내뱉습니다. - ### `[401] {AUTH_UNAUTHORIZED} - 인증에 실패하였습니다.}` Swagger 문서작성 (2022-01-11)
     *
     * @tags Markets
     * @name ChatroomsList
     * @summary ListMarketItemChatrooms
     * @request GET:/market-items/chatrooms
     * @secure
     * @response `200` `DomainListMarketItemChatroomsResponse` 채팅방 리스트 응답 값
     */
    chatroomsList: (query: ChatroomsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListMarketItemChatroomsResponse, any>({
        path: `/market-items/chatrooms`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 채팅방 삭제 (marketItemID or chatroomIDs 값중 하나는 필수 값)
     *
     * @tags Markets
     * @name ChatroomsDelete
     * @summary DeleteMarketItemChatrooms
     * @request DELETE:/market-items/chatrooms
     * @secure
     * @response `204` `void` No Content
     */
    chatroomsDelete: (
      DeleteMarketItemChatroomsRequest: DomainDeleteMarketItemChatroomsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/market-items/chatrooms`,
        method: 'DELETE',
        body: DeleteMarketItemChatroomsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 구매자의 리뷰 거절
     *
     * @tags Markets
     * @name ClaimPurchaseCreate
     * @summary ClaimPurchase
     * @request POST:/market-items/claim-purchase
     * @secure
     * @response `204` `void` No Content
     */
    claimPurchaseCreate: (ClaimPurchaseRequest: DomainClaimPurchaseRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/market-items/claim-purchase`,
        method: 'POST',
        body: ClaimPurchaseRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 중고 아이템 판매 종료
     *
     * @tags Markets
     * @name CloseCreate
     * @summary CloseMarketItem
     * @request POST:/market-items/close
     * @secure
     * @response `204` `void` No Content
     * @response `400` `ErrorutilErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_UPDATION_NOT_ALLOWED
     * @response `404` `ErrorutilErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
     */
    closeCreate: (CloseMarketItemRequest: DomainCloseMarketItemRequest, params: RequestParams = {}) =>
      this.http.request<void, ErrorutilErrorResponse>({
        path: `/market-items/close`,
        method: 'POST',
        body: CloseMarketItemRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 실측 사이즈 비교
     *
     * @tags Markets
     * @name CompareSizesList
     * @summary ListMarketItemsForCompareSizes
     * @request GET:/market-items/compare-sizes
     * @secure
     * @response `200` `DomainListMarketItemsForCompareSizesResponse` 실측 사이즈 비교 응답값
     */
    compareSizesList: (query: CompareSizesListParams, params: RequestParams = {}) =>
      this.http.request<DomainListMarketItemsForCompareSizesResponse, any>({
        path: `/market-items/compare-sizes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 마켓 아이템 코디 목록 조회
     *
     * @tags Markets
     * @name CoordinatesList
     * @summary ListMarketItemCoordinates
     * @request GET:/market-items/coordinates
     * @secure
     * @response `200` `DomainListMarketItemCoordinatesResponse` 마켓 아이템 코디 목록 조회 응답값
     */
    coordinatesList: (query: CoordinatesListParams, params: RequestParams = {}) =>
      this.http.request<DomainListMarketItemCoordinatesResponse, any>({
        path: `/market-items/coordinates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 리스트 조회
     *
     * @tags Markets
     * @name DetailList
     * @summary ListMarketItemDetails
     * @request GET:/market-items/detail
     * @secure
     * @response `200` `DomainListMarketItemDetailsResponse` 중고 리스트 응답 값
     */
    detailList: (query: DetailListParams, params: RequestParams = {}) =>
      this.http.request<DomainListMarketItemDetailsResponse, any>({
        path: `/market-items/detail`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Markets
     * @name FilterList
     * @summary ListFilterMarketItemCounts
     * @request GET:/market-items/filter
     * @secure
     * @response `200` `DomainListFilterMarketItemCountsResponse` 주간 마켓아이템 갯수
     */
    filterList: (query: FilterListParams, params: RequestParams = {}) =>
      this.http.request<DomainListFilterMarketItemCountsResponse, any>({
        path: `/market-items/filter`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 인기 키워드 리스트 조회
     *
     * @tags Markets
     * @name PopularKeywordsList
     * @summary ListPopularKeywords
     * @request GET:/market-items/popular-keywords
     * @secure
     * @response `200` `DomainListPopularKeywordsResponse` 응답 값
     */
    popularKeywordsList: (params: RequestParams = {}) =>
      this.http.request<DomainListPopularKeywordsResponse, any>({
        path: `/market-items/popular-keywords`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 프로모션 정보 리스트 조회
     *
     * @tags Markets
     * @name PromotionInfosList
     * @summary ListPromotionInfos 프로모션 정보 리스트 조회
     * @request GET:/market-items/promotion-infos
     * @secure
     * @response `200` `DomainListPromotionInfosResponse` 프로모션 정보 리스트 응답 값
     */
    promotionInfosList: (query: PromotionInfosListParams, params: RequestParams = {}) =>
      this.http.request<DomainListPromotionInfosResponse, any>({
        path: `/market-items/promotion-infos`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 번장 불러오기 상품 실시간 크롤링 (동시에 한 셀러만 가능합니다.)
     *
     * @tags Markets
     * @name RealtimeBunjangCrawlingCreate
     * @summary RealtimeBunjangCrawling
     * @request POST:/market-items/realtime-bunjang-crawling
     * @secure
     * @response `200` `DomainRealtimeBunjangCrawlingResponse` OK
     */
    realtimeBunjangCrawlingCreate: (
      RealtimeBunjangCrawlingRequest: DomainRealtimeBunjangCrawlingRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainRealtimeBunjangCrawlingResponse, any>({
        path: `/market-items/realtime-bunjang-crawling`,
        method: 'POST',
        body: RealtimeBunjangCrawlingRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 조회한 결과로 나온 마켓아이템의 판매자가 내가 차단한 사용자라면, 해당 마켓아이템은 제외합니다. 추가적으로 hasNext 필드를 추가하여, 다음 페이지가 있는지 없는지를 알려줍니다. 최대 150개 까지만 조회할 수 있습니다. 최근 본 마켓아이템 리스트 조회, 작동확인 (없으면 빈 리스트)
     *
     * @tags Markets
     * @name RecentlyViewedList
     * @summary ListRecentlyViewedMarketItems
     * @request GET:/market-items/recently-viewed
     * @secure
     * @response `200` `DomainListRecentlyViewedMarketItemsResponse` 최근 본 마켓아이템 응답값
     */
    recentlyViewedList: (query: RecentlyViewedListParams, params: RequestParams = {}) =>
      this.http.request<DomainListRecentlyViewedMarketItemsResponse, any>({
        path: `/market-items/recently-viewed`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 추천 정보 리스트 조회
     *
     * @tags Markets
     * @name RecommendationInfosList
     * @summary ListRecommInfos 추천 정보 리스트 조회
     * @request GET:/market-items/recommendation-infos
     * @secure
     * @response `200` `DomainListRecommInfosResponse` 중고 리스트 응답 값
     */
    recommendationInfosList: (params: RequestParams = {}) =>
      this.http.request<DomainListRecommInfosResponse, any>({
        path: `/market-items/recommendation-infos`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 연관 키워드 리스트 조회
     *
     * @tags Markets
     * @name RelatedKeywordsList
     * @summary ListRelatedKeywords
     * @request GET:/market-items/related-keywords
     * @secure
     * @response `200` `DomainListRelatedKeywordsResponse` 중고 리뷰 리스트 응답 값
     */
    relatedKeywordsList: (query: RelatedKeywordsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListRelatedKeywordsResponse, any>({
        path: `/market-items/related-keywords`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 실시간 리뷰 리스트
     *
     * @tags Markets
     * @name ReviewsRealtimeList
     * @summary ListMarketItemRealtimeReviews
     * @request GET:/market-items/reviews/realtime
     * @secure
     * @response `200` `DomainListMarketItemRealtimeReviewsResponse` 실시간 리뷰 리스트 응답값
     */
    reviewsRealtimeList: (query: ReviewsRealtimeListParams, params: RequestParams = {}) =>
      this.http.request<DomainListMarketItemRealtimeReviewsResponse, any>({
        path: `/market-items/reviews/realtime`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 리뷰 단건 조회, 작동확인
     *
     * @tags Markets
     * @name ReviewsDetail
     * @summary GetMarketItemReviewV2
     * @request GET:/market-items/reviews/{reviewID}
     * @secure
     * @response `200` `DomainGetMarketItemReviewResponse` 중고 리뷰 조회 반환 값
     */
    reviewsDetail: (reviewId: number, params: RequestParams = {}) =>
      this.http.request<DomainGetMarketItemReviewResponse, any>({
        path: `/market-items/reviews/${reviewId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 현재 유효한 포인트 정책
     *
     * @tags Markets
     * @name RewardPointPolicyList
     * @summary 포인트 정책
     * @request GET:/market-items/reward-point-policy
     * @secure
     * @response `200` `DomainGetRewardPointPolicyResponse` 포인트 정책 값
     */
    rewardPointPolicyList: (query: RewardPointPolicyListParams, params: RequestParams = {}) =>
      this.http.request<DomainGetRewardPointPolicyResponse, any>({
        path: `/market-items/reward-point-policy`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 유사 이미지 상품 추천
     *
     * @tags Markets
     * @name SimilarImageItemsList
     * @summary ListSimilarImageMarketItems ✅
     * @request GET:/market-items/similar-image-items
     * @secure
     * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
     */
    similarImageItemsList: (query: SimilarImageItemsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListMarketItemsResponse, any>({
        path: `/market-items/similar-image-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Markets
     * @name WeeklyCountList
     * @summary CountWeeklyMarketItem
     * @request GET:/market-items/weekly-count
     * @secure
     * @response `200` `DomainCountWeeklyMarketItemResponse` 주간 마켓아이템 갯수
     */
    weeklyCountList: (params: RequestParams = {}) =>
      this.http.request<DomainCountWeeklyMarketItemResponse, any>({
        path: `/market-items/weekly-count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 단건 조회, 작동확인
     *
     * @tags Markets
     * @name MarketItemsDetail
     * @summary GetMarketItem
     * @request GET:/market-items/{marketItemID}
     * @secure
     * @response `200` `DomainGetMarketItemResponse` 중고 단건 응답값
     */
    marketItemsDetail: ({ marketItemId, ...query }: MarketItemsDetailParams3, params: RequestParams = {}) =>
      this.http.request<DomainGetMarketItemResponse, any>({
        path: `/market-items/${marketItemId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고(단건) 삭제
     *
     * @tags Markets
     * @name MarketItemsDelete
     * @summary DeleteMarketItem
     * @request DELETE:/market-items/{marketItemID}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `ErrorutilErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_DELETION_NOT_ALLOWED
     * @response `404` `ErrorutilErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
     */
    marketItemsDelete: (marketItemId: number, params: RequestParams = {}) =>
      this.http.request<void, ErrorutilErrorResponse>({
        path: `/market-items/${marketItemId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 중고(단건) 갱신
     *
     * @tags Markets
     * @name MarketItemsPartialUpdate
     * @summary PatchMarketItem
     * @request PATCH:/market-items/{marketItemID}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `ErrorutilErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_UPDATION_NOT_ALLOWED
     * @response `404` `ErrorutilErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
     */
    marketItemsPartialUpdate: (
      marketItemId: number,
      PatchMarketItemRequest: DomainPatchMarketItemRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, ErrorutilErrorResponse>({
        path: `/market-items/${marketItemId}`,
        method: 'PATCH',
        body: PatchMarketItemRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 중고 마켓아이템 판매중변경
     *
     * @tags Markets
     * @name AsProcessingPartialUpdate
     * @summary PatchMarketItemAsProcessing
     * @request PATCH:/market-items/{marketItemID}/as-processing
     * @secure
     * @response `204` `void` No Content
     * @response `400` `ErrorutilErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: TX_DUPLICATED<br />마켓 아이템이 판매중이 아닐때 Code: MARKET_ITEM_NOT_FOR_SALE
     * @response `404` `ErrorutilErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
     */
    asProcessingPartialUpdate: (marketItemId: number, params: RequestParams = {}) =>
      this.http.request<void, ErrorutilErrorResponse>({
        path: `/market-items/${marketItemId}/as-processing`,
        method: 'PATCH',
        secure: true,
        ...params,
      }),

    /**
     * @description 중고 마켓아이템 판매중으로 변경
     *
     * @tags Markets
     * @name AsSellingPartialUpdate
     * @summary PatchMarketItemAsSelling
     * @request PATCH:/market-items/{marketItemID}/as-selling
     * @secure
     * @response `204` `void` No Content
     * @response `400` `ErrorutilErrorResponse` 마켓 아이템 상태가 Processing가 아닐때 Code: MARKET_ITEM_NOT_PROCESSING
     * @response `404` `ErrorutilErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
     */
    asSellingPartialUpdate: (
      marketItemId: number,
      PatchMarketItemAsSellingRequest: DomainPatchMarketItemAsSellingRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, ErrorutilErrorResponse>({
        path: `/market-items/${marketItemId}/as-selling`,
        method: 'PATCH',
        body: PatchMarketItemAsSellingRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 중고 북마크 생성
     *
     * @tags Markets
     * @name BookmarksCreate
     * @summary CreateMarketItemBookmark
     * @request POST:/market-items/{marketItemID}/bookmarks
     * @secure
     * @response `204` `void` No Content
     */
    bookmarksCreate: (marketItemId: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/market-items/${marketItemId}/bookmarks`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 중고 북마크 삭제
     *
     * @tags Markets
     * @name BookmarksDelete2
     * @summary DeleteMarketItemBookmark
     * @request DELETE:/market-items/{marketItemID}/bookmarks
     * @originalName bookmarksDelete
     * @duplicate
     * @secure
     * @response `204` `void` No Content
     */
    bookmarksDelete2: (marketItemId: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/market-items/${marketItemId}/bookmarks`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 중고 채팅방 생성, mSwagger 문서작성 (2023-01-19)
     *
     * @tags Markets
     * @name ChatroomsCreate
     * @summary CreateMarketItemChatroom
     * @request POST:/market-items/{marketItemID}/chatrooms
     * @secure
     * @response `200` `DomainCreateMarketItemChatroomResponse` 중고 채팅방 생성 응답 값
     */
    chatroomsCreate: (
      marketItemId: number,
      CreateMarketItemChatroomRequest: DomainCreateMarketItemChatroomRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainCreateMarketItemChatroomResponse, any>({
        path: `/market-items/${marketItemId}/chatrooms`,
        method: 'POST',
        body: CreateMarketItemChatroomRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Markets
     * @name EditableList
     * @summary GetMarketItemEditable
     * @request GET:/market-items/{marketItemID}/editable
     * @secure
     * @response `200` `DomainGetMarketItemEditableResponse` 삭제 수정 가능 여부 응답값
     */
    editableList: ({ marketItemId, ...query }: EditableListParams, params: RequestParams = {}) =>
      this.http.request<DomainGetMarketItemEditableResponse, any>({
        path: `/market-items/${marketItemId}/editable`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 리뷰 생성
     *
     * @tags Markets
     * @name ReviewsCreate
     * @summary CreateMarketItemReview
     * @request POST:/market-items/{marketItemID}/reviews
     * @secure
     * @response `200` `DomainCreateMarketItemReviewResponse` 중고 리뷰 생성 응답값
     */
    reviewsCreate: (
      marketItemId: number,
      CreateMarketItemReviewRequest: DomainCreateMarketItemReviewRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainCreateMarketItemReviewResponse, any>({
        path: `/market-items/${marketItemId}/reviews`,
        method: 'POST',
        body: CreateMarketItemReviewRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 리뷰 단건 조회, 작동확인
     *
     * @tags Markets
     * @name ReviewsDetail2
     * @summary GetMarketItemReview
     * @request GET:/market-items/{marketItemID}/reviews/{reviewID}
     * @originalName reviewsDetail
     * @duplicate
     * @secure
     * @response `200` `DomainGetMarketItemReviewResponse` 중고 리뷰 조회 반환 값
     */
    reviewsDetail2: (marketItemId: number, reviewId: number, params: RequestParams = {}) =>
      this.http.request<DomainGetMarketItemReviewResponse, any>({
        path: `/market-items/${marketItemId}/reviews/${reviewId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 리뷰 수정
     *
     * @tags Markets
     * @name ReviewsUpdate
     * @summary UpdateMarketItemReview ✅
     * @request PUT:/market-items/{marketItemID}/reviews/{reviewID}
     * @secure
     * @response `204` `void` 중고 리뷰 수정 성공
     */
    reviewsUpdate: (
      marketItemId: number,
      reviewId: string,
      UpdateMarketItemReviewRequest: DomainUpdateMarketItemReviewRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/market-items/${marketItemId}/reviews/${reviewId}`,
        method: 'PUT',
        body: UpdateMarketItemReviewRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 비슷한 상품 추천
     *
     * @tags Markets
     * @name SellersOtherItemsList
     * @summary ListSellersOtherMarketItems
     * @request GET:/market-items/{marketItemID}/sellers-other-items
     * @secure
     * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
     */
    sellersOtherItemsList: ({ marketItemId, ...query }: SellersOtherItemsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListMarketItemsResponse, any>({
        path: `/market-items/${marketItemId}/sellers-other-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 비슷한 상품 추천
     *
     * @tags Markets
     * @name SimilarBrandItemsList
     * @summary ListSimilarBrandMarketItems
     * @request GET:/market-items/{marketItemID}/similar-brand-items
     * @secure
     * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
     */
    similarBrandItemsList: ({ marketItemId, ...query }: SimilarBrandItemsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListMarketItemsResponse, any>({
        path: `/market-items/${marketItemId}/similar-brand-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 소재 상품 모음전
     *
     * @tags Markets
     * @name SimilarFabricItemsList
     * @summary ListSimilarFabricMarketItems
     * @request GET:/market-items/{marketItemID}/similar-fabric-items
     * @secure
     * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
     */
    similarFabricItemsList: ({ marketItemId, ...query }: SimilarFabricItemsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListMarketItemsResponse, any>({
        path: `/market-items/${marketItemId}/similar-fabric-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 유사 이미지 상품 추천
     *
     * @tags Markets
     * @name SimilarImageItemsList2
     * @summary ListSimilarImageMarketItems ✅
     * @request GET:/market-items/{marketItemID}/similar-image-items
     * @originalName similarImageItemsList
     * @duplicate
     * @secure
     * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
     */
    similarImageItemsList2: ({ marketItemId, ...query }: SimilarImageItemsList2Params, params: RequestParams = {}) =>
      this.http.request<DomainListMarketItemsResponse, any>({
        path: `/market-items/${marketItemId}/similar-image-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 비슷한 상품 추천
     *
     * @tags Markets
     * @name SimilarItemsList
     * @summary ListSimilarMarketItems
     * @request GET:/market-items/{marketItemID}/similar-items
     * @secure
     * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
     */
    similarItemsList: ({ marketItemId, ...query }: SimilarItemsListParams, params: RequestParams = {}) =>
      this.http.request<DomainListMarketItemsResponse, any>({
        path: `/market-items/${marketItemId}/similar-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name TransactionsList
     * @summary GetOrderRecently
     * @request GET:/market-items/{marketItemID}/transactions
     * @secure
     * @response `200` `DomainGetOrderResponse` 거래 상세 조회 응답값
     * @response `404` `ErrorutilErrorResponse` 거래가 존재하지 않을 경우 Code: TX_NOT_FOUND
     */
    transactionsList: ({ marketItemId, ...query }: TransactionsListParams2, params: RequestParams = {}) =>
      this.http.request<DomainGetOrderResponse, ErrorutilErrorResponse>({
        path: `/market-items/${marketItemId}/transactions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 아이템 조회수 증가
     *
     * @tags Markets
     * @name ViewCreate
     * @summary CreateMarketItemView
     * @request POST:/market-items/{marketItemID}/view
     * @secure
     * @response `204` `void` No Content
     */
    viewCreate: (marketItemId: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/market-items/${marketItemId}/view`,
        method: 'POST',
        secure: true,
        ...params,
      }),
  };
  sendbird = {
    /**
     * @description Swagger 문서작성 (2022-01-11) ### 특정 유저의 샌드버드 토큰을 조회합니다. : https://github.com/looko-corp/acloset-api/issues/511 --- ### Authorization 헤더에 서비스 토큰을 넣어주시면 샌드버드 토큰을 반환합니다. ### 만약 샌드버드 계정이 없는 경우에 토큰을 요청하면 아래와 같은 에러가 발생합니다. - ### `[404] {SENDBIRD_TOKEN_NOT_FOUND - 토큰을 찾을 수 없습니다.}`
     *
     * @tags Sendbird
     * @name TokenList
     * @summary GetSendbirdToken
     * @request GET:/sendbird/token
     * @secure
     * @response `200` `DomainGetSendbirdTokenResponse` 토큰 요청 응답 값
     */
    tokenList: (params: RequestParams = {}) =>
      this.http.request<DomainGetSendbirdTokenResponse, any>({
        path: `/sendbird/token`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description ### 특정 유저의 샌드버드 토큰을 만듭니다 : https://github.com/looko-corp/acloset-api/issues/522 --- ### Authorization 헤더에 서비스 토큰을 요청하면 만들어 집니다. ### 만약 샌드버드 계정이 이미 있는 경우에는 아래와 같은 에러가 발생합니다. - ### `[409] {SENDBIRD_TOKEN_ALREADY_EXISTS - 이미 토큰이 존재합니다}` Swagger 문서작성 (2022-01-11)
     *
     * @tags Sendbird
     * @name TokenCreate
     * @summary CreateSendbirdToken
     * @request POST:/sendbird/token
     * @secure
     * @response `204` `void` No Content
     */
    tokenCreate: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/sendbird/token`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Swagger 문서작성 (2022-01-11) ### 특정유저의 샌드버드 채팅에서 안읽은 메세지수 조회 : https://github.com/looko-corp/acloset-api/issues/528 --- ### Authorization 헤더에 서비스 토큰을 요청하면 만들어 집니다. ### 만약 샌드버드 계정이 없는 경우에 토큰을 요청하면 아래와 같은 에러가 발생합니다. - ### `[404] {SENDBIRD_TOKEN_NOT_FOUND - 토큰을 찾을 수 없습니다.}`
     *
     * @tags Sendbird
     * @name UnreadMessageCountList
     * @summary CountSendbirdUnreadMessage
     * @request GET:/sendbird/unread-message-count
     * @secure
     * @response `200` `DomainCountSendbirdUnreadMessageResponse` 안읽은 메세지 개수 응답 값
     */
    unreadMessageCountList: (params: RequestParams = {}) =>
      this.http.request<DomainCountSendbirdUnreadMessageResponse, any>({
        path: `/sendbird/unread-message-count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  userProfile = {
    /**
     * @description https://github.com/looko-corp/acloset-api/issues/205 - 개발 완료
     *
     * @tags Users
     * @name UserProfileList
     * @summary GetUserProfile (4.7.0)
     * @request GET:/user-profile
     * @secure
     * @response `200` `DomainGetUserProfileResponse` 유저 프로필 응답값
     */
    userProfileList: (query: UserProfileListParams, params: RequestParams = {}) =>
      this.http.request<DomainGetUserProfileResponse, any>({
        path: `/user-profile`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
